/* This file was generated by `yarn gen-graphql-customer`. Don't edit it directly */

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A string that must be alphanumeric */
  AlphaNumericString: { input: string; output: string };
  /** ISO 8601 Date e.g. `1969-07-21` */
  Date: { input: string; output: string };
  /** ISO 8601 DateTime e.g. `1969-07-16T13:32:00.000Z`. You can also provide a date e.g. `1969-01-01` and it will be converted to `1969-01-01T00:00:00.000Z` */
  DateTime: { input: string; output: string };
  /** The first moment of a specific year, month or day or hour e.g. 1969 or 1969-1 or 1969-1-1 or 1969-1-1T00. All of the previous examples are equivalent to `1969-1-1T00:00:00.000`. */
  FirstMoment: { input: string; output: string };
  /** A string representing integers up to 9,223,372,036,854,775,807 (i.e. 2^63-1) */
  Int64: { input: string; output: string };
  /** A string representing integers as big as 2^120-1. The number is signed so the range is from -1,329,227,995,784,915,872,903,807,060,280,344,575 to 1,329,227,995,784,915,872,903,807,060,280,344,575. */
  Int96: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: string; output: string };
  /** The last moment of a specific year, month or day or hour e.g. 1969 or 1969-12 or 1969-12-31 or 1969-12-31T23. All of the previous examples are equivalent to `1969-12-31T23:59:59.999`. */
  LastMoment: { input: string; output: string };
  /** A string of non-zero length that can contain parameterized values via handlebars syntax. ex: `"Hello from {{country}}"`. */
  ParameterizedString: { input: string; output: string };
  /** A mapping of parameter keys to values. */
  Parameters: { input: string; output: string };
  /** A specific year ("2021"), quarter ("2021-Q1"), month ("2021-02"), day ("2021-02-03") or hour ("2021-02-03T04") */
  Period: { input: string; output: string };
  /** A specific year ("2026") or month ("2026-05") used to match dates that fall within it. */
  PeriodFilter: { input: string; output: string };
  /** A string with delimiter characters `/`, `#`, and `:` disallowed, as well as parameters in {{handlebar}} syntax. */
  SafeString: { input: string; output: string };
  /** All hour-aligned offsets from -11:00 to +12:00 are supported, e.g. "-08:00" (PT), "-05:00" (ET), "+00:00" (UTC) */
  UTCOffset: { input: string; output: string };
};

/** Error returned when one or more Ledger Entries in the batch could not be added. */
export type AddLedgerEntriesError = Error & {
  __typename?: 'AddLedgerEntriesError';
  /** The status code of error. For example, 'ledger_entry_batch_operation_failed'. */
  code: Scalars['String']['output'];
  /** The list of errors for each Ledger Entry that was responsible for the batch's failure. */
  errors: Array<AddLedgerEntryError>;
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

export type AddLedgerEntriesResponse = AddLedgerEntriesError | AddLedgerEntriesResult | BadRequestError | InternalError;

export type AddLedgerEntriesResult = {
  __typename?: 'AddLedgerEntriesResult';
  /** The added Ledger Entries, in the same order as the input */
  results: Array<AddLedgerEntryResult>;
};

/** Error details for a single Ledger Entry that was responsible for the batch's failure. */
export type AddLedgerEntryError = Error & {
  __typename?: 'AddLedgerEntryError';
  /** The status code of error. For example, 'ledger_entry_too_many_lines'. */
  code: Scalars['String']['output'];
  /** The [Idempotency Key](https://fragment.dev/api-reference/api-overview#idempotency) of the Ledger Entry */
  ik: Scalars['SafeString']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

export type AddLedgerEntryInput = {
  /** The [Ledger Entry](https://fragment.dev/api-reference/api-types#input-types-ledgerentryinput) to add */
  entry: LedgerEntryInput;
  /** The [Idempotency Key](https://fragment.dev/api-reference/api-overview#idempotency) for this Ledger Entry */
  ik: Scalars['SafeString']['input'];
};

export type AddLedgerEntryResponse = AddLedgerEntryResult | BadRequestError | InternalError;

export type AddLedgerEntryResult = {
  __typename?: 'AddLedgerEntryResult';
  /** The ledger entry that was posted */
  entry: LedgerEntry;
  /** True if this request successfully completed before and the previous response is being returned */
  isIkReplay: Scalars['Boolean']['output'];
  /** The ledger lines that were created in that entry */
  lines: Array<LedgerLine>;
};

/** Filters for pending clearing accounts. */
export type AgingClearingAccountsFilterSet = {
  /** Account path filter, with the same wildcard rules as LedgerAccountsFilterSet.path. */
  path?: InputMaybe<StringMatchFilter>;
};

/** Selection of pending clearing accounts to count. */
export type AgingClearingAccountsInput = {
  /** Additional account filters. */
  filter?: InputMaybe<AgingClearingAccountsFilterSet>;
};

/** Inclusive posted-time bounds usable directly in existing list filters. */
export type AgingInterval = {
  __typename?: 'AgingInterval';
  /** Unique pending accounts matching ledgerAccounts with this interval's earliestPosted filter. Different pending currencies can place an account in multiple intervals. Null when not requested. */
  clearingAccountCount?: Maybe<Scalars['Int']['output']>;
  /** Inclusive upper bound for earliestPosted.before or posted.before. */
  endTime: Scalars['DateTime']['output'];
  /** Inclusive lower bound for earliestPosted.after or posted.after; null for the oldest interval. */
  startTime?: Maybe<Scalars['DateTime']['output']>;
  /** Transactions matching unreconciledTxs with this interval's posted filter and the requested Links and filters. Null when not requested. */
  unreconciledTxCount?: Maybe<Scalars['Int']['output']>;
};

/** Selection of unreconciled transactions to count. */
export type AgingUnreconciledTxsInput = {
  /** Additional posted-time bounds intersected with each interval. */
  filter?: InputMaybe<LedgerUnreconciledTxsFilterSet>;
  /** Links identified by Fragment ID or Custom Link creation IK. Provide between 1 and 100 selectors; duplicates are searched once. */
  links: Array<LinkMatchInput>;
};

/** Equivalent to an HTTP 400 - request either has missing or incorrect data */
export type BadRequestError = Error & {
  __typename?: 'BadRequestError';
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

/** A single amount and the timestamp requested */
export type BalanceChangeDuring = {
  __typename?: 'BalanceChangeDuring';
  /** The balance or balance change */
  amount: CurrencyAmount;
  /** The period of the requested balance change */
  period: Scalars['Period']['output'];
};

/** A paginated list of amounts and their periods */
export type BalanceChangeDuringConnection = {
  __typename?: 'BalanceChangeDuringConnection';
  /** The end time of the period across which the balance changes are requested */
  endTime: Scalars['LastMoment']['output'];
  /** The granularity of the return data */
  granularity: Granularity;
  /** The current page of results */
  nodes: Array<BalanceChangeDuring>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
  /** The start time of the period across which the balance changes are requested */
  startTime: Scalars['FirstMoment']['output'];
};

/** Used to configure the write-consistency of a Ledger Account's balance. See [Configure consistency](https://fragment.dev/guides/configure-consistency). */
export enum BalanceUpdateConsistencyMode {
  Eventual = 'eventual',
  Strong = 'strong',
}

/** A saved card. */
export type CardPaymentMethod = PaymentMethod & {
  __typename?: 'CardPaymentMethod';
  /** The card network, for example `visa` or `mastercard`. */
  brand: Scalars['String']['output'];
  /** When the payment method was saved. */
  created: Scalars['DateTime']['output'];
  /** The card's expiry month, 1–12. */
  expiryMonth: Scalars['Int']['output'];
  /** The card's four-digit expiry year. */
  expiryYear: Scalars['Int']['output'];
  /** FRAGMENT ID of the saved Payment Method. */
  id: Scalars['ID']['output'];
  /** The last four digits of the card number. */
  last4: Scalars['String']['output'];
  /** The user who owns this payment method. */
  user: User;
};

/** The input for your Chart of Accounts in a Schema. */
export type ChartOfAccountsInput = {
  /** The Ledger Accounts modeled by your Schema. Ledger Accounts may be nested up to a maximum depth of 10. */
  accounts: Array<SchemaLedgerAccountInput>;
  /**
   * The default consistency configuration for all Ledger Accounts in this Schema.
   * If a Ledger Account does not specify its own consistency configuration, it will use the default values provided here.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  defaultConsistencyConfig?: InputMaybe<LedgerAccountConsistencyConfigInput>;
  /**
   * The default currency of each Ledger Account in the Chart Of Accounts.
   * It must be provided if `defaultCurrencyMode` is set to `single`.
   * Additionally, `defaultCurrency` must be omitted if `defaultCurrencyMode` is set to `multi`.
   */
  defaultCurrency?: InputMaybe<CurrencyMatchInput>;
  /** The default currency mode of each Ledger Account in the Chart Of Accounts. */
  defaultCurrencyMode?: InputMaybe<CurrencyMode>;
};

export type CreateCustomCurrencyInput = {
  /** The currency code for custom currencies. It can be up to 36 characters long. This is used for display purposes. */
  customCode: Scalars['String']['input'];
  /** The ID for a custom currency. This is specified when creating the custom currency using the [createCustomCurrency](https://fragment.dev/api-reference/api-mutations#createcustomcurrency) mutation. It can be up to 36 characters long. */
  customCurrencyId: Scalars['SafeString']['input'];
  /** A human readable name for the currency (e.g. United States Dollar). This is used for display purposes. */
  name: Scalars['String']['input'];
  /** The number of decimal places this currency goes to. For example, United States Dollars have a precision of 2 (i.e. 100 cents in a dollar), whereas the Jordanian Dinar has a precision of 3. This is used for display purposes. */
  precision: Scalars['Int']['input'];
};

export type CreateCustomCurrencyResponse = BadRequestError | CreateCustomCurrencyResult | InternalError;

export type CreateCustomCurrencyResult = {
  __typename?: 'CreateCustomCurrencyResult';
  /** The Currency that was created. */
  customCurrency: Currency;
};

export type CreateCustomLinkResponse = BadRequestError | CreateCustomLinkResult | InternalError;

export type CreateCustomLinkResult = {
  __typename?: 'CreateCustomLinkResult';
  isIkReplay: Scalars['Boolean']['output'];
  /** The custom link that was created. Represents an instance of an external system. */
  link: CustomLink;
};

export type CreateLedgerAccountInput = {
  /** The consistency configuration for this Ledger Account. This defines how updates to this Ledger Account's balance are handled. */
  consistencyConfig?: InputMaybe<LedgerAccountConsistencyConfigInput>;
  /**
   * The currency of this Ledger Account. If this is not set, and `currencyMode` is
   * not set to `multi`, the workspace-level default is used.
   */
  currency?: InputMaybe<CurrencyMatchInput>;
  /** If set to `multi`, creates a multi-currency Ledger Account. If set to `single`, creates a single-currency Ledger Account. */
  currencyMode?: InputMaybe<CurrencyMode>;
  /** The External Account to link to this Ledger Account. */
  linkedAccount?: InputMaybe<ExternalAccountMatchInput>;
  /** The human-readable name of this Ledger Account. */
  name: Scalars['String']['input'];
  /** The parent of this Ledger Account. */
  parent?: InputMaybe<LedgerAccountMatchInput>;
  /** The type of ledger account to create. Required if this is a top-level Ledger Account. If not provided, the type will be inferred from the parent. */
  type?: InputMaybe<LedgerAccountTypes>;
};

export type CreateLedgerAccountResponse = BadRequestError | CreateLedgerAccountResult | InternalError;

export type CreateLedgerAccountResult = {
  __typename?: 'CreateLedgerAccountResult';
  /** true if a previous request successfully created this ledger account */
  isIkReplay: Scalars['Boolean']['output'];
  /** The ledger account that was created */
  ledgerAccount: LedgerAccount;
};

export type CreateLedgerAccountsInput = {
  /** Ledger Accounts to create as children of this Ledger Account. */
  childLedgerAccounts?: InputMaybe<Array<CreateLedgerAccountsInput>>;
  /** The consistency configuration for this ledger account. See [Configure consistency](https://fragment.dev/guides/configure-consistency). */
  consistencyConfig?: InputMaybe<LedgerAccountConsistencyConfigInput>;
  /** The currency of this Ledger Account. If this is not set, the workspace level default is used. */
  currency?: InputMaybe<CurrencyMatchInput>;
  /** The currency mode of this Ledger Account. If this is not set, the workspace level default is used. */
  currencyMode?: InputMaybe<CurrencyMode>;
  /** The idempotency key for creating this Ledger Account. */
  ik: Scalars['SafeString']['input'];
  /** The External Account to link to this Ledger Account. This can only be specified on leaf Ledger Accounts. See [Reconcile payments](https://fragment.dev/guides/reconcile-payments). */
  linkedAccount?: InputMaybe<ExternalAccountMatchInput>;
  /** The name of the Ledger Account. */
  name: Scalars['String']['input'];
  /** The parent of this Ledger Account. This is only valid on the top level Ledger Account in the payload. */
  parent?: InputMaybe<LedgerAccountMatchInput>;
  /** The type of this Ledger Account. This field is only required if this is a root Ledger Account. Otherwise, the type will get inherited from its parent. */
  type?: InputMaybe<LedgerAccountTypes>;
};

export type CreateLedgerAccountsResponse = BadRequestError | CreateLedgerAccountsResult | InternalError;

export type CreateLedgerAccountsResult = {
  __typename?: 'CreateLedgerAccountsResult';
  /** Whether the ledger accounts were successfully created by a previous request */
  ikReplays: Array<IkReplay>;
  /** The ledger accounts that were created */
  ledgerAccounts: Array<LedgerAccount>;
};

export type CreateLedgerInput = {
  /**
   * Use this field to specify a timezone for queries to your Ledger.
   *
   * When aggregating balances, all transactions within a 24 hour period starting at midnight UTC are included in each day.
   * You can specify a different starting hour for balances. For example, use "-08:00" to align balances with Pacific Standard Time.
   * Balance queries would then consider the start of each local day to be at 8am UTC the next day in UTC.
   * The default timezone is UTC.
   */
  balanceUTCOffset?: InputMaybe<Scalars['UTCOffset']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<LedgerTypes>;
};

export type CreateLedgerResponse = BadRequestError | CreateLedgerResult | InternalError;

export type CreateLedgerResult = {
  __typename?: 'CreateLedgerResult';
  /** true if this request successfully completed before and the previous response is being returned */
  isIkReplay: Scalars['Boolean']['output'];
  /** The Ledger that was created */
  ledger: Ledger;
};

/** The Payment to create. */
export type CreatePaymentInput = {
  /** Parameters for the specific Payment Type. Must be a key-value pair of strings. Must be a flat object: nested objects and arrays are rejected. */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** The saved Payment Method to charge for this Payment. When set, the Payment is charged immediately. */
  paymentMethod?: InputMaybe<PaymentMethodMatchInput>;
  /** The type of the Payment. Must be defined in the Schema linked to the Ledger. */
  type: Scalars['SafeString']['input'];
  /** The version of the Payment Type. */
  typeVersion: Scalars['Int']['input'];
};

export type CreatePaymentMethodSetupResponse = BadRequestError | CreatePaymentMethodSetupResult | InternalError;

/** The created Payment Method Setup. */
export type CreatePaymentMethodSetupResult = {
  __typename?: 'CreatePaymentMethodSetupResult';
  /** Whether an earlier call with the same `ik` created this Payment Method Setup. */
  isIkReplay: Scalars['Boolean']['output'];
  /** The Payment Method Setup that was created. */
  paymentMethodSetup: PaymentMethodSetup;
};

export type CreatePaymentResponse = BadRequestError | CreatePaymentResult | InternalError;

/** The created Payment. */
export type CreatePaymentResult = {
  __typename?: 'CreatePaymentResult';
  /** Whether an earlier call with the same `ik` created this Payment. */
  isIkReplay: Scalars['Boolean']['output'];
  /** The Payment that was created. */
  payment: Payment;
};

export type Currency = {
  __typename?: 'Currency';
  /** The currency code. This is an [enum type](https://fragment.dev/api-reference/api-types#scalars-and-enums-currencycode) . */
  code: CurrencyCode;
  /** The currency code for custom currencies. This is only set if 'currency' is set to CUSTOM. It can be up to 36 characters long. */
  customCode?: Maybe<Scalars['String']['output']>;
  /** The ID for a custom currency. This is specified when creating the custom currency using the [createCustomCurrency](https://fragment.dev/api-reference/api-mutations#createcustomcurrency) mutation. */
  customCurrencyId?: Maybe<Scalars['SafeString']['output']>;
  /** A human readable name for the currency (e.g. United States Dollar). This is used for display purposes. */
  name: Scalars['String']['output'];
  /** The number of decimal places this currency goes to. For example, United States Dollars have a precision of 2 (i.e. 100 cents in a dollar), whereas the Jordanian Dinar has a precision of 3. This is used for display purposes. */
  precision: Scalars['Int']['output'];
};

/** A single amount accompanied by its currency */
export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  /** Numerical integer value, serialized as a string */
  amount: Scalars['Int96']['output'];
  /** The currency this amount is in */
  currency: Currency;
};

/** A paginated list of amounts with their currencies */
export type CurrencyAmountConnection = {
  __typename?: 'CurrencyAmountConnection';
  /** The current page of results */
  nodes: Array<CurrencyAmount>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export enum CurrencyCode {
  Aave = 'AAVE',
  Ada = 'ADA',
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bch = 'BCH',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btc = 'BTC',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cadc = 'CADC',
  Cadt = 'CADT',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Custom = 'CUSTOM',
  Cve = 'CVE',
  Czk = 'CZK',
  Dai = 'DAI',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eth = 'ETH',
  Eur = 'EUR',
  Eurc = 'EURC',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ggp = 'GGP',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Imp = 'IMP',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Link = 'LINK',
  Lkr = 'LKR',
  Logical = 'LOGICAL',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltc = 'LTC',
  Lyd = 'LYD',
  Mad = 'MAD',
  Matic = 'MATIC',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pts = 'PTS',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sle = 'SLE',
  Sll = 'SLL',
  Sol = 'SOL',
  Sos = 'SOS',
  Spl = 'SPL',
  Srd = 'SRD',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Tvd = 'TVD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Uni = 'UNI',
  Usd = 'USD',
  Usdc = 'USDC',
  Usdg = 'USDG',
  Usdt = 'USDT',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xlm = 'XLM',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
}

export type CurrencyFilter = {
  /** Must match the value provided */
  equalTo?: InputMaybe<CurrencyMatchInput>;
  /** Must match one of the values provided. Limited to 100 items maximum. */
  in?: InputMaybe<Array<CurrencyMatchInput>>;
};

export type CurrencyMatchInput = {
  /** The currency code. This is an [enum type](https://fragment.dev/api-reference/api-types#scalars-and-enums-currencycode). */
  code: CurrencyCode;
  /** The ID for a custom currency. This is specified when creating the custom currency using the [createCustomCurrency](https://fragment.dev/api-reference/api-mutations#createcustomcurrency) mutation. */
  customCurrencyId?: InputMaybe<Scalars['SafeString']['input']>;
};

/** Defines the currency handling of a LedgerAccount, which can either be restricted to a single currency or allow multiple currencies. */
export enum CurrencyMode {
  Multi = 'multi',
  Single = 'single',
}

export type CustomAccountInput = {
  /** The currency of this external account. If this is not set, the workspace level default is used. 'currency' cannot be set if 'currencyMode' is 'multi'. */
  currency?: InputMaybe<CurrencyMatchInput>;
  /** The currency mode of this external account. If set to multi, creates a multi-currency account. */
  currencyMode?: InputMaybe<CurrencyMode>;
  /** The ID of this account at the external system. This is used as the idempotency key, within the scope of its Custom Link. */
  externalId: Scalars['SafeString']['input'];
  /** The name of the account at the external system. */
  name: Scalars['String']['input'];
};

/** A paginated list of Custom Currencies */
export type CustomCurrenciesConnection = {
  __typename?: 'CustomCurrenciesConnection';
  /** The current page of results */
  nodes: Array<Currency>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export type CustomLink = Link & {
  __typename?: 'CustomLink';
  /** ISO-8601 timestamp when the Link was created. */
  created: Scalars['String']['output'];
  /** URL to the Fragment Dashboard for this Link. */
  dashboardUrl: Scalars['String']['output'];
  /** A list of External Accounts associated with this Link. */
  externalAccounts: ExternalAccountsConnection;
  /** FRAGMENT ID of the Custom Link. */
  id: Scalars['ID']['output'];
  /** Name of the Link as it appears in the Fragment Dashboard. */
  name: Scalars['String']['output'];
};

export type CustomTxInput = {
  account: ExternalAccountMatchInput;
  amount: Scalars['Int96']['input'];
  /** The currency of this tx. Should be set for multi-currency accounts. */
  currency?: InputMaybe<CurrencyMatchInput>;
  description: Scalars['String']['input'];
  /** The ID of this tx at the external system. This is used as the idempotency key, within the scope of its Custom Account. */
  externalId: Scalars['SafeString']['input'];
  posted: Scalars['DateTime']['input'];
};

export type DateFilter = {
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Must match one of the values provided. Limited to 100 items maximum. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Must fall within the given period. Supports a year (e.g. "2026") or a month (e.g. "2026-05"). To match a specific day, use `equalTo`. Cannot be combined with `withinBalanceUTCOffset`. */
  within?: InputMaybe<Scalars['PeriodFilter']['input']>;
  /** Must fall within the given period, taking into account the Ledger's `balanceUTCOffset`. Supports a year (e.g. "2026") or a month (e.g. "2026-05"). Cannot be combined with `within`. */
  withinBalanceUTCOffset?: InputMaybe<Scalars['PeriodFilter']['input']>;
};

/** Filters a timestamp field between two moments in time */
export type DateTimeFilter = {
  /** The timestamp value must be after this moment. Specified in ISO 8601 format e.g "1968-01-01T16:45:00Z" */
  after?: InputMaybe<Scalars['DateTime']['input']>;
  /** The timestamp value must be before this moment. Specified in ISO 8601 format e.g "1968-01-01T16:45:00Z" */
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteCustomTxsResponse = BadRequestError | DeleteCustomTxsResult | InternalError;

export type DeleteCustomTxsResult = {
  __typename?: 'DeleteCustomTxsResult';
  /** List of Txs deleted in this operation */
  txs: Array<DeletedCustomTx>;
};

export type DeleteLedgerResponse = BadRequestError | DeleteLedgerResult | InternalError;

export type DeleteLedgerResult = {
  __typename?: 'DeleteLedgerResult';
  success: Scalars['Boolean']['output'];
};

export type DeletePaymentMethodResponse = BadRequestError | DeletePaymentMethodResult | InternalError;

/** The result of deleting a Payment Method. */
export type DeletePaymentMethodResult = {
  __typename?: 'DeletePaymentMethodResult';
  /** Whether the Payment Method was deleted. */
  success: Scalars['Boolean']['output'];
};

export type DeleteSchemaResponse = BadRequestError | DeleteSchemaResult | InternalError;

export type DeleteSchemaResult = {
  __typename?: 'DeleteSchemaResult';
  success: Scalars['Boolean']['output'];
};

export type DeletedCustomTx = {
  __typename?: 'DeletedCustomTx';
  /** A deleted Tx */
  tx: Tx;
};

export type EmailFilter = {
  equalTo: Scalars['String']['input'];
};

export type EntryGroupMatchInput = {
  key: Scalars['SafeString']['input'];
  value: Scalars['SafeString']['input'];
};

/** Base error interface */
export type Error = {
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

export type ExternalAccount = {
  __typename?: 'ExternalAccount';
  /** The currency of this external account. */
  currency?: Maybe<Currency>;
  /** Indicates if the account allows multiple currencies or is restricted to a single currency */
  currencyMode: CurrencyMode;
  /** ID used for the external account */
  externalId: Scalars['ID']['output'];
  /** FRAGMENT ID of External Account */
  id: Scalars['ID']['output'];
  /** Ledger Accounts linked to this External Account. Ledger Accounts are paginated and sorted in reverse-chronological order by created date. */
  ledgerAccounts: LedgerAccountsConnection;
  /** The Link that this External Account belongs to. */
  link: CustomLink | IncreaseLink | StripeLink | UnitLink;
  /** FRAGMENT ID of this transaction's external link */
  linkId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** All Txs in this External Account. */
  txs: TxsConnection;
};

export type ExternalAccountLedgerAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalAccountTxsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalAccountFilter = {
  /** Ledger Account must linked to the the specified external account */
  equalTo?: InputMaybe<ExternalAccountMatchInput>;
  /** Ledger Account can be linked to any of the specified external accounts. Limited to 100 items maximum. */
  in?: InputMaybe<Array<ExternalAccountMatchInput>>;
};

/** Specify an External Account by using `id`, or `linkId` and `externalId`. */
export type ExternalAccountMatchInput = {
  /** The external system's ID of the External Account. If this is specified, `linkId` is required. `id` is optional, but will be validated if provided. */
  externalId?: InputMaybe<Scalars['ID']['input']>;
  /** The FRAGMENT ID of the External Account. If this is specified, both `linkId` and `externalId` are optional, but will be validated if provided. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The FRAGMENT ID of the Link the External Account is in. If this is specified, `externalId` is required. `id` is optional, but will be validated if provided. */
  linkId?: InputMaybe<Scalars['ID']['input']>;
};

/** A paginated list of External Accounts */
export type ExternalAccountsConnection = {
  __typename?: 'ExternalAccountsConnection';
  /** The current page of results */
  nodes: Array<ExternalAccount>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export enum ExternalTransferType {
  Ach = 'ach',
  Card = 'card',
  Check = 'check',
  Internal = 'internal',
  Wire = 'wire',
}

export enum ExternalTxSource {
  Increase = 'increase',
}

export enum Granularity {
  Daily = 'daily',
  Hourly = 'hourly',
  Monthly = 'monthly',
}

/** A filter to query balances of a specific subset of accounts */
export type GroupBalanceAccountFilter = {
  /** A filter that must match the account ID */
  id?: InputMaybe<StringFilter>;
  /** A filter that must match the account path. Wildcards ('*') may be used only for template variables, and will only match a single variable each. */
  path?: InputMaybe<StringMatchFilter>;
};

/** Filter for finding entries by group membership */
export type GroupFilter = {
  /** Find entries that have ALL of the specified groups. Limited to 10 items maximum. */
  all?: InputMaybe<Array<GroupMatchInput>>;
  /** Find groups that exactly match this group */
  equalTo?: InputMaybe<GroupMatchInput>;
  /** Find groups that match any of these groups */
  in?: InputMaybe<Array<GroupMatchInput>>;
  /** Find groups with a specific key */
  keyEqualTo?: InputMaybe<Scalars['SafeString']['input']>;
  /** Find groups with any of these keys */
  keyIn?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /**
   * Find groups that do not match this predicate
   * @deprecated not filter is deprecated. Use notKeyIn or notKeyEqualTo instead.
   */
  not?: InputMaybe<GroupNotFilter>;
  /** Find groups that do not exactly match this group */
  notEqualTo?: InputMaybe<GroupMatchInput>;
  /** Find groups that do not match any of these groups */
  notIn?: InputMaybe<Array<GroupMatchInput>>;
  /** Find groups that do not have a specific key */
  notKeyEqualTo?: InputMaybe<Scalars['SafeString']['input']>;
  /** Find groups that do not have any of these keys */
  notKeyIn?: InputMaybe<Array<Scalars['SafeString']['input']>>;
};

/** A Group in a Schema. Group define sequences of Ledger Entries and can help with reconciliation tasks. */
export type GroupInput = {
  /** Human-readable description of the Group. */
  description?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The key of this Group. This combined with its value is a stable, unique identifier for this group. */
  key: Scalars['SafeString']['input'];
  /** The parameters that are used to enable reconciliation abilities in a group. */
  reconciliation?: InputMaybe<GroupReconciliationParametersInput>;
};

/** Input type for matching a specific group by key and value */
export type GroupMatchInput = {
  /** The key of the group to match */
  key: Scalars['SafeString']['input'];
  /** The value of the group to match */
  value: Scalars['SafeString']['input'];
};

/** DEPRECATED: Use GroupFilter and notKeyIn or notKeyEqualTo instead. Filter for finding entries that do not match this predicate */
export type GroupNotFilter = {
  /** DEPRECATED: Find entries that are not members of all of these groups. This is an AND filter. */
  keyIn?: InputMaybe<Array<Scalars['SafeString']['input']>>;
};

/** A set of parameters that are used to enable reconciliation abilities in a group */
export type GroupReconciliationParametersInput = {
  /** The path to the clearing account for this group. A clearing account is an account that is used to indicate funds that are in transit. Also called a suspense account, pending account, or zero balance account. */
  clearingAccountPath: SchemaLedgerAccountMatchInput;
};

/** A single amount and the timestamp requested */
export type HistoricalBalance = {
  __typename?: 'HistoricalBalance';
  /** The balance or balance change */
  amount: CurrencyAmount;
  /** The timestamp of the requested balance */
  at: Scalars['LastMoment']['output'];
};

/** A paginated list of amounts and their periods */
export type HistoricalBalanceConnection = {
  __typename?: 'HistoricalBalanceConnection';
  /** The end time of the period across which the balance changes are requested */
  endTime: Scalars['LastMoment']['output'];
  /** The granularity of the return data */
  granularity: Granularity;
  /** The current page of results */
  nodes: Array<HistoricalBalance>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
  /** The start time of the period across which the balance changes are requested */
  startTime: Scalars['FirstMoment']['output'];
};

export type IkReplay = {
  __typename?: 'IkReplay';
  ik: Scalars['SafeString']['output'];
  isIkReplay: Scalars['Boolean']['output'];
};

export enum IncreaseEnv {
  Production = 'production',
  Sandbox = 'sandbox',
}

export type IncreaseLink = Link & {
  __typename?: 'IncreaseLink';
  /** ISO-8601 timestamp when the Link was created. */
  created: Scalars['String']['output'];
  /** URL to the Fragment Dashboard for this Link. */
  dashboardUrl: Scalars['String']['output'];
  /** A list of External Accounts associated with this Link. */
  externalAccounts: ExternalAccountsConnection;
  /** FRAGMENT ID of the Increase Link. */
  id: Scalars['ID']['output'];
  /** The environment of the Increase Link, either sandbox or production. */
  increaseEnv: IncreaseEnv;
  /** Name of the Link as it appears in the Dashboard. */
  name: Scalars['String']['output'];
};

export type InstantiateLedgerAccountResponse = BadRequestError | InstantiateLedgerAccountResult | InternalError;

export type InstantiateLedgerAccountResult = {
  __typename?: 'InstantiateLedgerAccountResult';
  /** The instantiated Ledger Account. */
  ledgerAccount: LedgerAccount;
};

/** A condition that must be met on an `Int96` field. */
export type Int96Condition = {
  __typename?: 'Int96Condition';
  /** Amount must exactly match this value. You may not specify this alongside `gte` or `lte`. */
  eq?: Maybe<Scalars['Int96']['output']>;
  /** Amount must be greater than or equal to this value. */
  gte?: Maybe<Scalars['Int96']['output']>;
  /** Amount must be less than or equal to this value. */
  lte?: Maybe<Scalars['Int96']['output']>;
};

/** A condition that must be met on an `Int96` field. */
export type Int96ConditionInput = {
  /** Amount must exactly match this value. You may not specify this alongside `gte` or `lte`. */
  eq?: InputMaybe<Scalars['Int96']['input']>;
  /** Amount must be greater than or equal to this value. */
  gte?: InputMaybe<Scalars['Int96']['input']>;
  /** Amount must be less than or equal to this value. */
  lte?: InputMaybe<Scalars['Int96']['input']>;
};

export type Int96Filter = {
  /** Must exactly equal this Int96 value */
  eq?: InputMaybe<Scalars['Int96']['input']>;
  /** Must be greater than or equal to this Int96 value */
  gte?: InputMaybe<Scalars['Int96']['input']>;
  /** Must be less than or equal to this Int96 value */
  lte?: InputMaybe<Scalars['Int96']['input']>;
  /** Must not equal this Int96 value */
  ne?: InputMaybe<Scalars['Int96']['input']>;
};

/** Equivalent to an HTTP 5XX - something went wrong with our API. */
export type InternalError = Error & {
  __typename?: 'InternalError';
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

/** Ledgers are databases designed for managing money */
export type Ledger = {
  __typename?: 'Ledger';
  /** When aggregating balances, all transactions within a 24 hour period starting at midnight UTC plus this offset are included in each day. */
  balanceUTCOffset: Scalars['UTCOffset']['output'];
  created: Scalars['DateTime']['output'];
  /** URL to the Fragment Dashboard for this Ledger. */
  dashboardUrl: Scalars['String']['output'];
  /** Entry statistics for this Ledger. */
  entryStats: LedgerEntryStatsConnection;
  id: Scalars['ID']['output'];
  /** The IK passed into the [createLedger](/api-reference/api-mutations#createledger) mutation. This is treated as a unique identifier for this Ledger. */
  ik: Scalars['SafeString']['output'];
  /** Ledger Account data migrations affecting this Ledger. */
  ledgerAccountDataMigrations: LedgerAccountDataMigrationConnection;
  /** Query LedgerAccounts in Ledger. Ledger Accounts are paginated and returned in reverse-chronological order by their created date. */
  ledgerAccounts: LedgerAccountsConnection;
  /** Query Ledger Entries in a Ledger. Ledger Entries are paginated and sorted in reverse-chronological order by posted date. */
  ledgerEntries: LedgerEntriesConnection;
  /** Ledger Entry data migrations affecting this Ledger. */
  ledgerEntryDataMigrations: LedgerEntryDataMigrationConnection;
  /** Query a Ledger Entry Group for this Ledger given its key and value. */
  ledgerEntryGroup: LedgerEntryGroup;
  /** Query LedgerEntryGroups in Ledger. Ledger Entry Groups are paginated and returned in order lexigraphically key then inverse chronologically by created. */
  ledgerEntryGroups: LedgerEntryGroupsConnection;
  /**
   * List Ledger Lines across accounts in this Ledger, sorted by `posted` in reverse chronological order.
   * Specify a single Ledger Account via the `ledgerAccount` field, or query across multiple accounts using the `path` filter or `ledgerAccount.in`.
   */
  lines: LedgerLinesConnection;
  /** Schema migrations affecting this Ledger. */
  migrations: LedgerMigrationConnection;
  /** The name of the Ledger. Can be updated with the [updateLedger](/api-reference/api-mutations#updateledger) mutation. */
  name: Scalars['String']['output'];
  /** List the Payments on a Ledger, most recent first. */
  payments: PaymentsConnection;
  /** Counts of pending clearing accounts and unreconciled transactions, grouped by age measured from the time of the request. */
  reconciliationReport: ReconciliationReport;
  /** Schema key associated with this Ledger. */
  schema?: Maybe<Schema>;
  type: LedgerTypes;
  /** Transactions in the specified Links that have not been reconciled to any account in this Ledger. Includes external accounts not linked to this Ledger. Sorted by posted timestamp, newest first. */
  unreconciledTxs: TxsConnection;
  /** @deprecated Callers should not need to query or store this value. */
  workspaceId: Scalars['ID']['output'];
};

/** Ledgers are databases designed for managing money */
export type LedgerEntryStatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerLedgerAccountDataMigrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerAccountDataMigrationsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerLedgerAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerAccountsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerLedgerEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntriesFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerLedgerEntryDataMigrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntryDataMigrationsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerLedgerEntryGroupArgs = {
  ledgerEntryGroup: EntryGroupMatchInput;
};

/** Ledgers are databases designed for managing money */
export type LedgerLedgerEntryGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntryGroupsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: LedgerLinesFilterSet;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerMigrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PaymentsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ledgers are databases designed for managing money */
export type LedgerReconciliationReportArgs = {
  clearingAccounts?: InputMaybe<AgingClearingAccountsInput>;
  granularity: Granularity;
  intervals: Scalars['Int']['input'];
  unreconciledTxs?: InputMaybe<AgingUnreconciledTxsInput>;
};

/** Ledgers are databases designed for managing money */
export type LedgerUnreconciledTxsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerUnreconciledTxsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  links: Array<LinkMatchInput>;
};

/** A ledger account is a container for money */
export type LedgerAccount = {
  __typename?: 'LedgerAccount';
  /** Total of all lines in this ledger account and child ledger accounts of the same currency as this ledger account */
  balance: Scalars['Int96']['output'];
  /** How much did the this ledger account's balance change during the specified period. This query will include all child accounts in the same currency as this ledger account. */
  balanceChange: Scalars['Int96']['output'];
  /** How much did the this ledger account's balances change during the specified period. This query will include all child accounts of all currencies. */
  balanceChanges: CurrencyAmountConnection;
  /**
   * How much did the ledger account's balances change over a time period with a specified granularity.
   * For example, if the period is 1969-07 and the granularity is daily, the query will return the balance changes for each day in the month.
   */
  balanceChangesDuring: BalanceChangeDuringConnection;
  /** Total of all lines in this ledger account and child ledger accounts in all currencies */
  balances: CurrencyAmountConnection;
  /**
   * The ledger account's balances over a time period with a specified granularity.
   * For example, if the period is 1969-07 and the granularity is daily, the query will return the balance for each day in the month.
   */
  balancesDuring: HistoricalBalanceConnection;
  /** Total of all lines in child ledger accounts of the same currency as this ledger account */
  childBalance: Scalars['Int96']['output'];
  /** How much did the this ledger account's childBalance change during the specified period. This query will only include child accounts which are in the same currency as this one. See childBalanceChanges to include children of different currencies. */
  childBalanceChange: Scalars['Int96']['output'];
  /** How much did the this ledger account's child accounts' balances change during the specified period. This query will include all child accounts of all currencies. */
  childBalanceChanges: CurrencyAmountConnection;
  /**
   * How much did the ledger account's childBalances change over a time period with a specified granularity.
   * For example, if the period is 1969-07 and the granularity is daily, the query will return the balance changes for each day in the month.
   */
  childBalanceChangesDuring: BalanceChangeDuringConnection;
  /** Total of all lines in child ledger accounts of this ledger in all currencies */
  childBalances: CurrencyAmountConnection;
  /**
   * The ledger account's childBalances over a time period with a specified granularity.
   * For example, if the period is 1969-07 and the granularity is daily, the query will return the balance for each day in the month.
   */
  childBalancesDuring: HistoricalBalanceConnection;
  /** The child Ledger Accounts of this Ledger Accountw */
  childLedgerAccounts: LedgerAccountsConnection;
  /**
   * The clearing status of the Ledger Account.
   *
   * This field is null when the Ledger Account is not configured to be a Clearing account.
   */
  clearingStatus?: Maybe<LedgerAccountClearingStatus>;
  /** The consistency configuration for this Ledger Account. This defines how updates to this Ledger Account's ownBalance are handled. */
  consistencyConfig: LedgerAccountConsistencyConfig;
  created: Scalars['DateTime']['output'];
  /** Currency of this ledger account */
  currency?: Maybe<Currency>;
  /** Indicates if the account allows multiple currencies or is restricted to a single currency */
  currencyMode: CurrencyMode;
  /** URL to the Fragment Dashboard for this Ledger Account. */
  dashboardUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The idempotency key used to create this account */
  ik: Scalars['String']['output'];
  /** Ledger this account is in */
  ledger: Ledger;
  /** All Ledger Entries that have posted to this Ledger Account. Ledger Entries are paginated and sorted in reverse-chronological order by posted date. */
  ledgerEntries: LedgerEntriesConnection;
  /** ID of the ledger this account is in */
  ledgerId: Scalars['ID']['output'];
  /** List Ledger Lines in this account, sorted by `posted` in reverse chronological order. Does not include Ledger Lines from child Ledger Accounts. */
  lines: LedgerLinesConnection;
  /** The Link for the External Account that is linked to this ledger account */
  link?: Maybe<CustomLink | IncreaseLink | StripeLink | UnitLink>;
  /** External Account that is linked to this ledger account */
  linkedAccount?: Maybe<ExternalAccount>;
  /** The name of your Ledger Account */
  name?: Maybe<Scalars['String']['output']>;
  /** Total of all lines in this ledger account, excluding all child ledger accounts */
  ownBalance: Scalars['Int96']['output'];
  /** How much did the this ledger account's ownBalance change during the specified period. This query will exclude all child accounts. */
  ownBalanceChange: Scalars['Int96']['output'];
  /** How much did the this ledger account's ownBalance change during the specified period. This is the total of all lines in this ledger account, excluding all child ledger accounts */
  ownBalanceChanges: CurrencyAmountConnection;
  /**
   * How much did the ledger account's ownBalances change over a time period with a specified granularity.
   * For example, if the period is 1969-07 and the granularity is daily, the query will return the balance changes for each day in the month.
   */
  ownBalanceChangesDuring: BalanceChangeDuringConnection;
  /** Total of all lines across all currencies in this ledger account, excluding all child ledger accounts */
  ownBalances: CurrencyAmountConnection;
  /**
   * The ledger account's ownBalances over a time period with a specified granularity.
   * For example, if the period is 1969-07 and the granularity is daily, the query will return the balance for each day in the month.
   */
  ownBalancesDuring: HistoricalBalanceConnection;
  /** The parent ledger account of this ledger account */
  parentLedgerAccount?: Maybe<LedgerAccount>;
  /** ID of the parent ledger account of this ledger account */
  parentLedgerAccountId?: Maybe<Scalars['ID']['output']>;
  /**
   * The unique Path of the ledger account. This is a slash-delimited string containing the location of an account in its chart of accounts.
   * For accounts created with a schema, this will be composed of account keys. Else, for accounts created with the createLedgerAccounts API,
   * this will be composed of the IKs of an account and its ancestors.
   */
  path: Scalars['String']['output'];
  /** Payment configuration of this Ledger Account, if it is a payment account. */
  payment?: Maybe<LedgerAccountPayment>;
  /**
   * The posted timestamp window for this clearing account, representing the earliest and latest
   * posted timestamps across all currencies.
   *
   * This field is null when the Ledger Account is not configured to be a Clearing account
   * or when no entries have been posted to this account.
   */
  postedWindow?: Maybe<PostedWindow>;
  type: LedgerAccountTypes;
  /** A list of external account transactions that haven't been reconciled to this ledger account yet. Only populated for linked ledger accounts. Transactions are sorted in reverse chronological order by posted date. */
  unreconciledTxs: TxsConnection;
  /** @deprecated Callers should not need to query or store this value. */
  workspaceId: Scalars['ID']['output'];
};

/** A ledger account is a container for money */
export type LedgerAccountBalanceArgs = {
  at?: InputMaybe<Scalars['LastMoment']['input']>;
  consistencyMode?: InputMaybe<ReadBalanceConsistencyMode>;
  currency?: InputMaybe<CurrencyMatchInput>;
};

/** A ledger account is a container for money */
export type LedgerAccountBalanceChangeArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  period: Scalars['Period']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountBalanceChangesArgs = {
  period: Scalars['Period']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountBalanceChangesDuringArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  duration: Scalars['Int']['input'];
  granularity: Granularity;
  startTime: Scalars['FirstMoment']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['LastMoment']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  consistencyMode?: InputMaybe<ReadBalanceConsistencyMode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A ledger account is a container for money */
export type LedgerAccountBalancesDuringArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  duration: Scalars['Int']['input'];
  granularity: Granularity;
  startTime: Scalars['FirstMoment']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountChildBalanceArgs = {
  at?: InputMaybe<Scalars['LastMoment']['input']>;
  consistencyMode?: InputMaybe<ReadBalanceConsistencyMode>;
  currency?: InputMaybe<CurrencyMatchInput>;
};

/** A ledger account is a container for money */
export type LedgerAccountChildBalanceChangeArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  period: Scalars['Period']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountChildBalanceChangesArgs = {
  period: Scalars['Period']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountChildBalanceChangesDuringArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  duration: Scalars['Int']['input'];
  granularity: Granularity;
  startTime: Scalars['FirstMoment']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountChildBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['LastMoment']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  consistencyMode?: InputMaybe<ReadBalanceConsistencyMode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A ledger account is a container for money */
export type LedgerAccountChildBalancesDuringArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  duration: Scalars['Int']['input'];
  granularity: Granularity;
  startTime: Scalars['FirstMoment']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountChildLedgerAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A ledger account is a container for money */
export type LedgerAccountLedgerEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A ledger account is a container for money */
export type LedgerAccountLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerLinesFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A ledger account is a container for money */
export type LedgerAccountOwnBalanceArgs = {
  at?: InputMaybe<Scalars['LastMoment']['input']>;
  consistencyMode?: InputMaybe<ReadBalanceConsistencyMode>;
  currency?: InputMaybe<CurrencyMatchInput>;
};

/** A ledger account is a container for money */
export type LedgerAccountOwnBalanceChangeArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  period: Scalars['Period']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountOwnBalanceChangesArgs = {
  period: Scalars['Period']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountOwnBalanceChangesDuringArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  duration: Scalars['Int']['input'];
  granularity: Granularity;
  startTime: Scalars['FirstMoment']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountOwnBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['LastMoment']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  consistencyMode?: InputMaybe<ReadBalanceConsistencyMode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A ledger account is a container for money */
export type LedgerAccountOwnBalancesDuringArgs = {
  currency?: InputMaybe<CurrencyMatchInput>;
  duration: Scalars['Int']['input'];
  granularity: Granularity;
  startTime: Scalars['FirstMoment']['input'];
};

/** A ledger account is a container for money */
export type LedgerAccountUnreconciledTxsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerAccountUnreconciledTxsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The clearing status of a Ledger Account. */
export enum LedgerAccountClearingStatus {
  /** The account has no outstanding balances. */
  Cleared = 'cleared',
  /** The account has outstanding balances that have not been cleared. */
  Pending = 'pending',
}

export type LedgerAccountClearingStatusFilter = {
  /** Results must match the specified clearing account status */
  equalTo?: InputMaybe<LedgerAccountClearingStatus>;
};

/** A set of conditions that a Ledger Account must meet for an operation to succeed. */
export type LedgerAccountCondition = {
  __typename?: 'LedgerAccountCondition';
  /** A condition that the `ownBalance` field must satisfy. Note that this condition always applies to the latest balance, not to balances at a specific date or time. See [Read balances](https://fragment.dev/guides/read-balances) for more on the different types of Ledger Account balances. */
  ownBalance?: Maybe<Int96Condition>;
  /** A condition that the `totalBalance` field must satisfy. Note that this condition always applies to the latest balance, not to balances at a specific date or time. See [Read balances](https://fragment.dev/guides/read-balances) for more on the different types of Ledger Account balances. */
  totalBalance?: Maybe<Int96Condition>;
};

/** A set of conditions that a Ledger Account must meet for an operation to succeed. */
export type LedgerAccountConditionInput = {
  /** A condition that the ownBalance field must satisfy. Note that this condition always applies to the latest balance, not to balances at a specific date or time. See [Read balances](/guides/read-balances) for more on the different types of Ledger Account balances. */
  ownBalance?: InputMaybe<Int96ConditionInput>;
  /** A condition that the totalBalance field must satisfy. Note that this condition always applies to the latest balance, not to balances at a specific date or time. See [Read balances](/guides/read-balances) for more on the different types of Ledger Account balances. */
  totalBalance?: InputMaybe<Int96ConditionInput>;
};

/**
 * The consistency configuration of a Ledger Account's balance updates.
 * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
 */
export type LedgerAccountConsistencyConfig = {
  __typename?: 'LedgerAccountConsistencyConfig';
  lines: LedgerLinesConsistencyMode;
  /**
   * If set to `strong`, then a Ledger Account's `ownBalance` updates will be strongly consistent with
   * the API response. This Ledger Account's balance will be updated and
   * available for strongly consistent reads once you receive an API response.
   *
   * Otherwise if not set or set to `eventual`, `ownBalance` updates are applied
   * asynchronously and may not be immediately reflected in queries.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  ownBalanceUpdates: BalanceUpdateConsistencyMode;
  /**
   * If set to `strong`, then a Ledger Account's `ownBalance`, `childBalance`, and `balance` fields' updates will be strongly consistent with
   * the API response. This Ledger Account's balance will be updated and
   * available for strongly consistent reads once you receive an API response.
   *
   * Otherwise if not set or set to `eventual`, updates are applied
   * asynchronously and may not be immediately reflected in queries.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  totalBalanceUpdates?: Maybe<BalanceUpdateConsistencyMode>;
};

/**
 * The payload configuring the consistency for this Ledger Account.
 * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
 */
export type LedgerAccountConsistencyConfigInput = {
  /**
   * The consistency configuration for Ledger Entry Groups affecting this account.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  groups?: InputMaybe<Array<LedgerAccountGroupConsistencyConfigInput>>;
  /**
   * If set to `strong`, then a Ledger Account's `lines` updates will be strongly consistent with the API response.
   * This Ledger Account's balance will be updated and available for strongly consistent reads before you receive an API response.
   *
   * Otherwise if unset or set to `eventual`, `lines` updates are applied asynchronously and may not be immediately reflected in queries.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  lines?: InputMaybe<LedgerLinesConsistencyMode>;
  /**
   * If set to `strong`, then a Ledger Account's `ownBalance` updates will be strongly consistent with the API response.
   * This Ledger Account's balance will be updated and available for strongly consistent reads before you receive an API response.
   *
   * Otherwise if unset or set to `eventual`, `ownBalance` updates are applied asynchronously and may not be immediately reflected in queries.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  ownBalanceUpdates?: InputMaybe<BalanceUpdateConsistencyMode>;
  /**
   * EXPERIMENTAL: If set to `strong`, then a Ledger Account's `totalBalance` updates will be strongly consistent with the API response.
   * This Ledger Account's balance will be updated and available for strongly consistent reads before you receive an API response.
   *
   * Otherwise if unset or set to `eventual`, `totalBalance` updates are applied asynchronously and may not be immediately reflected in queries.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  totalBalanceUpdates?: InputMaybe<BalanceUpdateConsistencyMode>;
};

/** Represents a data migration for a specific Ledger Account in a Ledger. */
export type LedgerAccountDataMigration = LedgerDataMigration & {
  __typename?: 'LedgerAccountDataMigration';
  /** The path of the Ledger Account being migrated. */
  accountPath: Scalars['String']['output'];
  /** Current active migration info (null if migration is inactive). */
  currentMigration?: Maybe<LedgerDataMigrationHistoryEntry>;
  /** The historical transitions of this migration. */
  history: LedgerDataMigrationHistoryConnection;
  /** The ledger entries to be migrated. */
  ledgerEntries: LedgerEntriesConnection;
  /** The status of the data migration. */
  status: LedgerDataMigrationStatus;
};

/** Represents a data migration for a specific Ledger Account in a Ledger. */
export type LedgerAccountDataMigrationHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a data migration for a specific Ledger Account in a Ledger. */
export type LedgerAccountDataMigrationLedgerEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LedgerAccountDataMigrationConnection = {
  __typename?: 'LedgerAccountDataMigrationConnection';
  /** The current page of results */
  nodes: Array<LedgerAccountDataMigration>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

export type LedgerAccountDataMigrationsFilterSet = {
  /** Filter by Ledger Account path. */
  accountPath?: InputMaybe<StringFilter>;
  /** Filter by the status of the data migration. */
  status?: InputMaybe<LedgerDataMigrationStatus>;
};

export type LedgerAccountFilter = {
  /** Result must match the specified Ledger Account */
  equalTo?: InputMaybe<LedgerAccountMatchInput>;
  /** Results can match any of specified Ledger Accounts */
  in?: InputMaybe<Array<LedgerAccountMatchInput>>;
};

/** The consistency configuration for a specific Ledger Entry Group in this account. */
export type LedgerAccountGroupConsistencyConfigInput = {
  /** The group key for this configuration. */
  key: Scalars['SafeString']['input'];
  /**
   * If set to `strong`, then Ledger Entry Group `ownBalance`s updates for this account will be strongly consistent with the API response.
   * This Ledger Account's Ledger Entry Group balances will be updated and available for strongly consistent reads before you receive an API response.
   *
   * Otherwise if unset or set to `eventual`, Ledger Entry Group `ownBalance` updates are applied asynchronously and may not be immediately reflected in queries.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  ownBalanceUpdates: BalanceUpdateConsistencyMode;
};

/**
 * Specify a Ledger Account by using `id` or `path`.
 *
 * When specifying a Ledger Account by `path`, you must provide `ledger`.
 */
export type LedgerAccountMatchInput = {
  /** The FRAGMENT ID of the Ledger Account */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The Ledger to which this Ledger Account belongs. This is required if you are specifying the Ledger Account by `path`. */
  ledger?: InputMaybe<LedgerMatchInput>;
  /**
   * The unique path of the Ledger Account.
   * This is a slash-delimited string containing the keys of an account and all its direct ancestors.
   */
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Payment configuration of a Ledger Account. */
export type LedgerAccountPayment = {
  __typename?: 'LedgerAccountPayment';
  enabled: Scalars['Boolean']['output'];
};

export type LedgerAccountTypeFilter = {
  /** Results must be of the specified Ledger Account type */
  equalTo?: InputMaybe<LedgerAccountTypes>;
  /** Results can have any of the specified Ledger Account types */
  in?: InputMaybe<Array<LedgerAccountTypes>>;
};

export enum LedgerAccountTypes {
  Asset = 'asset',
  Expense = 'expense',
  Income = 'income',
  Liability = 'liability',
}

/** Filters for a ledger account's unreconciled transactions. */
export type LedgerAccountUnreconciledTxsFilterSet = {
  /** The transaction's posted timestamp. Bounds are inclusive; when both are supplied, before must be later than after. */
  posted?: InputMaybe<DateTimeFilter>;
};

/** A paginated list of Ledger Accounts */
export type LedgerAccountsConnection = {
  __typename?: 'LedgerAccountsConnection';
  /** The current page of results */
  nodes: Array<LedgerAccount>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export type LedgerAccountsFilterSet = {
  /** Use this to filter Ledger Accounts by their clearing account status */
  clearingStatus?: InputMaybe<LedgerAccountClearingStatusFilter>;
  /**
   * Filter by the earliest posted timestamp across all currencies for clearing accounts. You must also provide clearingStatus in the same filter.
   * Only clearing accounts where the minimum posted timestamp (across all currencies) matches this filter will be included.
   */
  earliestPosted?: InputMaybe<DateTimeFilter>;
  /** Use this to filter Ledger Accounts by their parent status */
  hasParentLedgerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use this to filter Ledger Accounts by their linked status */
  isLinkedAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by the latest posted timestamp across all currencies for clearing accounts. You must also provide clearingStatus in the same filter.
   * Only clearing accounts where the maximum posted timestamp (across all currencies) matches this filter will be included.
   */
  latestPosted?: InputMaybe<DateTimeFilter>;
  /** Use this to filter Ledger Accounts by their ID or path */
  ledgerAccount?: InputMaybe<LedgerAccountFilter>;
  /** Use this to filter Ledger Accounts by their external linked account ID */
  linkedAccount?: InputMaybe<ExternalAccountFilter>;
  /** Use this to filter Ledger Accounts by their parent account IDs */
  parentLedgerAccount?: InputMaybe<LedgerAccountFilter>;
  /**
   * A filter that must match the account path. Wildcards ('*') may be used only for template variables, and will only match a single variable each.
   * For example: 'assets-root/accounts-receivable/merchant:*' would match: 'assets-root/accounts-receivable/merchant:1' and 'assets-root/accounts-receivable/merchant:1/child'.
   * Wildcards may not be used outside of template variables. For example, passing in 'assets-root/*' as a filter is invalid and would raise a GraphQL error.
   */
  path?: InputMaybe<StringMatchFilter>;
  /** Use this to filter Ledger Accounts by their type */
  type?: InputMaybe<LedgerAccountTypeFilter>;
};

/** Represents a data migration for a Ledger. */
export type LedgerDataMigration = {
  /** Current active migration info (null if migration is inactive). */
  currentMigration?: Maybe<LedgerDataMigrationHistoryEntry>;
  /** The historical transitions of this migration. */
  history: LedgerDataMigrationHistoryConnection;
  /** The ledger entries to be migrated. */
  ledgerEntries: LedgerEntriesConnection;
  /** The status of the data migration. */
  status: LedgerDataMigrationStatus;
};

/** Represents a data migration for a Ledger. */
export type LedgerDataMigrationHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a data migration for a Ledger. */
export type LedgerDataMigrationLedgerEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated list of migration history entries. */
export type LedgerDataMigrationHistoryConnection = {
  __typename?: 'LedgerDataMigrationHistoryConnection';
  /** The current page of results */
  nodes: Array<LedgerDataMigrationHistoryEntry>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

/** A single schema version in the migration history. */
export type LedgerDataMigrationHistoryEntry = {
  __typename?: 'LedgerDataMigrationHistoryEntry';
  /** The schema version. */
  schemaVersion: Scalars['Int']['output'];
  /** The current status of this schema version (active if it's the latest and migration is active, otherwise inactive). */
  status: LedgerDataMigrationStatus;
};

/** The status of a ledger data migration. */
export enum LedgerDataMigrationStatus {
  /** The migration is active. */
  Active = 'active',
  /** The migration is inactive. */
  Inactive = 'inactive',
}

/** A paginated list of Ledger Entries */
export type LedgerEntriesConnection = {
  __typename?: 'LedgerEntriesConnection';
  /** The current page of results */
  nodes: Array<LedgerEntry>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export type LedgerEntriesFilterSet = {
  /** Use this filter to filter Ledger Entries by their `posted` date. */
  date?: InputMaybe<DateFilter>;
  /** Use this to filter Ledger Entries by groups. The response will include entries that contain or do not contain specific groups. */
  group?: InputMaybe<GroupFilter>;
  /** Use this to filter Ledger Entries that were posted using `reverseLedgerEntry`. */
  isReversal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use this to filter Ledger Entries that have been reversed. */
  isReversed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use to filter Ledger Entries by their IDs or IKs. */
  ledgerEntry?: InputMaybe<LedgerEntryFilter>;
  /** Use this filter to filter Ledger Entries by their `posted` timestamp. */
  posted?: InputMaybe<DateTimeFilter>;
  /** Use this filter to show hidden Ledger Entries. */
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use this to filter Ledger Entries by tags. The response will include entries that contain tags matching the filter. */
  tag?: InputMaybe<TagFilter>;
  /** Use this to filter Ledger Entries by type. Ledger Entry types are defined in Schemas. */
  type?: InputMaybe<StringFilter>;
  /** Use this to filter Ledger Entries by their type version. */
  typeVersion?: InputMaybe<StringFilter>;
};

export type LedgerEntry = {
  __typename?: 'LedgerEntry';
  /** The conditions that were satisfied by this Ledger Entry when it was posted. */
  conditions: Array<LedgerEntryCondition>;
  /** ISO-8601 timestamp this LedgerEntry was created in Fragment. */
  created: Scalars['DateTime']['output'];
  /** URL to the Fragment Dashboard for this Ledger Entry. */
  dashboardUrl: Scalars['String']['output'];
  /** Date this LedgerEntry posted to its Ledger e.g. "2021-01-01". */
  date: Scalars['Date']['output'];
  /** Description posted for this Ledger Entry. */
  description?: Maybe<Scalars['String']['output']>;
  /** The Ledger Entry Groups this Ledger Entry is in. */
  groups: Array<LedgerEntryGroup>;
  /**
   * Indicates whether this Ledger Entry is hidden when listing Ledger Entries.
   * Reversed and Reversal Ledger Entries are hidden by default because taken together they have no impact on a Ledger's balances.
   */
  hidden: Scalars['Boolean']['output'];
  /** The ID of this LedgerEntry. */
  id: Scalars['ID']['output'];
  /** The idempotency key used to post this ledger entry */
  ik: Scalars['String']['output'];
  /**
   * Indicates whether this Ledger Entry is a reversal of another Ledger Entry.
   * If so, reverses will point to that Ledger Entry.
   */
  isReversal: Scalars['Boolean']['output'];
  /**
   * Indicates whether this Ledger Entry has been reversed by another Ledger Entry.
   * If so, reversedBy will point to that Ledger Entry.
   */
  isReversed: Scalars['Boolean']['output'];
  /** The Ledger that this Ledger Entry is posted to. */
  ledger: Ledger;
  /** The ID of the Ledger this Ledger Entry is posted to. */
  ledgerId: Scalars['ID']['output'];
  /** Lines posted in this Ledger Entry. */
  lines: LedgerLinesConnection;
  /** The parameters used to post this Ledger Entry. */
  parameters?: Maybe<Scalars['Parameters']['output']>;
  /** ISO-8601 timestamp this LedgerEntry posted to its Ledger. */
  posted: Scalars['DateTime']['output'];
  /** The reversal history of this Ledger Entry. Each entry in this connection shares the same IK. */
  reversalHistory: LedgerEntriesConnection;
  /** The position of this Ledger Entry in its reversalHistory. This is a one-indexed value, so the initial entry will have reversalPosition 1. */
  reversalPosition: Scalars['Int']['output'];
  /** ISO-8601 timestamp of when this Ledger Entry was reversed. */
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Ledger Entry that reversed this Ledger Entry. */
  reversedBy?: Maybe<LedgerEntry>;
  /** The Ledger Entry that was reversed by this Ledger Entry. */
  reverses?: Maybe<LedgerEntry>;
  /** The set of tags attached to this Ledger Entry. */
  tags: Array<LedgerEntryTag>;
  /** The type of the Ledger Entry. */
  type?: Maybe<Scalars['SafeString']['output']>;
  /** The version of the Ledger Entry type used when it was posted. */
  typeVersion?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Callers should not need to query or store this value. */
  workspaceId: Scalars['ID']['output'];
};

/** A set of pre-conditions and post-conditions that a Ledger Account must have satisfied. Each `LedgerEntryCondition` has at least one of `precondition` or `postcondition`. */
export type LedgerEntryCondition = {
  __typename?: 'LedgerEntryCondition';
  /** The Ledger Account that must satisfied the provided conditions. */
  account: LedgerAccount;
  /** The currency of the balance associated with this `LedgerEntryCondition`. */
  currency: Currency;
  /** The conditions that must be satisfied after the operation. */
  postcondition?: Maybe<LedgerAccountCondition>;
  /** The conditions that must be satisfied prior to the operation. */
  precondition?: Maybe<LedgerAccountCondition>;
};

/** A set of pre-conditions and post-conditions that a Ledger Account balance must meet for an operation to succeed. You must specify at least one of `precondition` or `postcondition` for each condition. */
export type LedgerEntryConditionInput = {
  /** The Ledger Account that must satisfy the provided conditions. */
  account: LedgerAccountMatchInput;
  /** For Ledger Accounts in the `multi` currency mode, you must specify the currency of the balance affected by the condition. You only need to specify this field for multi-currency accounts. */
  currency?: InputMaybe<CurrencyMatchInput>;
  /** The conditions that must hold after the operation. */
  postcondition?: InputMaybe<LedgerAccountConditionInput>;
  /** The conditions that must hold prior to the operation. */
  precondition?: InputMaybe<LedgerAccountConditionInput>;
};

/** Represents a data migration for a specific entry type in a Ledger. */
export type LedgerEntryDataMigration = LedgerDataMigration & {
  __typename?: 'LedgerEntryDataMigration';
  /** Current active migration info (null if migration is inactive). */
  currentMigration?: Maybe<LedgerDataMigrationHistoryEntry>;
  /** The entry type being migrated. */
  entryType: Scalars['SafeString']['output'];
  /** The historical transitions of this migration. */
  history: LedgerDataMigrationHistoryConnection;
  /** The ledger entries to be migrated. */
  ledgerEntries: LedgerEntriesConnection;
  /** The status of the data migration. */
  status: LedgerDataMigrationStatus;
  /** The version of the entry type being migrated. */
  typeVersion: Scalars['Int']['output'];
};

/** Represents a data migration for a specific entry type in a Ledger. */
export type LedgerEntryDataMigrationHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a data migration for a specific entry type in a Ledger. */
export type LedgerEntryDataMigrationLedgerEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LedgerEntryDataMigrationConnection = {
  __typename?: 'LedgerEntryDataMigrationConnection';
  /** The current page of results */
  nodes: Array<LedgerEntryDataMigration>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

export type LedgerEntryDataMigrationsFilterSet = {
  /** Filter by Ledger Entry type. */
  entryType?: InputMaybe<StringFilter>;
  /** Filter by the status of the data migration. */
  status?: InputMaybe<LedgerDataMigrationStatus>;
  /** Filter by Ledger Entry type version. */
  typeVersion?: InputMaybe<StringFilter>;
};

export type LedgerEntryFilter = {
  /** Result must be the specified Ledger Entry. */
  equalTo?: InputMaybe<LedgerEntryMatchInput>;
  /** Result can be any of the specified Ledger Entries. Limited to 100 items maximum. */
  in?: InputMaybe<Array<LedgerEntryMatchInput>>;
};

/** A group of Ledger Entries */
export type LedgerEntryGroup = {
  __typename?: 'LedgerEntryGroup';
  balances: LedgerEntryGroupBalanceConnection;
  /** ISO-8601 timestamp this LedgerEntryGroup was created in Fragment. */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** URL to the Fragment Dashboard for this Ledger Entry Group. */
  dashboardUrl: Scalars['String']['output'];
  /** The key of this Ledger Entry Group. */
  key: Scalars['SafeString']['output'];
  /** The Ledger that this Ledger Entry Group is within. */
  ledger: Ledger;
  ledgerEntries: LedgerEntriesConnection;
  /** The ID of the Ledger this Ledger Entry Group is within. */
  ledgerId: Scalars['ID']['output'];
  /** The value associated with Ledger Entry Group. */
  value: Scalars['SafeString']['output'];
};

/** A group of Ledger Entries */
export type LedgerEntryGroupBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntryGroupBalanceFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A group of Ledger Entries */
export type LedgerEntryGroupLedgerEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntriesFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the total effect of a Ledger Entry Group on a Ledger Account balance for a single currency. */
export type LedgerEntryGroupBalance = {
  __typename?: 'LedgerEntryGroupBalance';
  /** The Ledger Account whose balance is affected. */
  account: LedgerAccount;
  /** The currency of the affected balance. */
  currency: Currency;
  /** The total balance change for this Ledger Account and currency. */
  ownBalance: Scalars['Int96']['output'];
};

/** Represents the total effect of a Ledger Entry Group on a Ledger Account balance for a single currency. */
export type LedgerEntryGroupBalanceOwnBalanceArgs = {
  consistencyMode?: InputMaybe<ReadBalanceConsistencyMode>;
};

/** A set of balance changes for a specific Ledger Entry Group. */
export type LedgerEntryGroupBalanceConnection = {
  __typename?: 'LedgerEntryGroupBalanceConnection';
  nodes: Array<LedgerEntryGroupBalance>;
  pageInfo: PageInfo;
};

/** Filter Ledger Entry Groups by their balance impact on a Ledger Account. If a group has a matching balance for the specified account, the group will be included in the results. */
export type LedgerEntryGroupBalanceFilter = {
  /** A Ledger Entry Group will be included in the result if it has a balance for the specified account. If 'account' is the only filter specified, then any non-null balance in any currency will match. */
  account: GroupBalanceAccountFilter;
  /** A Ledger Entry Group will be included in the result if it has a balance for the specified account in the specified currency. If the 'ownBalance' filter is omitted then any non-null balance will match. */
  currency?: InputMaybe<CurrencyFilter>;
  /** A Ledger Entry Group will be included in the result if it has a balance for the specified account that passes the specified value predicate. If the 'currency' filter is omitted then any balance in any currency that passes the predicate will match. If the 'currency' filter is included, the value predicate will only be evaluated against the specified currency.  */
  ownBalance?: InputMaybe<Int96Filter>;
};

/** Optional filters for querying balances on a Ledger Entry Group. */
export type LedgerEntryGroupBalanceFilterSet = {
  /** Filter to a subset of accounts */
  account?: InputMaybe<GroupBalanceAccountFilter>;
  /** Filter to one or more currencies */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter to only balances in a certain range */
  ownBalance?: InputMaybe<Int96Filter>;
};

export type LedgerEntryGroupInput = {
  /** The key of this group. Can be up to 128 characters long. */
  key: Scalars['SafeString']['input'];
  /** The value associated with this group's key. Can be up to 128 characters long. */
  value: Scalars['SafeString']['input'];
};

export type LedgerEntryGroupMatchInput = {
  key: Scalars['SafeString']['input'];
  ledger: LedgerMatchInput;
  value: Scalars['SafeString']['input'];
};

/** A paginated list of Ledger Entry Groups */
export type LedgerEntryGroupsConnection = {
  __typename?: 'LedgerEntryGroupsConnection';
  /** The current page of results */
  nodes: Array<LedgerEntryGroup>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

export type LedgerEntryGroupsFilterSet = {
  /** Filter Ledger Entry Groups by their balance impact on a Ledger Account. If a group has a matching balance for the specified account, the group will be included in the results. */
  balance?: InputMaybe<LedgerEntryGroupBalanceFilter>;
  /** Use to filter Ledger Entry Groups by their created timestamp */
  created?: InputMaybe<DateTimeFilter>;
  /** Use to filter Ledger Entry Groups by their key */
  key?: InputMaybe<StringFilter>;
  /** Use to filter Ledger Entry Groups by their value */
  value?: InputMaybe<StringFilter>;
};

/** Ledger Entries are limited to 30 Ledger Lines. */
export type LedgerEntryInput = {
  /** Conditions that must be satisfied to post this Ledger Entry. The Ledger Entry will reject with a BadRequestError if any condition is not met. You can only add a condition on a Ledger Account containing a Line in this Ledger Entry. */
  conditions?: InputMaybe<Array<LedgerEntryConditionInput>>;
  /** If specified, will also be used as the description for LedgerLines unless they specify their own description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Adds this Ledger Entry to this set of Ledger Entry Groups */
  groups?: InputMaybe<Array<LedgerEntryGroupInput>>;
  /** The Ledger to which to post this Ledger Entry. Must be linked to a Schema that defines the provided Ledger Entry type. */
  ledger?: InputMaybe<LedgerMatchInput>;
  /** The Ledger Lines to create as part of this Ledger Entry. This cannot be used with Ledger Entries that have a 'type' i.e.  Ledger Entries defined in the Schema. This can be useful during non-routine operations such as an incident. It is not recommended to use 'lines' during routine operations. */
  lines?: InputMaybe<Array<LedgerLineInput>>;
  /** Parameters to be included in a templated Ledger Entry. All provided parameters must be present in the typed Ledger Entry within the Schema linked to the provided Ledger. */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** ISO 8601 timestamp to post this Ledger Entry e.g. "2021-01-01" or "2021-01-01T16:45:00Z". Will error out if supplied to reconcileTx or createOrder since the transaction timestamp will be used instead */
  posted?: InputMaybe<Scalars['DateTime']['input']>;
  /** A set of tags attached to this Ledger Entry. */
  tags?: InputMaybe<Array<LedgerEntryTagInput>>;
  /** The type of the Ledger Entry. Must be defined in the Schema linked to the Ledger specified below. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The version of the Ledger Entry type to post. Defaults to 1. */
  typeVersion?: InputMaybe<Scalars['Int']['input']>;
};

/** Specify a Ledger Entry by using `id`. */
export type LedgerEntryMatchInput = {
  /** The FRAGMENT ID of the Ledger Entry */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The IK provided to the `addLedgerEntry` mutation or the `ik` field returned from a `reconcileTx` mutation. This is required if you have not provided `id`. */
  ik?: InputMaybe<Scalars['SafeString']['input']>;
  /** The FRAGMENT ID of the Ledger to which this Ledger Entry belongs. This is required if you have not provided `id`. */
  ledger?: InputMaybe<LedgerMatchInput>;
};

/** Posting count statistics for a specific type and typeVersion of entry in a Ledger. */
export type LedgerEntryStats = {
  __typename?: 'LedgerEntryStats';
  /** The total number of entries of this type. */
  count: Scalars['Int96']['output'];
  /** The ledger ID these stats are for. */
  ledgerId: Scalars['SafeString']['output'];
  /** The net number of entries (count - reversalsCount). */
  netCount: Scalars['Int96']['output'];
  /** The number of entries that are reversals. */
  reversalsCount: Scalars['Int96']['output'];
  /** The schema key associated with these stats. */
  schemaKey: Scalars['SafeString']['output'];
  /** The type of entry these stats are for. */
  type: Scalars['SafeString']['output'];
  /** The version of the entry type these stats are for. */
  typeVersion: Scalars['Int']['output'];
};

/** A paginated list of Ledger Entry Stats */
export type LedgerEntryStatsConnection = {
  __typename?: 'LedgerEntryStatsConnection';
  /** The current page of results */
  nodes: Array<LedgerEntryStats>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

/** A tag attached to a Ledger Entry. */
export type LedgerEntryTag = {
  __typename?: 'LedgerEntryTag';
  /** The key of this tag. */
  key: Scalars['SafeString']['output'];
  /** The value associated with this tag's key. */
  value: Scalars['SafeString']['output'];
};

export type LedgerEntryTagInput = {
  /** The key of this tag. Can be up to 128 characters long. */
  key: Scalars['SafeString']['input'];
  /** The value associated with this tag's key. Can be up to 256 characters long. */
  value: Scalars['SafeString']['input'];
};

export type LedgerLine = {
  __typename?: 'LedgerLine';
  /** LedgerAccount that contains this line */
  account: LedgerAccount;
  accountId: Scalars['ID']['output'];
  /** How much this line's LedgerAccount's balance changed in integer cents  (i.e. in USD 100 is 1 dollar, 100 cents) */
  amount: Scalars['Int96']['output'];
  /** ISO-8601 timestamp this LedgerLine was created in Fragment */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Currency of this LedgerLine */
  currency?: Maybe<Currency>;
  /** Date this LedgerLine posted to its LedgerAccount e.g. "2021-01-01" */
  date?: Maybe<Scalars['Date']['output']>;
  /** Description of this LedgerLine */
  description?: Maybe<Scalars['String']['output']>;
  /** ID in the external system of the payment or transfer that created the transaction linked to this LedgerLine */
  externalTransferId?: Maybe<Scalars['String']['output']>;
  /** Whether the transaction linked to this LedgerLine was a payment or transfer */
  externalTransferType?: Maybe<ExternalTransferType>;
  /** ID in the external system of the transaction linked to this LedgerLine */
  externalTxId?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates whether this Ledger Line is hidden when listing Ledger Lines.
   * Reversed and Reversal Ledger Lines are hidden by default because taken together they have no impact on a Ledger Account's balance
   */
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Indicates whether this Ledger Line is a reversal of another Ledger Line.
   * If so, reverses will point to that Ledger Line.
   */
  isReversal: Scalars['Boolean']['output'];
  /**
   * Indicates whether this Ledger Line has been reversed by another Ledger Line.
   * If so, reversedBy will point to that Ledger Line.
   */
  isReversed: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  ledger: Ledger;
  /** LedgerEntry that contains this line */
  ledgerEntry: LedgerEntry;
  /** ID of the LedgerEntry that contains this line */
  ledgerEntryId: Scalars['ID']['output'];
  /** Ledger that contains this line */
  ledgerId: Scalars['ID']['output'];
  /** ID in the external system of destination or source bank account for an internal bank transfer. Only for internal bank transfers - see otherTxId */
  otherTxExternalAccountExternalId?: Maybe<Scalars['String']['output']>;
  /** FRAGMENT ID of destination or source bank account. Only for internal bank transfers - see otherTxId */
  otherTxExternalAccountId?: Maybe<Scalars['String']['output']>;
  /** ID in the external system of transaction in the destination or source bank account. Only for internal bank transfers - see otherTxId */
  otherTxExternalId?: Maybe<Scalars['String']['output']>;
  /** FRAGMENT ID of the transaction in the destination account (if sending money from this account) or source account (if pulling money into this account). Only applicable if this line is linked to a transaction created through an internal transfer */
  otherTxId?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 timestamp this LedgerLine posted to its LedgerAccount */
  posted?: Maybe<Scalars['DateTime']['output']>;
  /** ISO-8601 timestamp of when this Ledger Line was reversed. */
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Ledger Line that reverses the balance changes of this Ledger Line. */
  reversedBy?: Maybe<LedgerLine>;
  /** The Ledger Line whose balance changes are reversed by this Ledger Line. */
  reverses?: Maybe<LedgerLine>;
  /** Tags attached to this Ledger Line. */
  tags: Array<LedgerLineTag>;
  /** The transaction linked to this LedgerLine */
  tx?: Maybe<Tx>;
  /** Fragment ID of the transaction linked to this LedgerLine */
  txId?: Maybe<Scalars['String']['output']>;
  /** credit or debit */
  type: TxType;
  /** @deprecated Callers should not need to query or store this value. */
  workspaceId: Scalars['ID']['output'];
};

export type LedgerLineAmountArgs = {
  absolute?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LedgerLineInput = {
  /** The LedgerAccount this line is being added to */
  account: LedgerAccountMatchInput;
  /** A positive amount increases the balance of its LedgerAccount, a negative amount reduces the balance of its LedgerAccount */
  amount?: InputMaybe<Scalars['Int96']['input']>;
  /** The currency the ledger line is in */
  currency?: InputMaybe<CurrencyMatchInput>;
  /** If not specified the description from the parent LedgerEntryInput will be used */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional identifier for Ledger Line. You can filter lines by key using [LedgerLinesFilterSet](https://fragment.dev/api-reference/api-types#filter-types-ledgerlinesfilterset). */
  key?: InputMaybe<Scalars['String']['input']>;
  /** A set of tags attached to this Ledger Line. */
  tags?: InputMaybe<Array<LedgerEntryTagInput>>;
  /** Required for reconcileTx to specify the transaction being reconciled, you can specify either the FRAGMENT ID or external ID of the transaction */
  tx?: InputMaybe<TxMatchInput>;
};

/** Specify a Ledger Line by using `id`. */
export type LedgerLineMatchInput = {
  /** The FRAGMENT ID of the ledger line */
  id: Scalars['ID']['input'];
};

/** A tag attached to a Ledger Line. */
export type LedgerLineTag = {
  __typename?: 'LedgerLineTag';
  /** The key of this tag. */
  key: Scalars['SafeString']['output'];
  /** The value associated with this tag's key. */
  value: Scalars['SafeString']['output'];
};

export type LedgerLineTagInput = {
  /** The key of this tag. Can be up to 128 characters long. */
  key: Scalars['SafeString']['input'];
  /** The value associated with this tag's key. Can be up to 256 characters long. */
  value: Scalars['SafeString']['input'];
};

/** A paginated list of Ledger Lines */
export type LedgerLinesConnection = {
  __typename?: 'LedgerLinesConnection';
  /** The current page of results */
  nodes: Array<LedgerLine>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export enum LedgerLinesConsistencyMode {
  Eventual = 'eventual',
  Strong = 'strong',
}

export type LedgerLinesFilterSet = {
  /** Filter by the created timestamp of the Ledger Line. This is the wall-clock time when the Ledger Line was created. */
  created?: InputMaybe<DateTimeFilter>;
  /** Filter by the currency of the Ledger Line. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Use this filter to filter Ledger Lines by their `posted` date. */
  date?: InputMaybe<DateFilter>;
  /** Filter Ledger Lines by the external IDs of their linked transactions. Only supported on `LedgerAccount.lines` for a linked Ledger Account. */
  externalTxIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Use this to filter Ledger Lines that were posted to this Ledger Account, using `reverseLedgerEntry`. */
  isReversal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use this to filter Ledger Lines that have been reversed. */
  isReversed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use this to filter Ledger Lines by key. Ledger Line keys are defined in Schemas. */
  key?: InputMaybe<StringFilter>;
  /** Specify which Ledger Account to read lines from. Required when querying lines via `Ledger.lines` without a `path` filter. Not allowed when querying via `LedgerAccount.lines`. */
  ledgerAccount?: InputMaybe<LedgerAccountFilter>;
  /**
   * A filter that string matches the account path. Wildcards ('*') can be used to return lines across multiple accounts.
   * To search for all instances of a a Ledger Account template, use the `matches` filter  with an wildcard character in place of the template value e.g. `assets/user:*`. This returns lines from all instances of this template, interleaved by `posted` timestamp.
   * To search for all descendant Ledger Accounts under a given path, use a trailing `/*` in the `matches` filter e.g. `assets/user:user-1>/*`. This returns lines from all descendants at any depth, but not lines from the parent account at `assets/user:user-1>`.
   * To OR multiple `matches` patterns and get a single paginated list, use `matchesAny` — e.g. `matchesAny: ["assets/user:user-1/*", "assets/user:user-2/*"]` returns descendants of both prefixes interleaved by `posted` timestamp.
   * Cannot be combined with `ledgerAccount` filter. Not allowed when querying via `LedgerAccount.lines`. You cannot use wildcards for both descendant and template instance matching in the same query.
   */
  path?: InputMaybe<StringMatchFilter>;
  /** Use this filter to filter Ledger Lines by their `posted` timestamp. */
  posted?: InputMaybe<DateTimeFilter>;
  /** Use this filter to find hidden Ledger Lines. */
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter Ledger Lines by tag. Only matches lines that have the specified tags attached directly to them. */
  tag?: InputMaybe<TagFilter>;
  type?: InputMaybe<TxTypeFilter>;
};

/** Specify a Ledger by using `id` or `ik`. */
export type LedgerMatchInput = {
  /** The FRAGMENT ID of the Ledger */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The IK passed into the [createLedger](/api-reference/api-mutations#createledger) mutation. This is treated as a second unique identifier for this Ledger. */
  ik?: InputMaybe<Scalars['SafeString']['input']>;
};

/**
 * Represents a Schema being applied to a Ledger.
 * It contains metadata about the Ledger, the Schema, and the status of the migration.
 */
export type LedgerMigration = {
  __typename?: 'LedgerMigration';
  /** The Ledger that the migration is run on. */
  ledger: Ledger;
  schemaVersion: SchemaVersion;
  /** The status of the Ledger Migration. */
  status: LedgerMigrationStatus;
};

/** A paginated list of Ledger Migrations */
export type LedgerMigrationConnection = {
  __typename?: 'LedgerMigrationConnection';
  /** The current page of results */
  nodes: Array<LedgerMigration>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

/** The status of a ledger migration. */
export enum LedgerMigrationStatus {
  /**
   * The Ledger Migration has been successfully completed.
   * This is a terminal state.
   */
  Completed = 'completed',
  /**
   * The Ledger Migration has failed.
   * This can happen either due to an invalid schema or an internal error.
   * This is a terminal state.
   */
  Failed = 'failed',
  /** The Ledger Migration has been queued. */
  Queued = 'queued',
  /**
   * The Ledger Migration has been skipped because a newer version is available.
   * This is a terminal state.
   */
  Skipped = 'skipped',
  /** The Ledger Migration has been started. */
  Started = 'started',
}

export type LedgerTypeFilter = {
  equalTo?: InputMaybe<LedgerTypes>;
  /** Must match one of the values provided. Limited to 100 items maximum. */
  in?: InputMaybe<Array<LedgerTypes>>;
};

export enum LedgerTypes {
  Double = 'double',
}

/** Filters for transactions not reconciled to any account in a Ledger. */
export type LedgerUnreconciledTxsFilterSet = {
  /** Filter by the external transaction's posted timestamp. Bounds are inclusive. */
  posted?: InputMaybe<DateTimeFilter>;
};

/** A paginated list of Ledgers */
export type LedgersConnection = {
  __typename?: 'LedgersConnection';
  /** The current page of results */
  nodes: Array<Ledger>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export type LedgersFilterSet = {
  hasSchema?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<LedgerTypeFilter>;
};

export type Link = {
  /** ISO-8601 timestamp when the Link was created. */
  created: Scalars['String']['output'];
  /** URL to the Fragment Dashboard for this Link. */
  dashboardUrl: Scalars['String']['output'];
  /** A list of External Accounts associated with this Link. */
  externalAccounts: ExternalAccountsConnection;
  /** FRAGMENT ID of the Link. */
  id: Scalars['ID']['output'];
  /** Name of the Link as it appears in the Dashboard. */
  name: Scalars['String']['output'];
};

/** Specify a Link by ID, or a Custom Link by its creation IK. */
export type LinkMatchInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The IK passed to createCustomLink. If id is also provided, both must identify the same Link. */
  ik?: InputMaybe<Scalars['SafeString']['input']>;
};

/** The type of Link an external account belongs to. */
export enum LinkType {
  /** A Custom Link */
  CustomLink = 'CustomLink',
  /** An Increase Link */
  IncreaseLink = 'IncreaseLink',
  /** A Stripe Link */
  StripeLink = 'StripeLink',
  /** A Unit Link */
  UnitLink = 'UnitLink',
}

/** A paginated list of Links */
export type LinksConnection = {
  __typename?: 'LinksConnection';
  /** The current page of results */
  nodes: Array<CustomLink | IncreaseLink | StripeLink | UnitLink>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

/** An object defining the input for migrating a Ledger Entry. */
export type MigrateLedgerEntryInput = {
  /** The Ledger Entry to migrate */
  id: Scalars['ID']['input'];
  /** The Ledger Entry you want to migrate it to */
  newLedgerEntry: LedgerEntryInput;
};

export type MigrateLedgerEntryResponse = BadRequestError | InternalError | MigrateLedgerEntryResult;

export type MigrateLedgerEntryResult = {
  __typename?: 'MigrateLedgerEntryResult';
  /** Whether this migration was an IK replay or not */
  isIkReplay: Scalars['Boolean']['output'];
  /** The new Ledger Entry posted as a result of the migration */
  newLedgerEntry: LedgerEntry;
  /** The Ledger Entry that was migrated */
  reversedLedgerEntry: LedgerEntry;
  /** The reversal Ledger Entry that was posted to reverse the Ledger Entry being migrated */
  reversingLedgerEntry: LedgerEntry;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  /**
   * Batch version of [addLedgerEntry](/api-reference/ledger-mutations#addledgerentry).
   *
   * Adds a batch of Ledger Entries in one synchronous and atomic transaction. Either every entry is added or none are.
   */
  addLedgerEntries: AddLedgerEntriesResponse;
  /** Adds a Ledger Entry to a Ledger. This Ledger Entry cannot be into a Linked Ledger Account. For that, use [reconcileTx](https://fragment.dev/api-reference/api-mutations#reconciletx) */
  addLedgerEntry: AddLedgerEntryResponse;
  /** Creates a custom currency.  */
  createCustomCurrency: CreateCustomCurrencyResponse;
  /** Custom Links let you integrate external systems that don't have native support. See [Custom Links](https://fragment.dev/guides/sync-payments#custom-link) */
  createCustomLink: CreateCustomLinkResponse;
  /** Creates a Ledger.  */
  createLedger: CreateLedgerResponse;
  createLedgerAccount: CreateLedgerAccountResponse;
  /** This API call is used to create Ledger Accounts. It is only used if you are not using a Schema. Unlike other mutations that take a single IK, 'createLedgerAccount' accepts an IK for each of the ledger accounts in the request payload. This is so you can recover in the case of a partial failure.  One API call can create up to 200 Ledger Accounts, up to 10 levels deep. */
  createLedgerAccounts: CreateLedgerAccountsResponse;
  /** Create a Payment. */
  createPayment: CreatePaymentResponse;
  /** Save a Payment Method for a User without charging it. */
  createPaymentMethodSetup: CreatePaymentMethodSetupResponse;
  /** Delete Txs on a Custom Link. Once deleted, a Tx will not show up in listing queries, but can be resolved by if you lookup by its Fragment ID. */
  deleteCustomTxs: DeleteCustomTxsResponse;
  /**
   * Delete a Ledger.
   *
   * After using the deleteLedger mutation you can re-use the ik in a new ledger after a 30 second wait.
   */
  deleteLedger: DeleteLedgerResponse;
  /** Delete a Payment Method saved for a User. */
  deletePaymentMethod: DeletePaymentMethodResponse;
  /** Delete a Schema */
  deleteSchema: DeleteSchemaResponse;
  /** Instantiates a Ledger Account from a template in the Ledger's Schema before any Ledger Entry is posted to it. Creates any missing templated ancestors. */
  instantiateLedgerAccount: InstantiateLedgerAccountResponse;
  /**
   * Migrate an existing Ledger Entry to a new type and typeVersion.
   *
   * Migrating a Ledger Entry will do the following:
   *   1. Reverse the existing Ledger Entry
   *   2. Post a new Ledger Entry with the new type, typeVersion, and parameters provided
   */
  migrateLedgerEntry: MigrateLedgerEntryResponse;
  /** This mutation is used to [reconcile](https://fragment.dev/guides/reconcile-payments#reconcile-a-tx) transactions from an external system into a Ledger Entry. This mutation does not require an idempotency key since a transaction can only be reconciled once per Linked Ledger Account.  If you are reconciling a transfer between two Link Accounts which are both linked to the same Ledger, use a transit account in between to split the transfer into two `reconcileTx` calls. */
  reconcileTx: ReconcileTxResponse;
  /** Reverses a Ledger Entry */
  reverseLedgerEntry: ReverseLedgerEntryResponse;
  /**
   * Stores a Schema in your workspace. If no Schema with the same key exists in your worksapce, a new Schema is created.
   * Else, the Schema is updated, and every Ledger associated with it is migrated to the latest version.
   */
  storeSchema: StoreSchemaResponse;
  /** Once you've created a [Custom Link](https://fragment.dev/guides/sync-payments#custom-link), create accounts under it using this mutation. Each Custom Account is an immutable, single-entry view of all the transactions in the external account. You can sync up to 100 Custom Accounts in one API call. */
  syncCustomAccounts: SyncCustomAccountsResponse;
  /** You can create transactions under a Custom Account in a [Custom Link](https://fragment.dev/guides/sync-payments#custom-link) using this mutation. Once you've imported transactions, you can use the reconcileTx mutation to add them to a Ledger via the Linked Ledger Account. You can sync up to 100 Custom Transactions in one API call. */
  syncCustomTxs: SyncCustomTxsResponse;
  /** Updates a Ledger. Currently, you can change only the Ledger 'name'. */
  updateLedger: UpdateLedgerResponse;
  /** Updates a ledger account. Only supports name right now. */
  updateLedgerAccount: UpdateLedgerAccountResponse;
  /** Update a ledger entry */
  updateLedgerEntry: UpdateLedgerEntryResponse;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationAddLedgerEntriesArgs = {
  entries: Array<AddLedgerEntryInput>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationAddLedgerEntryArgs = {
  entry: LedgerEntryInput;
  ik: Scalars['SafeString']['input'];
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationCreateCustomCurrencyArgs = {
  customCurrency: CreateCustomCurrencyInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationCreateCustomLinkArgs = {
  ik: Scalars['SafeString']['input'];
  name: Scalars['String']['input'];
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationCreateLedgerArgs = {
  ik: Scalars['SafeString']['input'];
  ledger: CreateLedgerInput;
  schema?: InputMaybe<SchemaMatchInput>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationCreateLedgerAccountArgs = {
  ik: Scalars['SafeString']['input'];
  ledger: LedgerMatchInput;
  ledgerAccount: CreateLedgerAccountInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationCreateLedgerAccountsArgs = {
  ledger: LedgerMatchInput;
  ledgerAccounts: Array<CreateLedgerAccountsInput>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationCreatePaymentArgs = {
  ik: Scalars['SafeString']['input'];
  ledger: LedgerMatchInput;
  payment: CreatePaymentInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationCreatePaymentMethodSetupArgs = {
  ik: Scalars['SafeString']['input'];
  ledger: LedgerMatchInput;
  user: UserMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationDeleteCustomTxsArgs = {
  txs: Array<Scalars['ID']['input']>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationDeleteLedgerArgs = {
  ledger: LedgerMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationDeletePaymentMethodArgs = {
  paymentMethod: PaymentMethodMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationDeleteSchemaArgs = {
  schema: SchemaMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationInstantiateLedgerAccountArgs = {
  ledger: LedgerMatchInput;
  parameters?: InputMaybe<Scalars['Parameters']['input']>;
  path: Scalars['String']['input'];
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationMigrateLedgerEntryArgs = {
  input: MigrateLedgerEntryInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationReconcileTxArgs = {
  entry: LedgerEntryInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationReverseLedgerEntryArgs = {
  id: Scalars['ID']['input'];
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationStoreSchemaArgs = {
  schema: SchemaInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationSyncCustomAccountsArgs = {
  accounts: Array<CustomAccountInput>;
  link: LinkMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationSyncCustomTxsArgs = {
  link: LinkMatchInput;
  txs: Array<CustomTxInput>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationUpdateLedgerArgs = {
  ledger: LedgerMatchInput;
  update: UpdateLedgerInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationUpdateLedgerAccountArgs = {
  ledgerAccount: LedgerAccountMatchInput;
  update: UpdateLedgerAccountInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-mutations) */
export type MutationUpdateLedgerEntryArgs = {
  ledgerEntry: LedgerEntryMatchInput;
  update: UpdateLedgerEntryInput;
};

/** Equivalent to an HTTP 404 */
export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  /** The status code of error. For example, 'ledger_not_found'. */
  code: Scalars['String']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether or not the operation is retryable */
  retryable: Scalars['Boolean']['output'];
};

/** An object containing [pagination](https://fragment.dev/guides/query-data#basics-pagination) details. */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A Payment posted to a Ledger. */
export type Payment = {
  __typename?: 'Payment';
  /** The amount of this Payment, in whole cents. */
  amount: Scalars['Int96']['output'];
  /** The credential the payments SDK presents to `confirmPayment`. */
  clientSecret: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /** The currency this Payment is denominated in. */
  currency: PaymentCurrency;
  /** The log of events that have occurred on this Payment, most recent first. */
  events: PaymentEventsConnection;
  /** The ID of this Payment. */
  id: Scalars['ID']['output'];
  /** The [Idempotency Key](https://fragment.dev/api-reference/api-overview#idempotency) the Payment was created with. */
  ik: Scalars['SafeString']['output'];
  /** The Ledger that this Payment belongs to. */
  ledger: Ledger;
  /** The mode of this Payment. Can be `sandbox` or `production`. */
  mode: PaymentMode;
  /** Parameters the Payment was created with. */
  parameters: Scalars['JSON']['output'];
  /** The status of this Payment. */
  status: PaymentStatus;
  /** The Payment Type in the Schema this Payment was created from. */
  type: Scalars['SafeString']['output'];
  /** The version of the Payment Type. */
  typeVersion: Scalars['Int']['output'];
};

/** The payer abandoned or failed the 3DS check. */
export type PaymentCard3DsCanceledEvent = PaymentEvent & {
  __typename?: 'PaymentCard3DSCanceledEvent';
  /** The ID of this Payment event. */
  id: Scalars['ID']['output'];
  /** When this event occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The status of the Payment after this event. */
  status: PaymentStatus;
};

/** The card network captured the Payment. */
export type PaymentCardCapturedEvent = PaymentEvent & {
  __typename?: 'PaymentCardCapturedEvent';
  /** The ID of this Payment event. */
  id: Scalars['ID']['output'];
  /** The `initiated` Ledger Entry, `null` where the Payment Type defines none. */
  ledgerEntry?: Maybe<LedgerEntry>;
  /** When this event occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The status of the Payment after this event. */
  status: PaymentStatus;
};

/** The card was declined, or the charge refused. */
export type PaymentCardDeclinedEvent = PaymentEvent & {
  __typename?: 'PaymentCardDeclinedEvent';
  /** The ID of this Payment event. */
  id: Scalars['ID']['output'];
  /** When this event occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The status of the Payment after this event. */
  status: PaymentStatus;
};

/** The payer went through checkout. */
export type PaymentCheckoutEvent = PaymentEvent & {
  __typename?: 'PaymentCheckoutEvent';
  /** The ID of this Payment event. */
  id: Scalars['ID']['output'];
  /** When this event occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The status of the Payment after this event. */
  status: PaymentStatus;
};

/** The Payment was created. */
export type PaymentCreatedEvent = PaymentEvent & {
  __typename?: 'PaymentCreatedEvent';
  /** The ID of this Payment event. */
  id: Scalars['ID']['output'];
  /** When this event occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The status of the Payment after this event. */
  status: PaymentStatus;
};

/** The currency a Payment is denominated in. */
export type PaymentCurrency = {
  __typename?: 'PaymentCurrency';
  /** The currency code. */
  code: PaymentCurrencyCode;
  /** A human readable name for the currency (e.g. United States Dollar). This is used for display purposes. */
  name: Scalars['String']['output'];
  /** The number of decimal places this currency goes to. For example, United States Dollars have a precision of 2 (i.e. 100 cents in a dollar), whereas the Jordanian Dinar has a precision of 3. This is used for display purposes. */
  precision: Scalars['Int']['output'];
};

/** The currencies a Payment can be denominated in. */
export enum PaymentCurrencyCode {
  Usd = 'USD',
}

/** Something that happened to a Payment. */
export type PaymentEvent = {
  /** The ID of this Payment event. */
  id: Scalars['ID']['output'];
  /** When this event occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The status of the Payment after this event. */
  status: PaymentStatus;
};

/** A paginated list of Payment events. */
export type PaymentEventsConnection = {
  __typename?: 'PaymentEventsConnection';
  /** The current page of results. */
  nodes: Array<
    | PaymentCard3DsCanceledEvent
    | PaymentCardCapturedEvent
    | PaymentCardDeclinedEvent
    | PaymentCheckoutEvent
    | PaymentCreatedEvent
    | PaymentSettledEvent
  >;
  /** The pagination info for this list. */
  pageInfo: PageInfo;
};

/** Specify a Payment by `id`, or by `ledger` and `ik`. */
export type PaymentMatchInput = {
  /** The FRAGMENT ID of the Payment. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The Idempotency Key the Payment was created with. */
  ik?: InputMaybe<Scalars['SafeString']['input']>;
  /** The Ledger the Payment belongs to. */
  ledger?: InputMaybe<LedgerMatchInput>;
};

/** A payment method saved for a User. */
export type PaymentMethod = {
  /** When the payment method was saved. */
  created: Scalars['DateTime']['output'];
  /** FRAGMENT ID of the saved Payment Method. */
  id: Scalars['ID']['output'];
  /** The user who owns this payment method. */
  user: User;
};

/** Specify a saved Payment Method by its ID. */
export type PaymentMethodMatchInput = {
  /** FRAGMENT ID of the Payment Method. */
  id: Scalars['ID']['input'];
};

/** An attempt to save the Payment Method for a User. */
export type PaymentMethodSetup = {
  __typename?: 'PaymentMethodSetup';
  /** The credential to provide to the `<PaymentMethodSetupSession>` component in the Fragment Elements SDK. */
  clientSecret: Scalars['String']['output'];
  /** When the Payment Method Setup was created. */
  created: Scalars['DateTime']['output'];
  /** The currency the saved payment method will be charged in. */
  currency: PaymentCurrency;
  /** The Fragment ID of this Payment Method Setup. */
  id: Scalars['ID']['output'];
  /** The [Idempotency Key](https://fragment.dev/api-reference/api-overview#idempotency) the Payment Method Setup was created with. */
  ik: Scalars['SafeString']['output'];
  /** Whether this Payment Method Setup was created in sandbox or production. */
  mode: PaymentMode;
  /** The Payment Method this setup saved, once its status is `saved`. */
  paymentMethod?: Maybe<CardPaymentMethod>;
  /** The status of this Payment Method Setup. */
  status: PaymentMethodSetupStatus;
};

/** Specify a Payment Method Setup by using `id`, or `ik` and `ledger`, or all three when they name the same Payment Method Setup. */
export type PaymentMethodSetupMatchInput = {
  /** The FRAGMENT ID of the Payment Method Setup. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The IK passed to `createPaymentMethodSetup`. Required if you have not provided `id`. */
  ik?: InputMaybe<Scalars['SafeString']['input']>;
  /** The Ledger the Payment Method Setup belongs to. Required if you have not provided `id`. */
  ledger?: InputMaybe<LedgerMatchInput>;
};

/** Status of a Payment Method Setup. */
export enum PaymentMethodSetupStatus {
  Canceled = 'canceled',
  NeedsAction = 'needs_action',
  NeedsPaymentMethod = 'needs_payment_method',
  Processing = 'processing',
  Saved = 'saved',
}

/** A list of Payment Methods, all in one page. */
export type PaymentMethodsConnection = {
  __typename?: 'PaymentMethodsConnection';
  /** Every Payment Method in the list. */
  nodes: Array<CardPaymentMethod>;
  /** The pagination info for this list. It never reports another page. */
  pageInfo: PageInfo;
};

/** Filter the list of saved Payment Methods returned. */
export type PaymentMethodsFilterSet = {
  /** Filter by the User the Payment Method belongs to. */
  user: UserFilter;
};

/** Mode of a Payment. */
export enum PaymentMode {
  Production = 'production',
  Sandbox = 'sandbox',
}

/** The Payment settled. */
export type PaymentSettledEvent = PaymentEvent & {
  __typename?: 'PaymentSettledEvent';
  /** The ID of this Payment event. */
  id: Scalars['ID']['output'];
  /** The `settled` Ledger Entry. */
  ledgerEntry: LedgerEntry;
  /** When this event occurred. */
  occurredAt: Scalars['DateTime']['output'];
  /** The status of the Payment after this event. */
  status: PaymentStatus;
};

/** Status of a Payment. */
export enum PaymentStatus {
  Accepted = 'accepted',
  NeedsPaymentMethod = 'needs_payment_method',
  Processing = 'processing',
  Settled = 'settled',
}

/** Filters a result set by Payment status. */
export type PaymentStatusFilter = {
  /** Results must have the specified status. */
  equalTo?: InputMaybe<PaymentStatus>;
  /** Results can have any of the specified statuses. */
  in?: InputMaybe<Array<PaymentStatus>>;
};

/** A paginated list of Payments. */
export type PaymentsConnection = {
  __typename?: 'PaymentsConnection';
  /** The current page of results. */
  nodes: Array<Payment>;
  /** The pagination info for this list. */
  pageInfo: PageInfo;
};

/** The filters that can be applied to a list of Payments. */
export type PaymentsFilterSet = {
  /** Use this filter to filter Payments by their `created` timestamp. */
  created?: InputMaybe<DateTimeFilter>;
  /** Use this to filter Payments by their status. */
  status?: InputMaybe<PaymentStatusFilter>;
};

/**
 * Controls how lines are posted for a Ledger Entry.
 * New entries created via the dashboard default to `net_amounts`.
 * Existing entries without this field set are treated as `raw_lines`.
 */
export enum PostLinesAs {
  /** Lines targeting the same account, currency, and tx are aggregated into a single line with the net amount. Lines that sum to zero are skipped. If all lines sum to zero, no lines are skipped. */
  NetAmounts = 'net_amounts',
  /** Lines are posted as-is without aggregation. */
  RawLines = 'raw_lines',
  /** Lines with a zero amount are skipped, but lines are not aggregated. If all lines have a zero amount, no lines are skipped. */
  SkipZeroLines = 'skip_zero_lines',
}

/**
 * The posted timestamp window for a clearing account, representing the earliest and latest
 * posted timestamps across all currencies.
 */
export type PostedWindow = {
  __typename?: 'PostedWindow';
  /** The earliest posted timestamp across all currencies for this clearing account. */
  earliest: Scalars['DateTime']['output'];
  /** The latest posted timestamp across all currencies for this clearing account. */
  latest: Scalars['DateTime']['output'];
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  /** Query Custom Currencies in the workspace */
  customCurrencies: CustomCurrenciesConnection;
  /** Get External Account by Link and External ID or FRAGMENT ID. */
  externalAccount?: Maybe<ExternalAccount>;
  /** Get a Ledger by ID */
  ledger?: Maybe<Ledger>;
  /** Get a Ledger Account by ID */
  ledgerAccount?: Maybe<LedgerAccount>;
  /** Get Ledger Entry by ID. */
  ledgerEntry?: Maybe<LedgerEntry>;
  /** Query a Ledger Entry Group given its Ledger, key, and value. */
  ledgerEntryGroup?: Maybe<LedgerEntryGroup>;
  /** Get the reversal history of a Ledger Entry. */
  ledgerEntryHistory: LedgerEntriesConnection;
  /** Get LedgerLine by ID */
  ledgerLine?: Maybe<LedgerLine>;
  /** Query Ledgers in workspace. Ledgers are paginated and returned in reverse-chronological order by their created date. */
  ledgers: LedgersConnection;
  /** Get a Link by ID or a Custom Link by creation IK. Returns a BadRequestError if the Link is not found. */
  link?: Maybe<CustomLink | IncreaseLink | StripeLink | UnitLink>;
  /** Get all links in a workspace */
  links: LinksConnection;
  /** Get a single Payment by its ID or Idempotency Key in a Ledger. */
  payment?: Maybe<Payment>;
  /** Get a Payment Method saved for a User. */
  paymentMethod?: Maybe<CardPaymentMethod>;
  /** Get a Payment Method Setup. */
  paymentMethodSetup: PaymentMethodSetup;
  /** List the Payment Methods a User saved in a Ledger, newest first. Deleted Payment Methods are not listed. */
  paymentMethods: PaymentMethodsConnection;
  /** Get a Schema by key. */
  schema?: Maybe<Schema>;
  /** Retrieve all of the Schemas in the workspace. */
  schemas: SchemaConnection;
  /** Get a Tx by ID */
  tx?: Maybe<Tx>;
  /** Get the current Workspace */
  workspace: Workspace;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryCustomCurrenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryExternalAccountArgs = {
  externalAccount: ExternalAccountMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLedgerArgs = {
  ledger: LedgerMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLedgerAccountArgs = {
  ledgerAccount: LedgerAccountMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLedgerEntryArgs = {
  ledgerEntry: LedgerEntryMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLedgerEntryGroupArgs = {
  ledgerEntryGroup: LedgerEntryGroupMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLedgerEntryHistoryArgs = {
  ledgerEntry: LedgerEntryMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLedgerLineArgs = {
  ledgerLine: LedgerLineMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLedgersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgersFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryLinkArgs = {
  link: LinkMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryPaymentArgs = {
  payment: PaymentMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryPaymentMethodArgs = {
  paymentMethod: PaymentMethodMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryPaymentMethodSetupArgs = {
  paymentMethodSetup: PaymentMethodSetupMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: PaymentMethodsFilterSet;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QuerySchemaArgs = {
  schema: SchemaMatchInput;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QuerySchemasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** View the API guide [here](https://fragment.dev/api-reference/api-queries) */
export type QueryTxArgs = {
  tx: TxMatchInput;
};

/** The consistency configuration of a Ledger Account's balance queries. If not provided as an argument to a balance query, the default behavior is to read eventually consistent balances. See [Configure consistency](https://fragment.dev/guides/configure-consistency). */
export enum ReadBalanceConsistencyMode {
  /** Balance queries will read eventually consistent balances. This is the default behavior if `ReadBalanceConsistencyMode` is not provided as an argument to the balance field. Both Ledger Accounts configured with strongly and eventually consistent balance updates support this enum. */
  Eventual = 'eventual',
  /** Balance queries will read strongly consistent balances. This is only allowed if the Ledger Account's `ownBalanceUpdates` in its `consistencyConfig` is `strong`. */
  Strong = 'strong',
  /** Balance queries will use the value from the Ledger Account's `ownBalanceUpdates` in its `consistencyConfig`. */
  UseAccount = 'use_account',
}

export type ReconcileTxResponse = BadRequestError | InternalError | ReconcileTxResult;

export type ReconcileTxResult = {
  __typename?: 'ReconcileTxResult';
  /** The ledger entry that was posted */
  entry: LedgerEntry;
  /** True if this request successfully completed before and the previous response is being returned */
  isIkReplay: Scalars['Boolean']['output'];
  /** The ledger lines that were created in that entry */
  lines: Array<LedgerLine>;
};

/** Reconciliation counts grouped by age, measured from endTime. */
export type ReconciliationReport = {
  __typename?: 'ReconciliationReport';
  /** Time of the request; the exclusive cutoff used to compute interval boundaries. */
  endTime: Scalars['DateTime']['output'];
  /** Unit used to compute interval boundaries. */
  granularity: Granularity;
  /** Intervals ordered youngest first. The final interval has no lower time bound. */
  intervals: Array<AgingInterval>;
};

export type ReverseLedgerEntryResponse = BadRequestError | InternalError | ReverseLedgerEntryResult;

export type ReverseLedgerEntryResult = {
  __typename?: 'ReverseLedgerEntryResult';
  /** Whether the reversal was an IK replay */
  isIkReplay: Scalars['Boolean']['output'];
  /** The Ledger Entry that was reversed */
  reversedLedgerEntry: LedgerEntry;
  /** The reversal Ledger Entry that was created */
  reversingLedgerEntry: LedgerEntry;
};

/** A simulated Ledger Entry posted as a part of a Scene. */
export type SceneEntryInput = {
  /** Any parameters to be used as inputs to this simulated Ledger Entry. */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** The type of the simulated Ledger Entry. Must match one of the types provided in schema.ledgerEntries.types. */
  type: Scalars['SafeString']['input'];
  /** The version of the Ledger Entry type. */
  typeVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type SceneEventInput = {
  /** The simulated Ledger Entry. Required when eventType is `entry`. */
  entry?: InputMaybe<SceneEntryInput>;
  /** The type of the Scene Event. */
  eventType: SceneEventType;
  /** The simulated Payment lifecycle transition. Required when eventType is `payment`. */
  payment?: InputMaybe<ScenePaymentEventInput>;
};

/** The kind of thing a Scene Event simulates. */
export enum SceneEventType {
  /** A simulated Ledger Entry. */
  Entry = 'entry',
  /** One lifecycle transition of a simulated Payment. */
  Payment = 'payment',
}

export type SceneInput = {
  /** The ordered simulated events that make up the Scene. */
  events: Array<SceneEventInput>;
  /** The human-readable name of the Scene. */
  name: Scalars['String']['input'];
  /** The simulated Payments the Scene's payment events reference. */
  payments?: InputMaybe<Array<ScenePaymentInput>>;
};

/**
 * One lifecycle transition of a simulated Payment, posted as a
 * part of a Scene.
 */
export type ScenePaymentEventInput = {
  /** The lifecycle transition this Scene Event posts. */
  event: SchemaPaymentAccountingEventKey;
  /** The Idempotency Key of the simulated Payment, as declared in scene.payments. */
  ik: Scalars['SafeString']['input'];
};

/**
 * A simulated Payment declared by a Scene. Its lifecycle events
 * reference it by `ik`, so one simulated Payment has exactly one set of
 * parameters.
 */
export type ScenePaymentInput = {
  /** The Idempotency Key of the simulated Payment. Unique within the Scene. */
  ik: Scalars['SafeString']['input'];
  /** Any parameters to be used as inputs to this simulated Payment. */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** The type of the simulated Payment. Must match one of the types provided in schema.payments.types. */
  type: Scalars['SafeString']['input'];
  /** The version of the Payment Type. */
  typeVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type Schema = {
  __typename?: 'Schema';
  /**
   * The identifier for a Schema.
   * `key` is unique to a Workspace.
   */
  key: Scalars['SafeString']['output'];
  /** The paginated list of ledgers the Schema has been applied to. */
  ledgers: LedgersConnection;
  /** The name of a Schema. It defaults to the `key` if not provided in your SchemaInput. */
  name: Scalars['String']['output'];
  /** The metadata for a specific SchemaVersion. */
  version: SchemaVersion;
  /** A paginated list of SchemaVersions. */
  versions: SchemaVersionConnection;
};

export type SchemaLedgersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SchemaVersionArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type SchemaVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition that must be met on a Ledger Account balance. The condition can be
 * either a `precondition` or `postcondition`.
 */
export type SchemaConditionInput = {
  /** A condition on the `ownBalance` of the Ledger Account. */
  ownBalance?: InputMaybe<SchemaInt96ConditionInput>;
  /** A condition on the `totalBalance` of the Ledger Account. */
  totalBalance?: InputMaybe<SchemaInt96ConditionInput>;
};

/** A paginated list of Schemas in a Workspace. */
export type SchemaConnection = {
  __typename?: 'SchemaConnection';
  /** The current page of results */
  nodes: Array<Schema>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

/**
 * The consistency configuration for entities created within Ledgers created by this Schema.
 *
 * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
 */
export type SchemaConsistencyConfigInput = {
  /**
   * The consistency mode for the Ledger Entries list query within Ledgers created by this Schema.
   *
   * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
   */
  entries?: InputMaybe<SchemaConsistencyMode>;
};

/**
 * The consistency modes available for entities created within this Schema.
 *
 * See [Configure consistency](https://fragment.dev/guides/configure-consistency).
 */
export enum SchemaConsistencyMode {
  /** Eventually consistent entity updates */
  Eventual = 'eventual',
  /** Strongly consistent entity updates */
  Strong = 'strong',
}

/**
 * Matches a Currency. Can be a built-in [CurrencyCode](https://fragment.dev/api-reference/api-types#scalars-and-enums-currencycode), custom Currency, or a parameterized string.
 * If you supply a parameterized string, you must pass in a valid CurrencyCode as a parameter when posting a Ledger Entry.
 */
export type SchemaCurrencyMatchInput = {
  /** The currency code. This must either be a [CurrencyCode](https://fragment.dev/api-reference/api-types#scalars-and-enums-currencycode) or a parameterized string that resolves to a CurrencyCode . */
  code: Scalars['ParameterizedString']['input'];
  /** The ID for a custom currency. This is specified when creating the custom currency using the [createCustomCurrency](https://fragment.dev/api-reference/api-mutations#createcustomcurrency) mutation. */
  customCurrencyId?: InputMaybe<Scalars['ParameterizedString']['input']>;
};

export type SchemaExternalAccountMatchInput = {
  /** The External systems's ID of the account */
  externalId?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The FRAGMENT ID of the external account */
  id?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The FRAGMENT ID of the link */
  linkId?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /**
   * The idempotency key of a CustomLink, expressed with a schema parameter. Requires linkType: CustomLink.
   * If linkId is also supplied, both must identify the same Link.
   */
  linkIk?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The type of Link this external account belongs to. Must be one of: IncreaseLink, UnitLink, CustomLink, or StripeLink. */
  linkType?: InputMaybe<LinkType>;
};

/** Input to the API for creating a Schema. */
export type SchemaInput = {
  /** The Chart of Accounts for the Schema. */
  chartOfAccounts: ChartOfAccountsInput;
  /** The consistency configuration for this Schema. */
  consistencyConfig?: InputMaybe<SchemaConsistencyConfigInput>;
  /** Any groups associated with this Schema. */
  groups?: InputMaybe<Array<GroupInput>>;
  /** The key of the Schema. This is a stable, unique identifier for the Schema. Uniqueness is enforced at the Workspace level. */
  key: Scalars['SafeString']['input'];
  /** The Ledger Entries to add to the Schema. */
  ledgerEntries?: InputMaybe<SchemaLedgerEntriesInput>;
  /** The human-readable name of the Schema. */
  name?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The Payment Types to add to the Schema. */
  payments?: InputMaybe<SchemaPaymentsInput>;
  /** Any scenes associated with this Schema. */
  scenes?: InputMaybe<Array<SceneInput>>;
};

/** A condition that must be met on a field. */
export type SchemaInt96ConditionInput = {
  /** Amount must be exactly equal to this value. You may not specify this alongside `gte` or `lte`. */
  eq?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** Amount must be greater than or equal to this value. */
  gte?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** Amount must be less than or equal to this value. */
  lte?: InputMaybe<Scalars['ParameterizedString']['input']>;
};

/**
 * Models a Ledger Account in a Schema.
 * Upon successfully storing a [Schema](https://fragment.dev/api-reference/api-types#core-types-schema), a [LedgerAccount](https://fragment.dev/api-reference/api-types#core-types-ledgeraccount) will be created for
 * each corresponding non-templated `SchemaLedgerAccountInput` in your Chart of Accounts.
 */
export type SchemaLedgerAccountInput = {
  /** Ledger Accounts to create as children of this Ledger Account. Ledger Accounts may be nested up to a maximum depth of 10. */
  children?: InputMaybe<Array<SchemaLedgerAccountInput>>;
  /**
   * EXPERIMENTAL: Whether or not this Ledger Account is a Clearing Account.
   * Clearing Accounts have balances that should tend to zero. They are used to track in-progress workflows and payments.
   */
  clearing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The consistency configuration for this ledger account. See [Configure consistency](https://fragment.dev/guides/configure-consistency). */
  consistencyConfig?: InputMaybe<LedgerAccountConsistencyConfigInput>;
  /**
   * The currency of this Ledger Account. If this is not set, and `currencyMode` is
   * not set to `multi`, it is derived from the Chart of Accounts' default.
   */
  currency?: InputMaybe<SchemaCurrencyMatchInput>;
  /** If set to `multi`, creates a multi-currency Ledger Account. If set to `single`, creates a single-currency Ledger Account. */
  currencyMode?: InputMaybe<CurrencyMode>;
  /**
   * The key of this Ledger Account. Keys are used to formulate the unique path of the Ledger Account in your Chart of Accounts.
   * Siblings must have unique keys.
   */
  key: Scalars['SafeString']['input'];
  /**
   * The External Account to link to this Ledger Account.
   * It must be provided of `linked` is true.
   */
  linkedAccount?: InputMaybe<SchemaExternalAccountMatchInput>;
  /** The human-readable name of this Ledger Account. */
  name?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** Marks this as a Payment Account. */
  payment?: InputMaybe<SchemaPaymentInput>;
  /** The status of this Ledger Account. Defaults to active. */
  status?: InputMaybe<SchemaLedgerAccountStatus>;
  /** Whether or not this Ledger Account should be templated. */
  template?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of ledger account to create. Required if this is a top-level Ledger Account. If not provided, the type will be inferred from the parent. */
  type?: InputMaybe<LedgerAccountTypes>;
};

/** Matches a Ledger Account in a Schema. */
export type SchemaLedgerAccountMatchInput = {
  /**
   * The unique path of the Ledger Account in the Schema.
   * This is a slash-delimited string containing the keys of a Ledger Account and all its direct ancestors.
   * ex: expense-root/subscriptions/netflix
   * For Templated Ledger Accounts, you must supply a parameter in the path that will be used to name an instance of the template.
   * ex: `"expense-root/subscriptions/vendor:{{vendor_name}}"`
   */
  path: Scalars['ParameterizedString']['input'];
};

/** The status of a Ledger Account. */
export enum SchemaLedgerAccountStatus {
  /** The Ledger Account is active. */
  Active = 'active',
  /** The Ledger Account is archived. */
  Archived = 'archived',
  /** The Ledger Account is disabled. */
  Disabled = 'disabled',
}

/** The Ledger Entries in your Schema. */
export type SchemaLedgerEntriesInput = {
  /** A list of Ledger Entry definitions. */
  types: Array<SchemaLedgerEntryInput>;
};

/** A condition that must be met on a Ledger Account when a Ledger Entry is posted. */
export type SchemaLedgerEntryConditionInput = {
  /** The Ledger Account to apply the condition to. */
  account: SchemaLedgerAccountMatchInput;
  /**
   * The currency of the balance to apply the condition to. Required if the Ledger Account matched is a multi-currency Ledger Account.
   * Otherwise, this field is defaults to the Ledger Account's currency.
   */
  currency?: InputMaybe<SchemaCurrencyMatchInput>;
  /** A `postcondition` must be met after the Ledger Entry updates are applied. */
  postcondition?: InputMaybe<SchemaConditionInput>;
  /** A `precondition` must be met before any Ledger Entry updates are applied. */
  precondition?: InputMaybe<SchemaConditionInput>;
  /**
   * Repeated expansion configuration. When set, this condition is expanded at runtime for each element
   * in the array parameter named by the key.
   */
  repeated?: InputMaybe<SchemaRepeatedConfigInput>;
};

/** A Ledger Entry Group associated with a Ledger Entry type. */
export type SchemaLedgerEntryGroupInput = {
  /** The key for this Ledger Entry Group. */
  key: Scalars['SafeString']['input'];
  /** The value associated with this Ledger Entry Group. */
  value: Scalars['ParameterizedString']['input'];
};

/** A Ledger Entry in a Schema. All Ledger Entries defined in a Schema must have a unique `type`. */
export type SchemaLedgerEntryInput = {
  /** Conditions that must be satisfied to post this Ledger Entry. The Ledger Entry will reject with a BadRequestError if any condition is not met. You can only add a condition on a Ledger Account containing a Line in this Ledger Entry. */
  conditions?: InputMaybe<Array<SchemaLedgerEntryConditionInput>>;
  /** Human-readable description of the Ledger Entry. */
  description?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** Ledger Entries posted with this type will be in these Ledger Entry Groups. */
  groups?: InputMaybe<Array<SchemaLedgerEntryGroupInput>>;
  /**
   * The Ledger Lines in the Ledger Entry.
   * If provided, when posting a Typed Entry, a [LedgerEntry](https://fragment.dev/api-reference/api-types#core-types-ledgerline) will be posted containing [LedgerLines](https://fragment.dev/api-reference/api-types#core-types-ledgerline) corresponding
   * to the values you provide here. If your lines contain parameters, you must supply values for those parameters that balance out the Ledger Entry. If not provided, lines will be required when posting a Typed Entry.
   */
  lines?: InputMaybe<Array<SchemaLedgerLineInput>>;
  /** Fixed partial set of parameters to be included in a templated Ledger Entry. */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** Controls how lines are posted. When set to `net_amounts`, all lines targeting the same account, currency, and tx are aggregated into a single line with the net amount, and lines that sum to zero are skipped. When set to `skip_zero_lines`, lines with a zero amount are skipped but not aggregated. In both modes, if all lines are zero, no lines are skipped. When set to `raw_lines`, lines are posted as-is without aggregation. New entries created via the dashboard default to `net_amounts`. Existing entries without this field set are treated as `raw_lines`. */
  postLinesAs?: InputMaybe<PostLinesAs>;
  /** The status of this Ledger Entry. Defaults to active. */
  status?: InputMaybe<SchemaLedgerEntryStatus>;
  /** Ledger Entries posted with this type will be associated with these tags. */
  tags?: InputMaybe<Array<SchemaLedgerEntryTagInput>>;
  /**
   * The type of this Ledger Entry. This is a stable, unique identifier for this entry. Uniqueness is enforced at the Schema level.
   * You can filter on this field when querying for Ledger Entries. See the docs on [LedgerEntryFilterSet](https://fragment.dev/api-reference/api-types#filter-types-ledgerentriesfilterset)
   */
  type: Scalars['SafeString']['input'];
  /** The version of the Ledger Entry type. */
  typeVersion?: InputMaybe<Scalars['Int']['input']>;
};

/** The status of a Ledger Entry. */
export enum SchemaLedgerEntryStatus {
  /** The Ledger Entry is active. */
  Active = 'active',
  /** The Ledger Entry is archived. */
  Archived = 'archived',
  /** The Ledger Entry is disabled. */
  Disabled = 'disabled',
}

/** A tag associated with a Ledger Entry type. */
export type SchemaLedgerEntryTagInput = {
  /** The key for this tag. */
  key: Scalars['SafeString']['input'];
  /** The value associated with the given key for this tag. */
  value: Scalars['ParameterizedString']['input'];
};

/** A Ledger Line in a Ledger Entry. */
export type SchemaLedgerLineInput = {
  /**
   * The Ledger Account this Ledger Line will be posted to.
   * It supports parameters in its attributes via handlebars syntax.
   */
  account: SchemaLedgerAccountMatchInput;
  /** The amount of the Ledger Line. It supports parameters via the handlebars syntax and addition (+) and subtraction (-). */
  amount?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /**
   * The currency of the Ledger Line. This is required if the Ledger Account has currencyMode multi.
   * It supports parameters in its attributes via handlebars syntax.
   */
  currency?: InputMaybe<SchemaCurrencyMatchInput>;
  /** Human-readable description of the line. */
  description?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The key for the Ledger Line. Ledger Line keys must be unique within a Ledger Entry. Key can be filtered on as part of the LedgerLinesFilterSet. */
  key: Scalars['SafeString']['input'];
  /**
   * Repeated expansion configuration. When set, this line is expanded at runtime for each element
   * in the array parameter named by the key.
   */
  repeated?: InputMaybe<SchemaRepeatedConfigInput>;
  /** Tags to attach to this Ledger Line. Supports parameterized values via handlebars syntax. */
  tags?: InputMaybe<Array<SchemaLedgerEntryTagInput>>;
  /**
   * The external transaction to reconcile.
   * This field is required if the Ledger Account being posted to is a Linked Ledger Account. Otherwise, this field is disallowed.
   * It supports parameters in its attributes via handlebars syntax.
   *
   * See the docs on [reconciling payments](https://fragment.dev/guides/reconcile-payments).
   */
  tx?: InputMaybe<SchemaTxMatchInput>;
};

/** An object used to retrieve a Schema. */
export type SchemaMatchInput = {
  /**
   * The key to retrieve a Schema by.
   * `key` is unique to a Workspace.
   */
  key: Scalars['SafeString']['input'];
  /** Optional parameter to specify version of requested Schema. If not provided, it defaults to 0, representing the latest available version for the provided Schema key. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** A lifecycle transition of a Payment. */
export enum SchemaPaymentAccountingEventKey {
  /** The payment was captured and is guaranteed to settle. */
  Initiated = 'initiated',
  /** EXPERIMENTAL: An initiated refund failed. */
  RefundFailed = 'refund_failed',
  /** EXPERIMENTAL: A refund of the settled payment is initiated. */
  RefundInitiated = 'refund_initiated',
  /** The payment settled. */
  Settled = 'settled',
}

/**
 * The Ledger Entries a Payment Type posts as a payment moves
 * through its lifecycle, keyed by lifecycle transition.
 */
export type SchemaPaymentAccountingInput = {
  /** Posted when the payment is captured. Optional. */
  initiated?: InputMaybe<SchemaPaymentEntryInput>;
  /** EXPERIMENTAL: Posted when an initiated refund fails. Optional. */
  refund_failed?: InputMaybe<SchemaPaymentEntryInput>;
  /** EXPERIMENTAL: Posted when a refund of the settled payment is initiated. Optional. */
  refund_initiated?: InputMaybe<SchemaPaymentEntryInput>;
  /** Posted when the payment settles. Every Payment Type must define it. */
  settled: SchemaPaymentEntryInput;
};

/** The Ledger Entry a Payment Type posts on a payment lifecycle event. */
export type SchemaPaymentEntryInput = {
  /** Human-readable description of the payment entry. */
  description?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The Ledger Lines in the payment entry. */
  lines: Array<SchemaPaymentLineInput>;
};

/** Marks a Ledger Account as a Payment Account. */
export type SchemaPaymentInput = {
  enabled: Scalars['Boolean']['input'];
};

/** A Ledger Line in a payment entry. */
export type SchemaPaymentLineInput = {
  /**
   * The Ledger Account this line will be posted to.
   * It supports parameters in its attributes via handlebars syntax.
   */
  account: SchemaLedgerAccountMatchInput;
  /** The amount of the line. It supports parameters via the handlebars syntax and addition (+) and subtraction (-). */
  amount: Scalars['ParameterizedString']['input'];
  /**
   * The currency of the line. This is required if the Ledger Account has currencyMode multi.
   * It supports parameters in its attributes via handlebars syntax.
   */
  currency?: InputMaybe<SchemaCurrencyMatchInput>;
  /** Human-readable description of the line. */
  description?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The key for the line. Keys must be unique within a payment entry. */
  key: Scalars['SafeString']['input'];
  /**
   * Marks this as a system-owned line. Fragment fills the amounts of system
   * lines when the payment entry is posted.
   */
  system?: InputMaybe<SchemaSystemLineKind>;
};

/** The payment a Payment Type creates. */
export type SchemaPaymentTypeDetailsInput = {
  /**
   * The amount requested for the payment, as a parameterized expression filled
   * from createPayment parameters.
   */
  amount: Scalars['ParameterizedString']['input'];
  /** The direction the payment moves money. */
  direction: SchemaPaymentTypeDirection;
};

/** The direction a Payment Type moves money. */
export enum SchemaPaymentTypeDirection {
  /** Money moves into the Payment Account. */
  Payin = 'payin',
  /** Money moves out of the Payment Account. */
  Payout = 'payout',
}

/**
 * A Payment Type in a Schema. All Payment Types defined in a
 * Schema must have a unique `type` and `typeVersion` pair.
 */
export type SchemaPaymentTypeInput = {
  /** The Ledger Entries posted as the payment moves through its lifecycle. */
  accounting: SchemaPaymentAccountingInput;
  /** The payment this Payment Type creates. */
  payment: SchemaPaymentTypeDetailsInput;
  /** The status of this Payment Type. */
  status: SchemaPaymentTypeStatus;
  /**
   * The type of this Payment Type. This is a stable, unique identifier for it.
   * Uniqueness is enforced at the Schema level.
   */
  type: Scalars['SafeString']['input'];
  /** The version of the Payment Type. */
  typeVersion: Scalars['Int']['input'];
};

/** The status of a Payment Type. */
export enum SchemaPaymentTypeStatus {
  /** The Payment Type is active. */
  Active = 'active',
}

/** The Payment Types in your Schema. */
export type SchemaPaymentsInput = {
  /** A list of Payment Type definitions. */
  types: Array<SchemaPaymentTypeInput>;
};

/**
 * Configuration for repeated expansion of a line or condition. The key names a client-supplied
 * array parameter whose elements each generate one copy of the line or condition at runtime.
 */
export type SchemaRepeatedConfigInput = {
  /** The key of the array parameter whose elements expand this line or condition. */
  key: Scalars['SafeString']['input'];
};

/**
 * Identifies a system-owned line in a payment entry. The amounts of system
 * lines are filled by Fragment when the payment entry is posted.
 */
export enum SchemaSystemLineKind {
  /** The line carrying the Fragment fee amount, posted to the Payment Account. */
  PaymentFeeLine = 'payment_fee_line',
  /** The line removing the refund amount from the Payment Account when a Refund is initiated. */
  PaymentRefundLine = 'payment_refund_line',
  /** The line restoring the refund amount to the Payment Account when a Refund fails. */
  PaymentRefundReversalLine = 'payment_refund_reversal_line',
  /** The line carrying the settled payment amount, posted to the Payment Account. */
  PaymentSettlementLine = 'payment_settlement_line',
}

/**
 * Matches a transaction at an external system.
 * This is used to specify the transaction being reconciled into a Linked Ledger Account
 */
export type SchemaTxMatchInput = {
  /** The external system's ID for the transaction. */
  externalId?: InputMaybe<Scalars['ParameterizedString']['input']>;
  /** The FRAGMENT ID for the transaction. */
  id?: InputMaybe<Scalars['ParameterizedString']['input']>;
};

/**
 * An instance of a Schema stored in a Workspace.
 * A new SchemaVersion is created each time a Schema is stored.
 * It stores the Chart of Accounts and list of Ledger Entries as well as a history of its Ledger migrations.
 */
export type SchemaVersion = {
  __typename?: 'SchemaVersion';
  created: Scalars['DateTime']['output'];
  json: Scalars['JSON']['output'];
  migrations: LedgerMigrationConnection;
  /** The version of the schema. */
  version: Scalars['Int']['output'];
};

/** A paginated list of SchemaVersions for a given Schema. */
export type SchemaVersionConnection = {
  __typename?: 'SchemaVersionConnection';
  /** The current page of results */
  nodes: Array<SchemaVersion>;
  /** Pagination info for this list. */
  pageInfo: PageInfo;
};

/** Returned by the [storeSchema](https://fragment.dev/api-reference/api-mutations#storeschema) mutation. */
export type StoreSchemaResponse = BadRequestError | InternalError | StoreSchemaResult;

/** `StoreSchemaResult` represents a successful execution of `storeSchema`. */
export type StoreSchemaResult = {
  __typename?: 'StoreSchemaResult';
  /** The Schema that was stored as a result of calling `storeSchema`. */
  schema: Schema;
};

export type StringFilter = {
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Must match one of the values provided. Limited to 100 items maximum. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Must not equal this string value */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Must not match any of the values provided. Limited to 100 items maximum. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StringMatchFilter = {
  /** Must contain the provided pattern somewhere within the string. For example, 'contains: hat' will match 'hat', 'chat', and 'hate'. */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Must exactly equal the provided value */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Must exactly equal one of the provided values. Limited to 100 items maximum. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Must match the provided pattern. Wildcards ("*") will match any substring */
  matches?: InputMaybe<Scalars['String']['input']>;
  /** Must match any one of the provided `matches` patterns, OR-ed together — results are returned as a single paginated list. Each entry uses the same wildcard grammar as `matches`. Cannot be combined with `matches`. Limited to 100 entries. */
  matchesAny?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum StripeEnv {
  Livemode = 'livemode',
  Testmode = 'testmode',
}

export type StripeLink = Link & {
  __typename?: 'StripeLink';
  /** ISO-8601 timestamp when the Link was created. */
  created: Scalars['String']['output'];
  /** URL to the Fragment Dashboard for this Link. */
  dashboardUrl: Scalars['String']['output'];
  /** A list of External Accounts associated with this Link. */
  externalAccounts: ExternalAccountsConnection;
  /** FRAGMENT ID of the Custom Link. */
  id: Scalars['ID']['output'];
  /** Name of the Link as it appears in the Fragment Dashboard. */
  name: Scalars['String']['output'];
  /** The environment of the Stripe Link, either testmode or livemode. */
  stripeEnv: StripeEnv;
};

export type SyncCustomAccountsResponse = BadRequestError | InternalError | SyncCustomAccountsResult;

export type SyncCustomAccountsResult = {
  __typename?: 'SyncCustomAccountsResult';
  /** The external accounts that were synced. */
  accounts: Array<ExternalAccount>;
};

export type SyncCustomTxsResponse = BadRequestError | InternalError | SyncCustomTxsResult;

export type SyncCustomTxsResult = {
  __typename?: 'SyncCustomTxsResult';
  txs: Array<Tx>;
};

/** Filters a result set based on the tags it contains. */
export type TagFilter = {
  /** Matches entries that have ALL of the specified tags. The key and value are both matched exactly. Limited to 10 items maximum. */
  all?: InputMaybe<Array<TagMatchInput>>;
  /** Matches tag values based on the existence of the provided string within the tag value. The key is matched exactly. */
  contains?: InputMaybe<TagMatchInput>;
  /** Matches tags based on the exact value provided. The key and value are both matched exactly. */
  equalTo?: InputMaybe<TagMatchInput>;
  /** Matches tags based on a list of possible tag matches. The key and value are both matched exactly. Limited to 100 items maximum. */
  in?: InputMaybe<Array<TagMatchInput>>;
  /** Matches tags where the key exactly equals the provided value. */
  keyEqualTo?: InputMaybe<Scalars['SafeString']['input']>;
  /** Matches tags where the key matches any of the provided values. Limited to 100 items maximum. */
  keyIn?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** Matches tags that do not equal the provided value. The key and value are both matched exactly. */
  notEqualTo?: InputMaybe<TagMatchInput>;
  /** Matches tags that do not match any of the provided values. The key and value are both matched exactly. Limited to 100 items maximum. */
  notIn?: InputMaybe<Array<TagMatchInput>>;
  /** Matches tags where the key does not equal the provided value. */
  notKeyEqualTo?: InputMaybe<Scalars['SafeString']['input']>;
  /** Matches tags where the key does not match any of the provided values. Limited to 100 items maximum. */
  notKeyIn?: InputMaybe<Array<Scalars['SafeString']['input']>>;
};

/** Specifies a single tag that an entity is expected to have. You must specify both the key and the value. */
export type TagMatchInput = {
  /** The key of this tag. */
  key: Scalars['SafeString']['input'];
  /** The value associated with this tag's key. */
  value: Scalars['SafeString']['input'];
};

export type Tx = {
  __typename?: 'Tx';
  /** FRAGMENT ID of this transaction's external account */
  accountId: Scalars['ID']['output'];
  /** Integer amount in cents. Positive indicates money entering the external account, negative indicates money leaving */
  amount: Scalars['Int96']['output'];
  /** Currency of this Tx */
  currency?: Maybe<Currency>;
  /** Date this Tx posted to the external account */
  date: Scalars['Date']['output'];
  /** ISO-8601 timestamp when this Tx was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Description at the external account */
  description: Scalars['String']['output'];
  /** The External Account that this transaction belongs to. */
  externalAccount: ExternalAccount;
  /** ID in the external system of this transaction's external account */
  externalAccountId: Scalars['ID']['output'];
  /** ID of this transaction in the external system */
  externalId: Scalars['ID']['output'];
  /** FRAGMENT ID of this Tx. If you delete a Tx via deleteCustomTxs, it will not show up in listing queries, but can be resolved by if you lookup by its Fragment ID. If you resync a Tx with the same externalId, its Fragment ID will be different than the previous Tx. */
  id: Scalars['ID']['output'];
  /** Whether this Tx has been deleted via deleteCustomTxs */
  isDeleted: Scalars['Boolean']['output'];
  /** Returns ledger entries that are linked to this transaction. You can link the same external account to multiple ledgers, so there could be multiple entries associated with one transaction - one for each linked ledger account this transaction has been reconciled with */
  ledgerEntries: LedgerEntriesConnection;
  /** Same as ledgerEntries, but returns an array of IDs instead */
  ledgerEntryIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Same as ledgerLines, but returns an array of IDs instead */
  ledgerLineIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Returns ledger lines that are linked to this transaction. You can link the same external account to multiple ledgers, so there could be multipe lines associated with one transaction - one for each linked ledger account this transaction has been reconciled with */
  ledgerLines: LedgerLinesConnection;
  /** This transaction's Link. */
  link: CustomLink | IncreaseLink | StripeLink | UnitLink;
  /** FRAGMENT ID of this transaction's Link */
  linkId: Scalars['ID']['output'];
  /** ISO-8601 timestamp when this Tx posted to the external account */
  posted: Scalars['DateTime']['output'];
  /** When a Tx is deleted and a new Tx is synced with the same externalId, its sequence will be higher than the previous Tx. You can use this to distinguish different instances of Txs that have the same externalId. */
  sequence: Scalars['Int']['output'];
  /** @deprecated Callers should not need to query or store this value. */
  workspaceId: Scalars['ID']['output'];
};

/** Specify a Tx by using `id` or `externalId`, the Link it belongs to by `linkId`, and the External Account it is a part of by `accountId` or `externalAccountId`. */
export type TxMatchInput = {
  /** The FRAGMENT ID of the external account */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** The external system's ID for the account */
  externalAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The external system's ID for the transaction */
  externalId?: InputMaybe<Scalars['ID']['input']>;
  /** The FRAGMENT ID of the transaction */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The FRAGMENT ID of the link */
  linkId?: InputMaybe<Scalars['ID']['input']>;
};

export enum TxType {
  Credit = 'credit',
  Debit = 'debit',
}

export type TxTypeFilter = {
  equalTo?: InputMaybe<TxType>;
  /** Must match one of the values provided. Limited to 100 items maximum. */
  in?: InputMaybe<Array<TxType>>;
};

/** A paginated list of Txs */
export type TxsConnection = {
  __typename?: 'TxsConnection';
  /** The current page of results */
  nodes: Array<Tx>;
  /** The [pagination info](https://fragment.dev/api-reference/api-types#connection-types-pageinfo) for this list */
  pageInfo: PageInfo;
};

export enum UnitEnv {
  Production = 'production',
  Sandbox = 'sandbox',
}

export type UnitLink = Link & {
  __typename?: 'UnitLink';
  /** ISO-8601 timestamp when the Link was created. */
  created: Scalars['String']['output'];
  /** URL to the Fragment Dashboard for this Link. */
  dashboardUrl: Scalars['String']['output'];
  /** A list of External Accounts associated with this Link. */
  externalAccounts: ExternalAccountsConnection;
  /** FRAGMENT ID of the Unit Link. */
  id: Scalars['ID']['output'];
  /** Name of the Link as it appears in the Dashboard. */
  name: Scalars['String']['output'];
  /** The environment of the Unit Link, either sandbox or production. */
  unitEnv: UnitEnv;
};

export type UpdateLedgerAccountInput = {
  /** The consistency configuration for this ledger account. This defines how updates to this ledger account's balance are handled. */
  consistencyConfig?: InputMaybe<LedgerAccountConsistencyConfigInput>;
  /** The name to update the ledger account to */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLedgerAccountResponse = BadRequestError | InternalError | UpdateLedgerAccountResult;

export type UpdateLedgerAccountResult = {
  __typename?: 'UpdateLedgerAccountResult';
  /** The ledger account that was updated */
  ledgerAccount: LedgerAccount;
};

export type UpdateLedgerEntryInput = {
  /** The list of Groups to add to this Ledger Entry. */
  groups?: InputMaybe<Array<LedgerEntryGroupInput>>;
  /** The list of Ledger Line updates to apply to Ledger Lines on this Ledger Entry. */
  ledgerLines?: InputMaybe<Array<UpdateLedgerLineInput>>;
  /** The list of Tags to add and/or update on this Ledger Entry. */
  tags?: InputMaybe<Array<LedgerEntryTagInput>>;
  /** The list of Tags to remove from this Ledger Entry. */
  tagsToRemove?: InputMaybe<Array<LedgerEntryTagInput>>;
};

export type UpdateLedgerEntryResponse = BadRequestError | InternalError | UpdateLedgerEntryResult;

export type UpdateLedgerEntryResult = {
  __typename?: 'UpdateLedgerEntryResult';
  /** The Ledger Entry that was updated. */
  entry: LedgerEntry;
};

export type UpdateLedgerInput = {
  /** The new Ledger name.  */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLedgerLineInput = {
  /** The Ledger Line that is being updated. It must belong to the Ledger Entry being updated. */
  ledgerLine: LedgerLineMatchInput;
  /** The list of Tags to add and/or update on this Ledger Line. */
  tags?: InputMaybe<Array<LedgerLineTagInput>>;
  /** The list of Tags to remove from this Ledger Line. */
  tagsToRemove?: InputMaybe<Array<LedgerLineTagInput>>;
};

export type UpdateLedgerResponse = BadRequestError | InternalError | UpdateLedgerResult;

export type UpdateLedgerResult = {
  __typename?: 'UpdateLedgerResult';
  /** The updated Ledger.  */
  ledger: Ledger;
};

/** A User who pays through a Ledger. */
export type User = {
  __typename?: 'User';
  /** The User's email address. */
  email: Scalars['String']['output'];
};

export type UserFilter = {
  /** Filter by the User's email address. */
  email: EmailFilter;
  /** The Ledger the User belongs to. */
  ledger: LedgerMatchInput;
};

/** Specify a User by their email. */
export type UserMatchInput = {
  /** The User's email. */
  email: Scalars['String']['input'];
};

export type Workspace = {
  __typename?: 'Workspace';
  /** The ID of the Workspace */
  id: Scalars['String']['output'];
  /** The name of the Workspace */
  name: Scalars['String']['output'];
};

export type GetExternalAccountLinkedAccountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetExternalAccountLinkedAccountsQuery = {
  __typename?: 'Query';
  externalAccount?: {
    __typename: 'ExternalAccount';
    ledgerAccounts: {
      __typename?: 'LedgerAccountsConnection';
      nodes: Array<{
        __typename?: 'LedgerAccount';
        id: string;
        ledgerId: string;
        path: string;
        name?: string | null;
        type: LedgerAccountTypes;
        ledger: { __typename?: 'Ledger'; name: string; schema?: { __typename?: 'Schema'; key: string } | null };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetExternalAccountSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetExternalAccountSummaryQuery = {
  __typename?: 'Query';
  externalAccount?: {
    __typename: 'ExternalAccount';
    name: string;
    id: string;
    externalId: string;
    currencyMode: CurrencyMode;
    link:
      | { __typename: 'CustomLink'; id: string; name: string }
      | { __typename: 'IncreaseLink'; id: string; name: string }
      | { __typename: 'StripeLink'; id: string; name: string }
      | { __typename: 'UnitLink'; id: string; name: string };
    currency?: { __typename?: 'Currency'; code: CurrencyCode; customCode?: string | null } | null;
  } | null;
};

export type GetExternalAccountTxsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetExternalAccountTxsQuery = {
  __typename?: 'Query';
  externalAccount?: {
    __typename: 'ExternalAccount';
    name: string;
    id: string;
    externalId: string;
    txs: {
      __typename?: 'TxsConnection';
      nodes: Array<{
        __typename?: 'Tx';
        id: string;
        externalId: string;
        description: string;
        amount: string;
        posted: string;
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          customCode?: string | null;
          name: string;
          precision: number;
        } | null;
        ledgerLines: {
          __typename?: 'LedgerLinesConnection';
          nodes: Array<{
            __typename?: 'LedgerLine';
            id: string;
            accountId: string;
            ledgerId: string;
            ledgerEntryId: string;
            description?: string | null;
            ledger: { __typename?: 'Ledger'; schema?: { __typename?: 'Schema'; key: string } | null };
          }>;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    link:
      | { __typename: 'CustomLink'; id: string; name: string }
      | { __typename: 'IncreaseLink'; id: string; name: string }
      | { __typename: 'StripeLink'; id: string; name: string }
      | { __typename: 'UnitLink'; id: string; name: string };
  } | null;
};

export type GetLinksQueryVariables = Exact<{ [key: string]: never }>;

export type GetLinksQuery = {
  __typename?: 'Query';
  links: {
    __typename: 'LinksConnection';
    nodes: Array<
      | { __typename: 'CustomLink'; id: string; name: string; created: string }
      | { __typename: 'IncreaseLink'; increaseEnv: IncreaseEnv; id: string; name: string; created: string }
      | { __typename: 'StripeLink'; stripeEnv: StripeEnv; id: string; name: string; created: string }
      | { __typename: 'UnitLink'; unitEnv: UnitEnv; id: string; name: string; created: string }
    >;
  };
};

export type ListExternalAccountsQueryVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;

export type ListExternalAccountsQuery = {
  __typename?: 'Query';
  link?:
    | {
        __typename: 'CustomLink';
        id: string;
        name: string;
        created: string;
        externalAccounts: {
          __typename?: 'ExternalAccountsConnection';
          nodes: Array<{
            __typename?: 'ExternalAccount';
            id: string;
            externalId: string;
            name: string;
            currencyMode: CurrencyMode;
            currency?: { __typename?: 'Currency'; code: CurrencyCode; customCode?: string | null } | null;
          }>;
        };
      }
    | {
        __typename: 'IncreaseLink';
        increaseEnv: IncreaseEnv;
        id: string;
        name: string;
        created: string;
        externalAccounts: {
          __typename?: 'ExternalAccountsConnection';
          nodes: Array<{
            __typename?: 'ExternalAccount';
            id: string;
            externalId: string;
            name: string;
            currencyMode: CurrencyMode;
            currency?: { __typename?: 'Currency'; code: CurrencyCode; customCode?: string | null } | null;
          }>;
        };
      }
    | {
        __typename: 'StripeLink';
        stripeEnv: StripeEnv;
        id: string;
        name: string;
        created: string;
        externalAccounts: {
          __typename?: 'ExternalAccountsConnection';
          nodes: Array<{
            __typename?: 'ExternalAccount';
            id: string;
            externalId: string;
            name: string;
            currencyMode: CurrencyMode;
            currency?: { __typename?: 'Currency'; code: CurrencyCode; customCode?: string | null } | null;
          }>;
        };
      }
    | {
        __typename: 'UnitLink';
        unitEnv: UnitEnv;
        id: string;
        name: string;
        created: string;
        externalAccounts: {
          __typename?: 'ExternalAccountsConnection';
          nodes: Array<{
            __typename?: 'ExternalAccount';
            id: string;
            externalId: string;
            name: string;
            currencyMode: CurrencyMode;
            currency?: { __typename?: 'Currency'; code: CurrencyCode; customCode?: string | null } | null;
          }>;
        };
      }
    | null;
};

export type SyncCustomAccountMutationVariables = Exact<{
  account: CustomAccountInput;
  link: LinkMatchInput;
}>;

export type SyncCustomAccountMutation = {
  __typename?: 'Mutation';
  syncCustomAccounts:
    | { __typename?: 'BadRequestError'; code: string; message: string }
    | { __typename?: 'InternalError'; code: string; message: string }
    | { __typename?: 'SyncCustomAccountsResult'; accounts: Array<{ __typename?: 'ExternalAccount'; id: string }> };
};

export type SyncCustomTxMutationVariables = Exact<{
  tx: CustomTxInput;
  link: LinkMatchInput;
}>;

export type SyncCustomTxMutation = {
  __typename?: 'Mutation';
  syncCustomTxs:
    | { __typename?: 'BadRequestError'; code: string; message: string }
    | { __typename?: 'InternalError'; code: string; message: string }
    | { __typename?: 'SyncCustomTxsResult'; txs: Array<{ __typename?: 'Tx'; id: string }> };
};

export type CreateLedgerMutationVariables = Exact<{
  ik: Scalars['SafeString']['input'];
  ledger: CreateLedgerInput;
  schema?: InputMaybe<SchemaMatchInput>;
}>;

export type CreateLedgerMutation = {
  __typename?: 'Mutation';
  createLedger:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | {
        __typename: 'CreateLedgerResult';
        isIkReplay: boolean;
        ledger: { __typename?: 'Ledger'; id: string; ik: string; name: string };
      }
    | { __typename: 'InternalError'; code: string; message: string };
};

export type DeleteLedgerMutationVariables = Exact<{
  ledgerId: Scalars['ID']['input'];
}>;

export type DeleteLedgerMutation = {
  __typename?: 'Mutation';
  deleteLedger:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'DeleteLedgerResult'; success: boolean }
    | { __typename: 'InternalError'; code: string; message: string };
};

export type DeleteSchemaMutationVariables = Exact<{
  schema: SchemaMatchInput;
}>;

export type DeleteSchemaMutation = {
  __typename?: 'Mutation';
  deleteSchema:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'DeleteSchemaResult'; success: boolean }
    | { __typename: 'InternalError'; code: string; message: string };
};

export type GetCustomCurrenciesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetCustomCurrenciesQuery = {
  __typename?: 'Query';
  customCurrencies: {
    __typename?: 'CustomCurrenciesConnection';
    nodes: Array<{
      __typename?: 'Currency';
      code: CurrencyCode;
      customCode?: string | null;
      customCurrencyId?: string | null;
      name: string;
      precision: number;
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetEntryStatsQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEntryStatsQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    id: string;
    ik: string;
    created: string;
    balanceUTCOffset: string;
    schema?: { __typename?: 'Schema'; key: string } | null;
    entryStats: {
      __typename?: 'LedgerEntryStatsConnection';
      nodes: Array<{
        __typename?: 'LedgerEntryStats';
        schemaKey: string;
        ledgerId: string;
        type: string;
        typeVersion: number;
        count: string;
        reversalsCount: string;
        netCount: string;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    name: string;
    id: string;
    ik: string;
    created: string;
    balanceUTCOffset: string;
    schema?: { __typename?: 'Schema'; key: string } | null;
    entryStats: {
      __typename?: 'LedgerEntryStatsConnection';
      nodes: Array<{
        __typename?: 'LedgerEntryStats';
        schemaKey: string;
        ledgerId: string;
        type: string;
        typeVersion: number;
        count: string;
        reversalsCount: string;
        netCount: string;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerAccountQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  ledgerId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
  ownBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  ownBalancesAfter?: InputMaybe<Scalars['String']['input']>;
  childBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  childBalancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerAccountQuery = {
  __typename: 'Query';
  ledgerAccount?: {
    __typename: 'LedgerAccount';
    id: string;
    path: string;
    ledgerId: string;
    name?: string | null;
    type: LedgerAccountTypes;
    created: string;
    currencyMode: CurrencyMode;
    payment?: { __typename?: 'LedgerAccountPayment'; enabled: boolean } | null;
    currency?: {
      __typename?: 'Currency';
      code: CurrencyCode;
      name: string;
      precision: number;
      customCode?: string | null;
      customCurrencyId?: string | null;
    } | null;
    parentLedgerAccount?: { __typename?: 'LedgerAccount'; id: string; name?: string | null } | null;
    link?:
      | { __typename: 'CustomLink'; id: string; name: string; created: string }
      | { __typename: 'IncreaseLink'; id: string; name: string; created: string; increaseEnv: IncreaseEnv }
      | { __typename: 'StripeLink' }
      | { __typename: 'UnitLink'; id: string; name: string; created: string; unitEnv: UnitEnv }
      | null;
    lines: {
      __typename?: 'LedgerLinesConnection';
      nodes: Array<{
        __typename: 'LedgerLine';
        id: string;
        description?: string | null;
        created?: string | null;
        posted?: string | null;
        amount: string;
        txId?: string | null;
        ledgerEntryId: string;
        isReversal: boolean;
        isReversed: boolean;
        hidden: boolean;
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    balances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    ownBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    childBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    linkedAccount?: {
      __typename?: 'ExternalAccount';
      externalId: string;
      id: string;
      linkId: string;
      name: string;
    } | null;
  } | null;
  childAccounts?: {
    __typename?: 'Ledger';
    ledgerAccounts: {
      __typename?: 'LedgerAccountsConnection';
      nodes: Array<{ __typename?: 'LedgerAccount'; id: string }>;
    };
  } | null;
};

export type GetLedgerAccountBalancesQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
  ownBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  ownBalancesAfter?: InputMaybe<Scalars['String']['input']>;
  childBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  childBalancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerAccountBalancesQuery = {
  __typename: 'Query';
  ledgerAccount?: {
    __typename: 'LedgerAccount';
    id: string;
    path: string;
    ledgerId: string;
    name?: string | null;
    type: LedgerAccountTypes;
    created: string;
    currencyMode: CurrencyMode;
    currency?: {
      __typename?: 'Currency';
      code: CurrencyCode;
      name: string;
      precision: number;
      customCode?: string | null;
      customCurrencyId?: string | null;
    } | null;
    parentLedgerAccount?: { __typename?: 'LedgerAccount'; id: string; name?: string | null } | null;
    balances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    ownBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    linkedAccount?: {
      __typename?: 'ExternalAccount';
      id: string;
      externalId: string;
      name: string;
      link:
        | { __typename: 'CustomLink' }
        | { __typename: 'IncreaseLink' }
        | { __typename: 'StripeLink' }
        | { __typename: 'UnitLink' };
    } | null;
    payment?: { __typename?: 'LedgerAccountPayment'; enabled: boolean } | null;
    childBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    link?:
      | { __typename: 'CustomLink'; id: string; name: string; created: string }
      | { __typename: 'IncreaseLink'; id: string; name: string; created: string; increaseEnv: IncreaseEnv }
      | { __typename: 'StripeLink' }
      | { __typename: 'UnitLink'; id: string; name: string; created: string; unitEnv: UnitEnv }
      | null;
  } | null;
};

export type GetLedgerAccountCrumbDataQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  filter?: InputMaybe<LedgerAccountsFilterSet>;
}>;

export type GetLedgerAccountCrumbDataQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    ledgerAccounts: {
      __typename: 'LedgerAccountsConnection';
      nodes: Array<{ __typename: 'LedgerAccount'; id: string; name?: string | null; path: string }>;
    };
  } | null;
};

export type GetLedgerAccountDataMigrationsQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LedgerAccountDataMigrationsFilterSet>;
}>;

export type GetLedgerAccountDataMigrationsQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    id: string;
    name: string;
    ledgerAccountDataMigrations: {
      __typename?: 'LedgerAccountDataMigrationConnection';
      nodes: Array<{
        __typename: 'LedgerAccountDataMigration';
        accountPath: string;
        status: LedgerDataMigrationStatus;
        currentMigration?: {
          __typename?: 'LedgerDataMigrationHistoryEntry';
          schemaVersion: number;
          status: LedgerDataMigrationStatus;
        } | null;
        history: {
          __typename?: 'LedgerDataMigrationHistoryConnection';
          nodes: Array<{
            __typename?: 'LedgerDataMigrationHistoryEntry';
            schemaVersion: number;
            status: LedgerDataMigrationStatus;
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            endCursor?: string | null;
            startCursor?: string | null;
          };
        };
        ledgerEntries: {
          __typename?: 'LedgerEntriesConnection';
          nodes: Array<{
            __typename?: 'LedgerEntry';
            id: string;
            ik: string;
            description?: string | null;
            posted: string;
            created: string;
            type?: string | null;
            typeVersion?: number | null;
            isReversal: boolean;
            isReversed: boolean;
            hidden: boolean;
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            endCursor?: string | null;
          };
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerAccountDetailQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  ledgerId: Scalars['ID']['input'];
}>;

export type GetLedgerAccountDetailQuery = {
  __typename: 'Query';
  ledgerAccount?: { __typename: 'LedgerAccount'; id: string; ledgerId: string; path: string } | null;
  childAccounts?: {
    __typename?: 'Ledger';
    ledgerAccounts: {
      __typename?: 'LedgerAccountsConnection';
      nodes: Array<{ __typename?: 'LedgerAccount'; id: string }>;
    };
  } | null;
};

export type GetLedgerAccountBalancesDuringQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  startTime: Scalars['FirstMoment']['input'];
  duration: Scalars['Int']['input'];
  granularity: Granularity;
  currency?: InputMaybe<CurrencyMatchInput>;
}>;

export type GetLedgerAccountBalancesDuringQuery = {
  __typename?: 'Query';
  ledgerAccount?: {
    __typename?: 'LedgerAccount';
    balancesDuring: {
      __typename?: 'HistoricalBalanceConnection';
      granularity: Granularity;
      startTime: string;
      endTime: string;
      nodes: Array<{
        __typename?: 'HistoricalBalance';
        at: string;
        amount: {
          __typename?: 'CurrencyAmount';
          amount: string;
          currency: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null };
        };
      }>;
    };
    childBalancesDuring: {
      __typename?: 'HistoricalBalanceConnection';
      granularity: Granularity;
      startTime: string;
      endTime: string;
      nodes: Array<{
        __typename?: 'HistoricalBalance';
        at: string;
        amount: {
          __typename?: 'CurrencyAmount';
          amount: string;
          currency: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null };
        };
      }>;
    };
    ownBalancesDuring: {
      __typename?: 'HistoricalBalanceConnection';
      granularity: Granularity;
      startTime: string;
      endTime: string;
      nodes: Array<{
        __typename?: 'HistoricalBalance';
        at: string;
        amount: {
          __typename?: 'CurrencyAmount';
          amount: string;
          currency: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null };
        };
      }>;
    };
  } | null;
};

export type GetLedgerAccountLineDownloadQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetLedgerAccountLineDownloadQuery = {
  __typename: 'Query';
  ledgerAccount?: {
    __typename: 'LedgerAccount';
    id: string;
    lines: {
      __typename?: 'LedgerLinesConnection';
      nodes: Array<{
        __typename?: 'LedgerLine';
        id: string;
        posted?: string | null;
        description?: string | null;
        amount: string;
        created?: string | null;
        ledgerEntry: { __typename?: 'LedgerEntry'; ik: string; id: string; type?: string | null };
        currency?: { __typename?: 'Currency'; code: CurrencyCode; customCode?: string | null } | null;
        tx?: { __typename?: 'Tx'; externalId: string; externalAccountId: string; linkId: string } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerAccountLinesQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LedgerLinesFilterSet>;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
  childBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  childBalancesAfter?: InputMaybe<Scalars['String']['input']>;
  ownBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  ownBalancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerAccountLinesQuery = {
  __typename: 'Query';
  ledgerAccount?: {
    __typename: 'LedgerAccount';
    id: string;
    path: string;
    ledgerId: string;
    name?: string | null;
    type: LedgerAccountTypes;
    currencyMode: CurrencyMode;
    created: string;
    linkedAccount?: {
      __typename?: 'ExternalAccount';
      id: string;
      externalId: string;
      name: string;
      link:
        | { __typename: 'CustomLink' }
        | { __typename: 'IncreaseLink' }
        | { __typename: 'StripeLink' }
        | { __typename: 'UnitLink' };
    } | null;
    payment?: { __typename?: 'LedgerAccountPayment'; enabled: boolean } | null;
    currency?: {
      __typename?: 'Currency';
      code: CurrencyCode;
      name: string;
      precision: number;
      customCode?: string | null;
      customCurrencyId?: string | null;
    } | null;
    balances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    childBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    ownBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    lines: {
      __typename: 'LedgerLinesConnection';
      nodes: Array<{
        __typename: 'LedgerLine';
        id: string;
        description?: string | null;
        ledgerEntryId: string;
        created?: string | null;
        posted?: string | null;
        amount: string;
        txId?: string | null;
        isReversal: boolean;
        isReversed: boolean;
        hidden: boolean;
        ledgerEntry: { __typename?: 'LedgerEntry'; type?: string | null };
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerAccountSummaryQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
  childBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  childBalancesAfter?: InputMaybe<Scalars['String']['input']>;
  ownBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  ownBalancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerAccountSummaryQuery = {
  __typename?: 'Query';
  ledgerAccount?: {
    __typename: 'LedgerAccount';
    id: string;
    path: string;
    name?: string | null;
    type: LedgerAccountTypes;
    currencyMode: CurrencyMode;
    ledgerId: string;
    created: string;
    currency?: {
      __typename?: 'Currency';
      code: CurrencyCode;
      name: string;
      precision: number;
      customCode?: string | null;
      customCurrencyId?: string | null;
    } | null;
    linkedAccount?: {
      __typename?: 'ExternalAccount';
      id: string;
      externalId: string;
      name: string;
      link:
        | { __typename: 'CustomLink' }
        | { __typename: 'IncreaseLink' }
        | { __typename: 'StripeLink' }
        | { __typename: 'UnitLink' };
    } | null;
    payment?: { __typename?: 'LedgerAccountPayment'; enabled: boolean } | null;
    balances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    childBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    ownBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerAccountsQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  filter?: InputMaybe<LedgerAccountsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerAccountsQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    ledgerAccounts: {
      __typename: 'LedgerAccountsConnection';
      nodes: Array<{
        __typename: 'LedgerAccount';
        id: string;
        path: string;
        ledgerId: string;
        name?: string | null;
        type: LedgerAccountTypes;
        currencyMode: CurrencyMode;
        balances: {
          __typename?: 'CurrencyAmountConnection';
          nodes: Array<{
            __typename?: 'CurrencyAmount';
            amount: string;
            currency: {
              __typename?: 'Currency';
              code: CurrencyCode;
              name: string;
              precision: number;
              customCode?: string | null;
              customCurrencyId?: string | null;
            };
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            endCursor?: string | null;
          };
        };
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        } | null;
        link?:
          | { __typename: 'CustomLink'; id: string }
          | { __typename: 'IncreaseLink'; id: string }
          | { __typename: 'StripeLink'; id: string }
          | { __typename: 'UnitLink'; id: string }
          | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerAccountsForPostEntryQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  filter?: InputMaybe<LedgerAccountsFilterSet>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerAccountsForPostEntryQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    ledgerAccounts: {
      __typename: 'LedgerAccountsConnection';
      nodes: Array<{ __typename: 'LedgerAccount'; path: string; type: LedgerAccountTypes }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerEntryQueryVariables = Exact<{
  entryId: Scalars['ID']['input'];
}>;

export type GetLedgerEntryQuery = {
  __typename?: 'Query';
  ledgerEntry?: {
    __typename: 'LedgerEntry';
    id: string;
    ik: string;
    description?: string | null;
    posted: string;
    created: string;
    parameters?: string | null;
    type?: string | null;
    typeVersion?: number | null;
    isReversal: boolean;
    isReversed: boolean;
    reversalPosition: number;
    hidden: boolean;
    ledger: { __typename?: 'Ledger'; id: string; name: string };
    reverses?: { __typename?: 'LedgerEntry'; type?: string | null; id: string } | null;
    reversedBy?: {
      __typename?: 'LedgerEntry';
      id: string;
      ik: string;
      description?: string | null;
      posted: string;
      created: string;
      parameters?: string | null;
      type?: string | null;
      reversalPosition: number;
      ledger: { __typename?: 'Ledger'; id: string; name: string };
      lines: {
        __typename?: 'LedgerLinesConnection';
        nodes: Array<{
          __typename?: 'LedgerLine';
          id: string;
          created?: string | null;
          posted?: string | null;
          txId?: string | null;
          externalTxId?: string | null;
          description?: string | null;
          amount: string;
          account: {
            __typename?: 'LedgerAccount';
            id: string;
            path: string;
            name?: string | null;
            type: LedgerAccountTypes;
            link?:
              | { __typename: 'CustomLink'; id: string; name: string }
              | { __typename: 'IncreaseLink'; id: string; name: string }
              | { __typename: 'StripeLink'; id: string; name: string }
              | { __typename: 'UnitLink'; id: string; name: string }
              | null;
            linkedAccount?: { __typename?: 'ExternalAccount'; id: string; name: string } | null;
          };
          currency?: {
            __typename?: 'Currency';
            code: CurrencyCode;
            name: string;
            precision: number;
            customCode?: string | null;
            customCurrencyId?: string | null;
          } | null;
        }>;
      };
      groups: Array<{ __typename?: 'LedgerEntryGroup'; key: string; value: string }>;
      tags: Array<{ __typename?: 'LedgerEntryTag'; key: string; value: string }>;
    } | null;
    reversalHistory: {
      __typename?: 'LedgerEntriesConnection';
      nodes: Array<{
        __typename?: 'LedgerEntry';
        reversalPosition: number;
        id: string;
        created: string;
        type?: string | null;
        isReversal: boolean;
        isReversed: boolean;
        hidden: boolean;
        lines: {
          __typename?: 'LedgerLinesConnection';
          nodes: Array<{
            __typename?: 'LedgerLine';
            account: { __typename?: 'LedgerAccount'; type: LedgerAccountTypes };
          }>;
        };
      }>;
    };
    lines: {
      __typename?: 'LedgerLinesConnection';
      nodes: Array<{
        __typename?: 'LedgerLine';
        id: string;
        created?: string | null;
        posted?: string | null;
        txId?: string | null;
        externalTxId?: string | null;
        description?: string | null;
        amount: string;
        account: {
          __typename?: 'LedgerAccount';
          id: string;
          path: string;
          name?: string | null;
          type: LedgerAccountTypes;
          link?:
            | { __typename: 'CustomLink'; id: string; name: string }
            | { __typename: 'IncreaseLink'; id: string; name: string }
            | { __typename: 'StripeLink'; id: string; name: string }
            | { __typename: 'UnitLink'; id: string; name: string }
            | null;
          linkedAccount?: { __typename?: 'ExternalAccount'; id: string; name: string } | null;
        };
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        } | null;
        tags: Array<{ __typename?: 'LedgerLineTag'; key: string; value: string }>;
      }>;
    };
    groups: Array<{ __typename?: 'LedgerEntryGroup'; key: string; value: string }>;
    tags: Array<{ __typename?: 'LedgerEntryTag'; key: string; value: string }>;
  } | null;
};

export type GetLedgerEntryDataMigrationsQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LedgerEntryDataMigrationsFilterSet>;
}>;

export type GetLedgerEntryDataMigrationsQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    id: string;
    name: string;
    ledgerEntryDataMigrations: {
      __typename?: 'LedgerEntryDataMigrationConnection';
      nodes: Array<{
        __typename: 'LedgerEntryDataMigration';
        entryType: string;
        typeVersion: number;
        status: LedgerDataMigrationStatus;
        currentMigration?: {
          __typename?: 'LedgerDataMigrationHistoryEntry';
          schemaVersion: number;
          status: LedgerDataMigrationStatus;
        } | null;
        history: {
          __typename?: 'LedgerDataMigrationHistoryConnection';
          nodes: Array<{
            __typename?: 'LedgerDataMigrationHistoryEntry';
            schemaVersion: number;
            status: LedgerDataMigrationStatus;
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            endCursor?: string | null;
            startCursor?: string | null;
          };
        };
        ledgerEntries: {
          __typename?: 'LedgerEntriesConnection';
          nodes: Array<{
            __typename?: 'LedgerEntry';
            id: string;
            ik: string;
            description?: string | null;
            posted: string;
            created: string;
            type?: string | null;
            typeVersion?: number | null;
            isReversal: boolean;
            isReversed: boolean;
            hidden: boolean;
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            endCursor?: string | null;
          };
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerEntryDownloadQueryVariables = Exact<{
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LedgerEntriesFilterSet>;
}>;

export type GetLedgerEntryDownloadQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    id: string;
    ik: string;
    name: string;
    ledgerEntries: {
      __typename?: 'LedgerEntriesConnection';
      nodes: Array<{
        __typename?: 'LedgerEntry';
        id: string;
        ik: string;
        posted: string;
        created: string;
        description?: string | null;
        type?: string | null;
        typeVersion?: number | null;
        isReversal: boolean;
        isReversed: boolean;
        reversalPosition: number;
        hidden: boolean;
        date: string;
        dashboardUrl: string;
        parameters?: string | null;
        lines: {
          __typename?: 'LedgerLinesConnection';
          nodes: Array<{
            __typename?: 'LedgerLine';
            id: string;
            key?: string | null;
            posted?: string | null;
            created?: string | null;
            description?: string | null;
            amount: string;
            account: {
              __typename?: 'LedgerAccount';
              id: string;
              path: string;
              name?: string | null;
              type: LedgerAccountTypes;
            };
            currency?: {
              __typename?: 'Currency';
              code: CurrencyCode;
              name: string;
              precision: number;
              customCode?: string | null;
              customCurrencyId?: string | null;
            } | null;
          }>;
        };
        groups: Array<{ __typename?: 'LedgerEntryGroup'; key: string; value: string }>;
        tags: Array<{ __typename?: 'LedgerEntryTag'; key: string; value: string }>;
        reverses?: { __typename?: 'LedgerEntry'; id: string; ik: string; type?: string | null } | null;
        reversedBy?: { __typename?: 'LedgerEntry'; id: string; ik: string; type?: string | null } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type GetLedgerEntryGroupQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  ledgerEntryGroup: EntryGroupMatchInput;
}>;

export type GetLedgerEntryGroupQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    name: string;
    id: string;
    ik: string;
    ledgerEntryGroup: { __typename: 'LedgerEntryGroup'; created?: string | null; key: string; value: string };
  } | null;
};

export type GetLedgerEntryGroupEntriesQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  ledgerEntryGroup: EntryGroupMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetLedgerEntryGroupEntriesQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    name: string;
    id: string;
    ik: string;
    ledgerEntryGroup: {
      __typename?: 'LedgerEntryGroup';
      ledgerEntries: {
        __typename?: 'LedgerEntriesConnection';
        nodes: Array<{
          __typename?: 'LedgerEntry';
          type?: string | null;
          posted: string;
          lines: {
            __typename?: 'LedgerLinesConnection';
            nodes: Array<{
              __typename?: 'LedgerLine';
              amount: string;
              account: { __typename?: 'LedgerAccount'; type: LedgerAccountTypes; path: string };
              currency?: {
                __typename?: 'Currency';
                code: CurrencyCode;
                customCurrencyId?: string | null;
                precision: number;
                name: string;
              } | null;
            }>;
          };
        }>;
        pageInfo: {
          __typename?: 'PageInfo';
          endCursor?: string | null;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
        };
      };
    };
  } | null;
};

export type GetPaymentQueryVariables = Exact<{
  payment: PaymentMatchInput;
}>;

export type GetPaymentQuery = {
  __typename?: 'Query';
  payment?: {
    __typename?: 'Payment';
    ik: string;
    status: PaymentStatus;
    amount: string;
    type: string;
    created: string;
    parameters: Record<string, unknown>;
    events: {
      __typename?: 'PaymentEventsConnection';
      nodes: Array<
        | { __typename: 'PaymentCard3DSCanceledEvent'; occurredAt: string; status: PaymentStatus }
        | {
            __typename: 'PaymentCardCapturedEvent';
            occurredAt: string;
            status: PaymentStatus;
            cardCapturedLedgerEntry?: {
              __typename?: 'LedgerEntry';
              id: string;
              ik: string;
              type?: string | null;
              lines: {
                __typename?: 'LedgerLinesConnection';
                nodes: Array<{
                  __typename?: 'LedgerLine';
                  account: { __typename?: 'LedgerAccount'; type: LedgerAccountTypes };
                }>;
              };
            } | null;
          }
        | { __typename: 'PaymentCardDeclinedEvent'; occurredAt: string; status: PaymentStatus }
        | { __typename: 'PaymentCheckoutEvent'; occurredAt: string; status: PaymentStatus }
        | { __typename: 'PaymentCreatedEvent'; occurredAt: string; status: PaymentStatus }
        | {
            __typename: 'PaymentSettledEvent';
            occurredAt: string;
            status: PaymentStatus;
            settledLedgerEntry: {
              __typename?: 'LedgerEntry';
              id: string;
              ik: string;
              type?: string | null;
              lines: {
                __typename?: 'LedgerLinesConnection';
                nodes: Array<{
                  __typename?: 'LedgerLine';
                  account: { __typename?: 'LedgerAccount'; type: LedgerAccountTypes };
                }>;
              };
            };
          }
      >;
    };
  } | null;
};

export type GetPaymentsQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPaymentsQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename?: 'Ledger';
    payments: {
      __typename?: 'PaymentsConnection';
      nodes: Array<{
        __typename?: 'Payment';
        ik: string;
        status: PaymentStatus;
        amount: string;
        type: string;
        created: string;
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
    };
  } | null;
};

export type GetTxQueryVariables = Exact<{
  txId: Scalars['ID']['input'];
}>;

export type GetTxQuery = {
  __typename?: 'Query';
  tx?: {
    __typename: 'Tx';
    id: string;
    externalId: string;
    description: string;
    posted: string;
    amount: string;
    currency?: {
      __typename?: 'Currency';
      code: CurrencyCode;
      customCurrencyId?: string | null;
      name: string;
      precision: number;
    } | null;
    link:
      | { __typename: 'CustomLink'; id: string; name: string }
      | { __typename: 'IncreaseLink'; id: string; name: string }
      | { __typename: 'StripeLink'; id: string; name: string }
      | { __typename: 'UnitLink'; id: string; name: string };
    ledgerEntries: { __typename?: 'LedgerEntriesConnection'; nodes: Array<{ __typename?: 'LedgerEntry'; id: string }> };
    externalAccount: { __typename?: 'ExternalAccount'; id: string; name: string };
  } | null;
};

export type GetUnreconciledTxsQueryVariables = Exact<{
  ledgerAccount: LedgerAccountMatchInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
  childBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  childBalancesAfter?: InputMaybe<Scalars['String']['input']>;
  ownBalancesFirst?: InputMaybe<Scalars['Int']['input']>;
  ownBalancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetUnreconciledTxsQuery = {
  __typename?: 'Query';
  ledgerAccount?: {
    __typename?: 'LedgerAccount';
    type: LedgerAccountTypes;
    id: string;
    name?: string | null;
    ledgerId: string;
    path: string;
    currencyMode: CurrencyMode;
    created: string;
    currency?: {
      __typename?: 'Currency';
      code: CurrencyCode;
      customCode?: string | null;
      precision: number;
      customCurrencyId?: string | null;
      name: string;
    } | null;
    linkedAccount?: {
      __typename?: 'ExternalAccount';
      id: string;
      externalId: string;
      name: string;
      link:
        | { __typename: 'CustomLink'; id: string }
        | { __typename: 'IncreaseLink'; increaseEnv: IncreaseEnv; id: string }
        | { __typename: 'StripeLink'; id: string }
        | { __typename: 'UnitLink'; unitEnv: UnitEnv; id: string };
    } | null;
    payment?: { __typename?: 'LedgerAccountPayment'; enabled: boolean } | null;
    balances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          customCode?: string | null;
          precision: number;
          customCurrencyId?: string | null;
          name: string;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    childBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    ownBalances: {
      __typename?: 'CurrencyAmountConnection';
      nodes: Array<{
        __typename?: 'CurrencyAmount';
        amount: string;
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
    unreconciledTxs: {
      __typename?: 'TxsConnection';
      nodes: Array<{
        __typename?: 'Tx';
        id: string;
        amount: string;
        description: string;
        externalId: string;
        posted: string;
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          customCode?: string | null;
          precision: number;
          customCurrencyId?: string | null;
          name: string;
        } | null;
        ledgerLines: {
          __typename?: 'LedgerLinesConnection';
          nodes: Array<{
            __typename?: 'LedgerLine';
            id: string;
            accountId: string;
            ledgerId: string;
            ledgerEntryId: string;
            description?: string | null;
          }>;
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
    };
  } | null;
};

export type LedgerLineEntrySectionGetLedgerEntryQueryVariables = Exact<{
  entryId: Scalars['ID']['input'];
}>;

export type LedgerLineEntrySectionGetLedgerEntryQuery = {
  __typename?: 'Query';
  ledgerEntry?: {
    __typename: 'LedgerEntry';
    id: string;
    ik: string;
    type?: string | null;
    lines: {
      __typename?: 'LedgerLinesConnection';
      nodes: Array<{
        __typename?: 'LedgerLine';
        id: string;
        account: { __typename?: 'LedgerAccount'; type: LedgerAccountTypes };
      }>;
    };
  } | null;
};

export type ListLedgerEntriesQueryVariables = Exact<{
  ledgerId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntriesFilterSet>;
}>;

export type ListLedgerEntriesQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    name: string;
    id: string;
    ledgerEntries: {
      __typename?: 'LedgerEntriesConnection';
      nodes: Array<{
        __typename?: 'LedgerEntry';
        id: string;
        ik: string;
        posted: string;
        description?: string | null;
        type?: string | null;
        isReversal: boolean;
        isReversed: boolean;
        reversalPosition: number;
        hidden: boolean;
        lines: {
          __typename?: 'LedgerLinesConnection';
          nodes: Array<{
            __typename?: 'LedgerLine';
            key?: string | null;
            id: string;
            account: { __typename?: 'LedgerAccount'; type: LedgerAccountTypes };
          }>;
        };
        reverses?: { __typename?: 'LedgerEntry'; id: string } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type ListLedgerEntryGroupsQueryVariables = Exact<{
  ledgerId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntryGroupsFilterSet>;
}>;

export type ListLedgerEntryGroupsQuery = {
  __typename?: 'Query';
  ledger?: {
    __typename: 'Ledger';
    name: string;
    id: string;
    ledgerEntryGroups: {
      __typename?: 'LedgerEntryGroupsConnection';
      nodes: Array<{
        __typename?: 'LedgerEntryGroup';
        dashboardUrl: string;
        key: string;
        value: string;
        created?: string | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type ListLedgerGroupBalancesQueryVariables = Exact<{
  ledgerEntryGroup: LedgerEntryGroupMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListLedgerGroupBalancesQuery = {
  __typename?: 'Query';
  ledgerEntryGroup?: {
    __typename?: 'LedgerEntryGroup';
    created?: string | null;
    balances: {
      __typename?: 'LedgerEntryGroupBalanceConnection';
      nodes: Array<{
        __typename?: 'LedgerEntryGroupBalance';
        ownBalance: string;
        account: {
          __typename?: 'LedgerAccount';
          name?: string | null;
          id: string;
          path: string;
          type: LedgerAccountTypes;
          link?:
            | { __typename: 'CustomLink' }
            | { __typename: 'IncreaseLink' }
            | { __typename: 'StripeLink' }
            | { __typename: 'UnitLink' }
            | null;
        };
        currency: {
          __typename?: 'Currency';
          code: CurrencyCode;
          customCode?: string | null;
          name: string;
          precision: number;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type ListLedgerGroupEntriesQueryVariables = Exact<{
  ledgerEntryGroup: LedgerEntryGroupMatchInput;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgerEntriesFilterSet>;
}>;

export type ListLedgerGroupEntriesQuery = {
  __typename?: 'Query';
  ledgerEntryGroup?: {
    __typename?: 'LedgerEntryGroup';
    created?: string | null;
    ledgerEntries: {
      __typename?: 'LedgerEntriesConnection';
      nodes: Array<{
        __typename?: 'LedgerEntry';
        ik: string;
        description?: string | null;
        type?: string | null;
        id: string;
        posted: string;
        hidden: boolean;
        lines: {
          __typename?: 'LedgerLinesConnection';
          nodes: Array<{
            __typename?: 'LedgerLine';
            account: { __typename?: 'LedgerAccount'; type: LedgerAccountTypes };
          }>;
        };
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type ListLedgersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LedgersFilterSet>;
}>;

export type ListLedgersQuery = {
  __typename?: 'Query';
  ledgers: {
    __typename?: 'LedgersConnection';
    nodes: Array<{
      __typename: 'Ledger';
      id: string;
      ik: string;
      name: string;
      created: string;
      schema?: { __typename?: 'Schema'; key: string } | null;
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
  };
};

export type ListLedgersBySchemaKeyQueryVariables = Exact<{
  schemaKey: Scalars['SafeString']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListLedgersBySchemaKeyQuery = {
  __typename?: 'Query';
  schema?: {
    __typename?: 'Schema';
    ledgers: {
      __typename?: 'LedgersConnection';
      nodes: Array<{
        __typename: 'Ledger';
        id: string;
        ik: string;
        name: string;
        created: string;
        schema?: { __typename?: 'Schema'; key: string } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type ListTemplateInstancesQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  pathMatch: StringMatchFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTemplateInstancesQuery = {
  __typename: 'Query';
  ledger?: {
    __typename?: 'Ledger';
    ledgerAccounts: {
      __typename: 'LedgerAccountsConnection';
      nodes: Array<{
        __typename?: 'LedgerAccount';
        id: string;
        path: string;
        type: LedgerAccountTypes;
        ik: string;
        currencyMode: CurrencyMode;
        parentLedgerAccount?: { __typename?: 'LedgerAccount'; id: string; path: string } | null;
        balances: {
          __typename?: 'CurrencyAmountConnection';
          nodes: Array<{
            __typename?: 'CurrencyAmount';
            amount: string;
            currency: {
              __typename?: 'Currency';
              code: CurrencyCode;
              name: string;
              precision: number;
              customCode?: string | null;
              customCurrencyId?: string | null;
            };
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            endCursor?: string | null;
          };
        };
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type QuerySimpleLedgerAccountBalancesQueryVariables = Exact<{
  ledger: LedgerMatchInput;
  pathMatch: StringMatchFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  balancesFirst?: InputMaybe<Scalars['Int']['input']>;
  balancesAfter?: InputMaybe<Scalars['String']['input']>;
}>;

export type QuerySimpleLedgerAccountBalancesQuery = {
  __typename: 'Query';
  ledger?: {
    __typename?: 'Ledger';
    ledgerAccounts: {
      __typename: 'LedgerAccountsConnection';
      nodes: Array<{
        __typename?: 'LedgerAccount';
        id: string;
        path: string;
        type: LedgerAccountTypes;
        ik: string;
        currencyMode: CurrencyMode;
        parentLedgerAccount?: { __typename?: 'LedgerAccount'; id: string; path: string } | null;
        balances: {
          __typename?: 'CurrencyAmountConnection';
          nodes: Array<{
            __typename?: 'CurrencyAmount';
            amount: string;
            currency: {
              __typename?: 'Currency';
              code: CurrencyCode;
              name: string;
              precision: number;
              customCode?: string | null;
              customCurrencyId?: string | null;
            };
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            endCursor?: string | null;
          };
        };
        currency?: {
          __typename?: 'Currency';
          code: CurrencyCode;
          name: string;
          precision: number;
          customCode?: string | null;
          customCurrencyId?: string | null;
        } | null;
      }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type ReconcileTxMutationVariables = Exact<{
  entry: LedgerEntryInput;
}>;

export type ReconcileTxMutation = {
  __typename?: 'Mutation';
  reconcileTx:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'ReconcileTxResult';
        isIkReplay: boolean;
        entry: {
          __typename?: 'LedgerEntry';
          id: string;
          ik: string;
          posted: string;
          created: string;
          date: string;
          description?: string | null;
          conditions: Array<{
            __typename?: 'LedgerEntryCondition';
            account: { __typename?: 'LedgerAccount'; id: string; name?: string | null };
            currency: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null };
            precondition?: {
              __typename?: 'LedgerAccountCondition';
              ownBalance?: {
                __typename?: 'Int96Condition';
                gte?: string | null;
                lte?: string | null;
                eq?: string | null;
              } | null;
            } | null;
            postcondition?: {
              __typename?: 'LedgerAccountCondition';
              ownBalance?: {
                __typename?: 'Int96Condition';
                gte?: string | null;
                lte?: string | null;
                eq?: string | null;
              } | null;
            } | null;
          }>;
          lines: {
            __typename?: 'LedgerLinesConnection';
            nodes: Array<{
              __typename?: 'LedgerLine';
              id: string;
              date?: string | null;
              posted?: string | null;
              created?: string | null;
              amount: string;
              type: TxType;
              ledgerId: string;
              accountId: string;
              ledgerEntryId: string;
              currency?: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null } | null;
            }>;
          };
          groups: Array<{ __typename?: 'LedgerEntryGroup'; key: string; value: string }>;
          tags: Array<{ __typename?: 'LedgerEntryTag'; key: string; value: string }>;
        };
        lines: Array<{
          __typename?: 'LedgerLine';
          key?: string | null;
          id: string;
          date?: string | null;
          posted?: string | null;
          created?: string | null;
          amount: string;
          type: TxType;
          ledgerId: string;
          accountId: string;
          ledgerEntryId: string;
          currency?: { __typename?: 'Currency'; code: CurrencyCode } | null;
        }>;
      };
};

export type ReverseLedgerEntryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ReverseLedgerEntryMutation = {
  __typename?: 'Mutation';
  reverseLedgerEntry:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'ReverseLedgerEntryResult';
        reversingLedgerEntry: {
          __typename?: 'LedgerEntry';
          id: string;
          ik: string;
          posted: string;
          isReversal: boolean;
          isReversed: boolean;
          reversalPosition: number;
          reverses?: { __typename?: 'LedgerEntry'; id: string } | null;
          reversedBy?: { __typename?: 'LedgerEntry'; id: string } | null;
          lines: {
            __typename?: 'LedgerLinesConnection';
            nodes: Array<{
              __typename?: 'LedgerLine';
              id: string;
              amount: string;
              accountId: string;
              ledgerEntry: { __typename?: 'LedgerEntry'; ik: string; id: string; reversalPosition: number };
              reverses?: { __typename?: 'LedgerLine'; id: string } | null;
            }>;
          };
          reversalHistory: {
            __typename?: 'LedgerEntriesConnection';
            nodes: Array<{ __typename?: 'LedgerEntry'; id: string; reversalPosition: number }>;
          };
        };
        reversedLedgerEntry: {
          __typename?: 'LedgerEntry';
          id: string;
          ik: string;
          posted: string;
          isReversal: boolean;
          isReversed: boolean;
          reversalPosition: number;
          reverses?: { __typename?: 'LedgerEntry'; id: string } | null;
          reversedBy?: { __typename?: 'LedgerEntry'; id: string } | null;
          lines: {
            __typename?: 'LedgerLinesConnection';
            nodes: Array<{
              __typename?: 'LedgerLine';
              id: string;
              amount: string;
              accountId: string;
              ledgerEntry: { __typename?: 'LedgerEntry'; ik: string; id: string; reversalPosition: number };
              reverses?: { __typename?: 'LedgerLine'; id: string } | null;
            }>;
          };
          reversalHistory: {
            __typename?: 'LedgerEntriesConnection';
            nodes: Array<{ __typename?: 'LedgerEntry'; id: string; reversalPosition: number }>;
          };
        };
      };
};

export type AddLedgerEntryMutationVariables = Exact<{
  entry: LedgerEntryInput;
  ik: Scalars['SafeString']['input'];
}>;

export type AddLedgerEntryMutation = {
  __typename?: 'Mutation';
  addLedgerEntry:
    | {
        __typename: 'AddLedgerEntryResult';
        isIkReplay: boolean;
        entry: {
          __typename?: 'LedgerEntry';
          id: string;
          ik: string;
          posted: string;
          created: string;
          date: string;
          description?: string | null;
          conditions: Array<{
            __typename?: 'LedgerEntryCondition';
            account: { __typename?: 'LedgerAccount'; id: string; name?: string | null };
            currency: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null };
            precondition?: {
              __typename?: 'LedgerAccountCondition';
              ownBalance?: {
                __typename?: 'Int96Condition';
                gte?: string | null;
                lte?: string | null;
                eq?: string | null;
              } | null;
            } | null;
            postcondition?: {
              __typename?: 'LedgerAccountCondition';
              ownBalance?: {
                __typename?: 'Int96Condition';
                gte?: string | null;
                lte?: string | null;
                eq?: string | null;
              } | null;
            } | null;
          }>;
          lines: {
            __typename?: 'LedgerLinesConnection';
            nodes: Array<{
              __typename?: 'LedgerLine';
              id: string;
              date?: string | null;
              posted?: string | null;
              created?: string | null;
              amount: string;
              type: TxType;
              ledgerId: string;
              accountId: string;
              ledgerEntryId: string;
              currency?: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null } | null;
            }>;
          };
          groups: Array<{ __typename?: 'LedgerEntryGroup'; key: string; value: string }>;
          tags: Array<{ __typename?: 'LedgerEntryTag'; key: string; value: string }>;
        };
        lines: Array<{
          __typename?: 'LedgerLine';
          key?: string | null;
          id: string;
          date?: string | null;
          posted?: string | null;
          created?: string | null;
          amount: string;
          type: TxType;
          ledgerId: string;
          accountId: string;
          ledgerEntryId: string;
          currency?: { __typename?: 'Currency'; code: CurrencyCode } | null;
        }>;
      }
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string };
};

export type MigrateLedgerEntryMutationVariables = Exact<{
  input: MigrateLedgerEntryInput;
}>;

export type MigrateLedgerEntryMutation = {
  __typename?: 'Mutation';
  migrateLedgerEntry:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'MigrateLedgerEntryResult';
        isIkReplay: boolean;
        newLedgerEntry: {
          __typename?: 'LedgerEntry';
          id: string;
          ik: string;
          posted: string;
          created: string;
          date: string;
          description?: string | null;
          conditions: Array<{
            __typename?: 'LedgerEntryCondition';
            account: { __typename?: 'LedgerAccount'; id: string; name?: string | null };
            currency: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null };
            precondition?: {
              __typename?: 'LedgerAccountCondition';
              ownBalance?: {
                __typename?: 'Int96Condition';
                gte?: string | null;
                lte?: string | null;
                eq?: string | null;
              } | null;
            } | null;
            postcondition?: {
              __typename?: 'LedgerAccountCondition';
              ownBalance?: {
                __typename?: 'Int96Condition';
                gte?: string | null;
                lte?: string | null;
                eq?: string | null;
              } | null;
            } | null;
          }>;
          lines: {
            __typename?: 'LedgerLinesConnection';
            nodes: Array<{
              __typename?: 'LedgerLine';
              id: string;
              date?: string | null;
              posted?: string | null;
              created?: string | null;
              amount: string;
              type: TxType;
              ledgerId: string;
              accountId: string;
              ledgerEntryId: string;
              currency?: { __typename?: 'Currency'; code: CurrencyCode; customCurrencyId?: string | null } | null;
            }>;
          };
          groups: Array<{ __typename?: 'LedgerEntryGroup'; key: string; value: string }>;
          tags: Array<{ __typename?: 'LedgerEntryTag'; key: string; value: string }>;
        };
      };
};

export type CreatePaymentMutationVariables = Exact<{
  ik: Scalars['SafeString']['input'];
  ledger: LedgerMatchInput;
  payment: CreatePaymentInput;
}>;

export type CreatePaymentMutation = {
  __typename?: 'Mutation';
  createPayment:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | {
        __typename: 'CreatePaymentResult';
        payment: {
          __typename?: 'Payment';
          id: string;
          clientSecret: string;
          status: PaymentStatus;
          amount: string;
          mode: PaymentMode;
          currency: { __typename?: 'PaymentCurrency'; code: PaymentCurrencyCode; precision: number };
        };
      }
    | { __typename: 'InternalError'; code: string; message: string };
};

export type GetSchemaQueryVariables = Exact<{
  key: Scalars['SafeString']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetSchemaQuery = {
  __typename?: 'Query';
  schema?: {
    __typename?: 'Schema';
    key: string;
    name: string;
    version: { __typename?: 'SchemaVersion'; version: number; json: Record<string, unknown>; created: string };
    versions: {
      __typename?: 'SchemaVersionConnection';
      nodes: Array<{ __typename?: 'SchemaVersion'; version: number; json: Record<string, unknown>; created: string }>;
    };
    ledgers: {
      __typename?: 'LedgersConnection';
      nodes: Array<{ __typename: 'Ledger'; ik: string; id: string; name: string }>;
    };
  } | null;
};

export type GetSchemaVersionsQueryVariables = Exact<{
  key: Scalars['SafeString']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSchemaVersionsQuery = {
  __typename?: 'Query';
  schema?: {
    __typename?: 'Schema';
    versions: {
      __typename?: 'SchemaVersionConnection';
      nodes: Array<{ __typename?: 'SchemaVersion'; version: number; created: string }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
    };
  } | null;
};

export type ListSchemasQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListSchemasQuery = {
  __typename?: 'Query';
  schemas: {
    __typename?: 'SchemaConnection';
    nodes: Array<{
      __typename: 'Schema';
      key: string;
      name: string;
      version: { __typename?: 'SchemaVersion'; version: number; created: string; json: Record<string, unknown> };
      ledgers: {
        __typename?: 'LedgersConnection';
        nodes: Array<{ __typename?: 'Ledger'; id: string; ik: string; name: string }>;
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          endCursor?: string | null;
        };
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; endCursor?: string | null };
  };
};

export type ListSchemasWithLedgersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListSchemasWithLedgersQuery = {
  __typename?: 'Query';
  schemas: {
    __typename?: 'SchemaConnection';
    nodes: Array<{
      __typename: 'Schema';
      key: string;
      versions: {
        __typename?: 'SchemaVersionConnection';
        nodes: Array<{ __typename?: 'SchemaVersion'; version: number; created: string; json: Record<string, unknown> }>;
      };
      ledgers: {
        __typename?: 'LedgersConnection';
        nodes: Array<{
          __typename?: 'Ledger';
          ik: string;
          id: string;
          ledgerEntries: {
            __typename?: 'LedgerEntriesConnection';
            nodes: Array<{ __typename?: 'LedgerEntry'; id: string }>;
          };
        }>;
      };
    }>;
  };
};

export type StoreSchemaMutationVariables = Exact<{
  schema: SchemaInput;
}>;

export type StoreSchemaMutation = {
  __typename?: 'Mutation';
  storeSchema:
    | { __typename: 'BadRequestError'; code: string; message: string }
    | { __typename: 'InternalError'; code: string; message: string }
    | {
        __typename: 'StoreSchemaResult';
        schema: {
          __typename?: 'Schema';
          key: string;
          version: { __typename?: 'SchemaVersion'; created: string; version: number; json: Record<string, unknown> };
        };
      };
};

export const GetExternalAccountLinkedAccountsDocument = gql`
    query GetExternalAccountLinkedAccounts($id: ID!, $after: String) {
  externalAccount(externalAccount: {id: $id}) {
    __typename
    ledgerAccounts(after: $after) {
      nodes {
        id
        ledgerId
        path
        name
        type
        ledger {
          name
          schema {
            key
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetExternalAccountLinkedAccountsQuery(
  options: Omit<Urql.UseQueryArgs<GetExternalAccountLinkedAccountsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetExternalAccountLinkedAccountsQuery, GetExternalAccountLinkedAccountsQueryVariables>({
    query: GetExternalAccountLinkedAccountsDocument,
    ...options,
  });
}
export const GetExternalAccountSummaryDocument = gql`
    query GetExternalAccountSummary($id: ID!) {
  externalAccount(externalAccount: {id: $id}) {
    __typename
    name
    id
    externalId
    link {
      __typename
      id
      name
    }
    currencyMode
    currency {
      code
      customCode
    }
  }
}
    `;

export function useGetExternalAccountSummaryQuery(
  options: Omit<Urql.UseQueryArgs<GetExternalAccountSummaryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetExternalAccountSummaryQuery, GetExternalAccountSummaryQueryVariables>({
    query: GetExternalAccountSummaryDocument,
    ...options,
  });
}
export const GetExternalAccountTxsDocument = gql`
    query GetExternalAccountTxs($id: ID!, $after: String, $first: Int) {
  externalAccount(externalAccount: {id: $id}) {
    __typename
    name
    id
    externalId
    txs(first: $first, after: $after) {
      nodes {
        id
        externalId
        description
        amount
        currency {
          code
          customCode
          name
          precision
        }
        posted
        ledgerLines {
          nodes {
            id
            accountId
            ledgerId
            ledgerEntryId
            description
            ledger {
              schema {
                key
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    link {
      __typename
      id
      name
    }
  }
}
    `;

export function useGetExternalAccountTxsQuery(
  options: Omit<Urql.UseQueryArgs<GetExternalAccountTxsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetExternalAccountTxsQuery, GetExternalAccountTxsQueryVariables>({
    query: GetExternalAccountTxsDocument,
    ...options,
  });
}
export const GetLinksDocument = gql`
    query GetLinks {
  links {
    __typename
    nodes {
      __typename
      id
      name
      created
      ... on IncreaseLink {
        increaseEnv
      }
      ... on UnitLink {
        unitEnv
      }
      ... on StripeLink {
        stripeEnv
      }
    }
  }
}
    `;

export function useGetLinksQuery(options?: Omit<Urql.UseQueryArgs<GetLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLinksQuery, GetLinksQueryVariables>({ query: GetLinksDocument, ...options });
}
export const ListExternalAccountsDocument = gql`
    query ListExternalAccounts($linkId: ID!) {
  link(link: {id: $linkId}) {
    __typename
    ... on IncreaseLink {
      increaseEnv
    }
    ... on UnitLink {
      unitEnv
    }
    ... on StripeLink {
      stripeEnv
    }
    id
    name
    created
    externalAccounts {
      nodes {
        id
        externalId
        name
        currency {
          code
          customCode
        }
        currencyMode
      }
    }
  }
}
    `;

export function useListExternalAccountsQuery(
  options: Omit<Urql.UseQueryArgs<ListExternalAccountsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListExternalAccountsQuery, ListExternalAccountsQueryVariables>({
    query: ListExternalAccountsDocument,
    ...options,
  });
}
export const SyncCustomAccountDocument = gql`
    mutation SyncCustomAccount($account: CustomAccountInput!, $link: LinkMatchInput!) {
  syncCustomAccounts(accounts: [$account], link: $link) {
    ... on Error {
      code
      message
    }
    ... on SyncCustomAccountsResult {
      accounts {
        id
      }
    }
  }
}
    `;

export function useSyncCustomAccountMutation() {
  return Urql.useMutation<SyncCustomAccountMutation, SyncCustomAccountMutationVariables>(SyncCustomAccountDocument);
}
export const SyncCustomTxDocument = gql`
    mutation SyncCustomTx($tx: CustomTxInput!, $link: LinkMatchInput!) {
  syncCustomTxs(txs: [$tx], link: $link) {
    ... on Error {
      code
      message
    }
    ... on SyncCustomTxsResult {
      txs {
        id
      }
    }
  }
}
    `;

export function useSyncCustomTxMutation() {
  return Urql.useMutation<SyncCustomTxMutation, SyncCustomTxMutationVariables>(SyncCustomTxDocument);
}
export const CreateLedgerDocument = gql`
    mutation CreateLedger($ik: SafeString!, $ledger: CreateLedgerInput!, $schema: SchemaMatchInput) {
  createLedger(ik: $ik, ledger: $ledger, schema: $schema) {
    __typename
    ... on CreateLedgerResult {
      ledger {
        id
        ik
        name
      }
      isIkReplay
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useCreateLedgerMutation() {
  return Urql.useMutation<CreateLedgerMutation, CreateLedgerMutationVariables>(CreateLedgerDocument);
}
export const DeleteLedgerDocument = gql`
    mutation DeleteLedger($ledgerId: ID!) {
  deleteLedger(ledger: {id: $ledgerId}) {
    __typename
    ... on DeleteLedgerResult {
      success
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useDeleteLedgerMutation() {
  return Urql.useMutation<DeleteLedgerMutation, DeleteLedgerMutationVariables>(DeleteLedgerDocument);
}
export const DeleteSchemaDocument = gql`
    mutation DeleteSchema($schema: SchemaMatchInput!) {
  deleteSchema(schema: $schema) {
    __typename
    ... on DeleteSchemaResult {
      success
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useDeleteSchemaMutation() {
  return Urql.useMutation<DeleteSchemaMutation, DeleteSchemaMutationVariables>(DeleteSchemaDocument);
}
export const GetCustomCurrenciesDocument = gql`
    query GetCustomCurrencies($first: Int) {
  customCurrencies(first: $first) {
    nodes {
      code
      customCode
      customCurrencyId
      name
      precision
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

export function useGetCustomCurrenciesQuery(
  options?: Omit<Urql.UseQueryArgs<GetCustomCurrenciesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetCustomCurrenciesQuery, GetCustomCurrenciesQueryVariables>({
    query: GetCustomCurrenciesDocument,
    ...options,
  });
}
export const GetEntryStatsDocument = gql`
    query GetEntryStats($ledger: LedgerMatchInput!, $after: String) {
  ledger(ledger: $ledger) {
    __typename
    id
    ik
    schema {
      key
    }
    created
    balanceUTCOffset
    entryStats(first: 200, after: $after) {
      nodes {
        schemaKey
        ledgerId
        type
        typeVersion
        count
        reversalsCount
        netCount
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

export function useGetEntryStatsQuery(options: Omit<Urql.UseQueryArgs<GetEntryStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEntryStatsQuery, GetEntryStatsQueryVariables>({ query: GetEntryStatsDocument, ...options });
}
export const GetLedgerDocument = gql`
    query GetLedger($ledger: LedgerMatchInput!, $after: String) {
  ledger(ledger: $ledger) {
    __typename
    name
    id
    ik
    schema {
      key
    }
    created
    balanceUTCOffset
    entryStats(first: 200, after: $after) {
      nodes {
        schemaKey
        ledgerId
        type
        typeVersion
        count
        reversalsCount
        netCount
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerQuery(options: Omit<Urql.UseQueryArgs<GetLedgerQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLedgerQuery, GetLedgerQueryVariables>({ query: GetLedgerDocument, ...options });
}
export const GetLedgerAccountDocument = gql`
    query GetLedgerAccount($ledgerAccount: LedgerAccountMatchInput!, $ledgerId: ID!, $after: String, $balancesFirst: Int = 50, $balancesAfter: String, $ownBalancesFirst: Int = 50, $ownBalancesAfter: String, $childBalancesFirst: Int = 50, $childBalancesAfter: String) {
  __typename
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    __typename
    id
    path
    ledgerId
    name
    type
    created
    payment {
      enabled
    }
    currencyMode
    currency {
      code
      name
      precision
      customCode
      customCurrencyId
    }
    parentLedgerAccount {
      id
      name
    }
    link {
      __typename
      ... on CustomLink {
        id
        name
        created
      }
      ... on IncreaseLink {
        id
        name
        created
        increaseEnv
      }
      ... on UnitLink {
        id
        name
        created
        unitEnv
      }
    }
    lines(after: $after) {
      nodes {
        __typename
        id
        description
        created
        posted
        amount
        txId
        ledgerEntryId
        isReversal
        isReversed
        hidden
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    balances(first: $balancesFirst, after: $balancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    ownBalances(first: $ownBalancesFirst, after: $ownBalancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    childBalances(first: $childBalancesFirst, after: $childBalancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    linkedAccount {
      externalId
      id
      linkId
      name
    }
  }
  childAccounts: ledger(ledger: {id: $ledgerId}) {
    ledgerAccounts(filter: {parentLedgerAccount: {in: [$ledgerAccount]}}) {
      nodes {
        id
      }
    }
  }
}
    `;

export function useGetLedgerAccountQuery(options: Omit<Urql.UseQueryArgs<GetLedgerAccountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLedgerAccountQuery, GetLedgerAccountQueryVariables>({
    query: GetLedgerAccountDocument,
    ...options,
  });
}
export const GetLedgerAccountBalancesDocument = gql`
    query GetLedgerAccountBalances($ledgerAccount: LedgerAccountMatchInput!, $balancesFirst: Int = 50, $balancesAfter: String, $ownBalancesFirst: Int = 50, $ownBalancesAfter: String, $childBalancesFirst: Int = 50, $childBalancesAfter: String) {
  __typename
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    __typename
    id
    path
    ledgerId
    name
    type
    created
    currencyMode
    currency {
      code
      name
      precision
      customCode
      customCurrencyId
    }
    parentLedgerAccount {
      id
      name
    }
    balances(first: $balancesFirst, after: $balancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    ownBalances(
      consistencyMode: use_account
      first: $ownBalancesFirst
      after: $ownBalancesAfter
    ) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    linkedAccount {
      id
      externalId
      name
      link {
        __typename
      }
    }
    payment {
      enabled
    }
    childBalances(first: $childBalancesFirst, after: $childBalancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    link {
      __typename
      ... on CustomLink {
        id
        name
        created
      }
      ... on IncreaseLink {
        id
        name
        created
        increaseEnv
      }
      ... on UnitLink {
        id
        name
        created
        unitEnv
      }
    }
  }
}
    `;

export function useGetLedgerAccountBalancesQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountBalancesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountBalancesQuery, GetLedgerAccountBalancesQueryVariables>({
    query: GetLedgerAccountBalancesDocument,
    ...options,
  });
}
export const GetLedgerAccountCrumbDataDocument = gql`
    query GetLedgerAccountCrumbData($ledger: LedgerMatchInput!, $filter: LedgerAccountsFilterSet) {
  ledger(ledger: $ledger) {
    __typename
    ledgerAccounts(filter: $filter) {
      __typename
      nodes {
        __typename
        id
        name
        path
      }
    }
  }
}
    `;

export function useGetLedgerAccountCrumbDataQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountCrumbDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountCrumbDataQuery, GetLedgerAccountCrumbDataQueryVariables>({
    query: GetLedgerAccountCrumbDataDocument,
    ...options,
  });
}
export const GetLedgerAccountDataMigrationsDocument = gql`
    query GetLedgerAccountDataMigrations($ledger: LedgerMatchInput!, $after: String, $first: Int, $filter: LedgerAccountDataMigrationsFilterSet) {
  ledger(ledger: $ledger) {
    __typename
    id
    name
    ledgerAccountDataMigrations(after: $after, first: $first, filter: $filter) {
      nodes {
        __typename
        accountPath
        status
        currentMigration {
          schemaVersion
          status
        }
        history {
          nodes {
            schemaVersion
            status
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
        }
        ledgerEntries {
          nodes {
            id
            ik
            description
            posted
            created
            type
            typeVersion
            isReversal
            isReversed
            hidden
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerAccountDataMigrationsQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountDataMigrationsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountDataMigrationsQuery, GetLedgerAccountDataMigrationsQueryVariables>({
    query: GetLedgerAccountDataMigrationsDocument,
    ...options,
  });
}
export const GetLedgerAccountDetailDocument = gql`
    query GetLedgerAccountDetail($ledgerAccount: LedgerAccountMatchInput!, $ledgerId: ID!) {
  __typename
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    __typename
    id
    ledgerId
    path
  }
  childAccounts: ledger(ledger: {id: $ledgerId}) {
    ledgerAccounts(filter: {parentLedgerAccount: {in: [$ledgerAccount]}}) {
      nodes {
        id
      }
    }
  }
}
    `;

export function useGetLedgerAccountDetailQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountDetailQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountDetailQuery, GetLedgerAccountDetailQueryVariables>({
    query: GetLedgerAccountDetailDocument,
    ...options,
  });
}
export const GetLedgerAccountBalancesDuringDocument = gql`
    query GetLedgerAccountBalancesDuring($ledgerAccount: LedgerAccountMatchInput!, $startTime: FirstMoment!, $duration: Int!, $granularity: Granularity!, $currency: CurrencyMatchInput) {
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    balancesDuring(
      startTime: $startTime
      duration: $duration
      granularity: $granularity
      currency: $currency
    ) {
      granularity
      startTime
      endTime
      nodes {
        at
        amount {
          currency {
            code
            customCurrencyId
          }
          amount
        }
      }
    }
    childBalancesDuring(
      startTime: $startTime
      duration: $duration
      granularity: $granularity
      currency: $currency
    ) {
      granularity
      startTime
      endTime
      nodes {
        at
        amount {
          currency {
            code
            customCurrencyId
          }
          amount
        }
      }
    }
    ownBalancesDuring(
      startTime: $startTime
      duration: $duration
      granularity: $granularity
      currency: $currency
    ) {
      granularity
      startTime
      endTime
      nodes {
        at
        amount {
          currency {
            code
            customCurrencyId
          }
          amount
        }
      }
    }
  }
}
    `;

export function useGetLedgerAccountBalancesDuringQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountBalancesDuringQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountBalancesDuringQuery, GetLedgerAccountBalancesDuringQueryVariables>({
    query: GetLedgerAccountBalancesDuringDocument,
    ...options,
  });
}
export const GetLedgerAccountLineDownloadDocument = gql`
    query GetLedgerAccountLineDownload($ledgerAccount: LedgerAccountMatchInput!, $after: String, $first: Int) {
  __typename
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    __typename
    id
    lines(after: $after, first: $first) {
      nodes {
        ledgerEntry {
          ik
          id
          type
        }
        id
        posted
        description
        amount
        currency {
          code
          customCode
        }
        created
        tx {
          externalId
          externalAccountId
          linkId
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerAccountLineDownloadQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountLineDownloadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountLineDownloadQuery, GetLedgerAccountLineDownloadQueryVariables>({
    query: GetLedgerAccountLineDownloadDocument,
    ...options,
  });
}
export const GetLedgerAccountLinesDocument = gql`
    query GetLedgerAccountLines($ledgerAccount: LedgerAccountMatchInput!, $after: String, $first: Int, $filter: LedgerLinesFilterSet, $balancesFirst: Int = 50, $balancesAfter: String, $childBalancesFirst: Int = 50, $childBalancesAfter: String, $ownBalancesFirst: Int = 50, $ownBalancesAfter: String) {
  __typename
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    __typename
    id
    path
    ledgerId
    name
    type
    currencyMode
    created
    linkedAccount {
      id
      externalId
      name
      link {
        __typename
      }
    }
    payment {
      enabled
    }
    currency {
      code
      name
      precision
      customCode
      customCurrencyId
    }
    balances(first: $balancesFirst, after: $balancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    childBalances(first: $childBalancesFirst, after: $childBalancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    ownBalances(
      consistencyMode: use_account
      first: $ownBalancesFirst
      after: $ownBalancesAfter
    ) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    lines(after: $after, first: $first, filter: $filter) {
      __typename
      nodes {
        __typename
        id
        description
        ledgerEntryId
        ledgerEntry {
          type
        }
        created
        posted
        amount
        txId
        isReversal
        isReversed
        hidden
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerAccountLinesQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountLinesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountLinesQuery, GetLedgerAccountLinesQueryVariables>({
    query: GetLedgerAccountLinesDocument,
    ...options,
  });
}
export const GetLedgerAccountSummaryDocument = gql`
    query GetLedgerAccountSummary($ledgerAccount: LedgerAccountMatchInput!, $balancesFirst: Int = 50, $balancesAfter: String, $childBalancesFirst: Int = 50, $childBalancesAfter: String, $ownBalancesFirst: Int = 50, $ownBalancesAfter: String) {
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    __typename
    id
    path
    name
    type
    currencyMode
    ledgerId
    created
    currency {
      code
      name
      precision
      customCode
      customCurrencyId
    }
    linkedAccount {
      id
      externalId
      name
      link {
        __typename
      }
    }
    payment {
      enabled
    }
    balances(first: $balancesFirst, after: $balancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    childBalances(first: $childBalancesFirst, after: $childBalancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    ownBalances(
      consistencyMode: use_account
      first: $ownBalancesFirst
      after: $ownBalancesAfter
    ) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerAccountSummaryQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountSummaryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountSummaryQuery, GetLedgerAccountSummaryQueryVariables>({
    query: GetLedgerAccountSummaryDocument,
    ...options,
  });
}
export const GetLedgerAccountsDocument = gql`
    query GetLedgerAccounts($ledger: LedgerMatchInput!, $filter: LedgerAccountsFilterSet, $first: Int, $after: String, $balancesFirst: Int = 50, $balancesAfter: String) {
  ledger(ledger: $ledger) {
    __typename
    ledgerAccounts(filter: $filter, first: $first, after: $after) {
      __typename
      nodes {
        __typename
        id
        path
        ledgerId
        name
        type
        balances(first: $balancesFirst, after: $balancesAfter) {
          nodes {
            amount
            currency {
              code
              name
              precision
              customCode
              customCurrencyId
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
          }
        }
        currencyMode
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
        link {
          __typename
          id
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerAccountsQuery(options: Omit<Urql.UseQueryArgs<GetLedgerAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLedgerAccountsQuery, GetLedgerAccountsQueryVariables>({
    query: GetLedgerAccountsDocument,
    ...options,
  });
}
export const GetLedgerAccountsForPostEntryDocument = gql`
    query GetLedgerAccountsForPostEntry($ledger: LedgerMatchInput!, $filter: LedgerAccountsFilterSet, $first: Int, $after: String) {
  ledger(ledger: $ledger) {
    __typename
    ledgerAccounts(filter: $filter, first: $first, after: $after) {
      __typename
      nodes {
        __typename
        path
        type
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerAccountsForPostEntryQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerAccountsForPostEntryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerAccountsForPostEntryQuery, GetLedgerAccountsForPostEntryQueryVariables>({
    query: GetLedgerAccountsForPostEntryDocument,
    ...options,
  });
}
export const GetLedgerEntryDocument = gql`
    query GetLedgerEntry($entryId: ID!) {
  ledgerEntry(ledgerEntry: {id: $entryId}) {
    __typename
    id
    ik
    description
    posted
    created
    ledger {
      id
      name
    }
    parameters
    type
    typeVersion
    isReversal
    isReversed
    reverses {
      type
      id
    }
    reversedBy {
      id
      ik
      description
      posted
      created
      ledger {
        id
        name
      }
      parameters
      type
      posted
      created
      description
      lines {
        nodes {
          id
          created
          posted
          account {
            id
            path
            name
            type
            link {
              __typename
              id
              name
            }
            linkedAccount {
              id
              name
            }
          }
          txId
          externalTxId
          description
          amount
          currency {
            code
            name
            precision
            customCode
            customCurrencyId
          }
        }
      }
      reversalPosition
      groups {
        key
        value
      }
      tags {
        key
        value
      }
    }
    reversalPosition
    reversalHistory {
      nodes {
        reversalPosition
        id
        created
        type
        lines {
          nodes {
            account {
              type
            }
          }
        }
        isReversal
        isReversed
        hidden
      }
    }
    hidden
    lines {
      nodes {
        id
        created
        posted
        account {
          id
          path
          name
          type
          link {
            __typename
            id
            name
          }
          linkedAccount {
            id
            name
          }
        }
        txId
        externalTxId
        description
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
        tags {
          key
          value
        }
      }
    }
    groups {
      key
      value
    }
    tags {
      key
      value
    }
  }
}
    `;

export function useGetLedgerEntryQuery(options: Omit<Urql.UseQueryArgs<GetLedgerEntryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLedgerEntryQuery, GetLedgerEntryQueryVariables>({
    query: GetLedgerEntryDocument,
    ...options,
  });
}
export const GetLedgerEntryDataMigrationsDocument = gql`
    query GetLedgerEntryDataMigrations($ledger: LedgerMatchInput!, $after: String, $first: Int, $filter: LedgerEntryDataMigrationsFilterSet) {
  ledger(ledger: $ledger) {
    __typename
    id
    name
    ledgerEntryDataMigrations(after: $after, first: $first, filter: $filter) {
      nodes {
        __typename
        entryType
        typeVersion
        status
        currentMigration {
          schemaVersion
          status
        }
        history {
          nodes {
            schemaVersion
            status
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
        }
        ledgerEntries {
          nodes {
            id
            ik
            description
            posted
            created
            type
            typeVersion
            isReversal
            isReversed
            hidden
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerEntryDataMigrationsQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerEntryDataMigrationsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerEntryDataMigrationsQuery, GetLedgerEntryDataMigrationsQueryVariables>({
    query: GetLedgerEntryDataMigrationsDocument,
    ...options,
  });
}
export const GetLedgerEntryDownloadDocument = gql`
    query GetLedgerEntryDownload($ledgerId: ID, $after: String, $first: Int, $filter: LedgerEntriesFilterSet) {
  ledger(ledger: {id: $ledgerId}) {
    __typename
    id
    ik
    name
    ledgerEntries(after: $after, first: $first, filter: $filter) {
      nodes {
        id
        ik
        posted
        created
        description
        type
        typeVersion
        isReversal
        isReversed
        reversalPosition
        hidden
        date
        dashboardUrl
        parameters
        lines {
          nodes {
            id
            key
            posted
            created
            description
            amount
            account {
              id
              path
              name
              type
            }
            currency {
              code
              name
              precision
              customCode
              customCurrencyId
            }
          }
        }
        groups {
          key
          value
        }
        tags {
          key
          value
        }
        reverses {
          id
          ik
          type
        }
        reversedBy {
          id
          ik
          type
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetLedgerEntryDownloadQuery(
  options?: Omit<Urql.UseQueryArgs<GetLedgerEntryDownloadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerEntryDownloadQuery, GetLedgerEntryDownloadQueryVariables>({
    query: GetLedgerEntryDownloadDocument,
    ...options,
  });
}
export const GetLedgerEntryGroupDocument = gql`
    query GetLedgerEntryGroup($ledger: LedgerMatchInput!, $ledgerEntryGroup: EntryGroupMatchInput!) {
  ledger(ledger: $ledger) {
    __typename
    name
    id
    ik
    ledgerEntryGroup(ledgerEntryGroup: $ledgerEntryGroup) {
      __typename
      created
      key
      value
    }
  }
}
    `;

export function useGetLedgerEntryGroupQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerEntryGroupQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerEntryGroupQuery, GetLedgerEntryGroupQueryVariables>({
    query: GetLedgerEntryGroupDocument,
    ...options,
  });
}
export const GetLedgerEntryGroupEntriesDocument = gql`
    query GetLedgerEntryGroupEntries($ledger: LedgerMatchInput!, $ledgerEntryGroup: EntryGroupMatchInput!, $after: String) {
  ledger(ledger: $ledger) {
    __typename
    name
    id
    ik
    ledgerEntryGroup(ledgerEntryGroup: $ledgerEntryGroup) {
      ledgerEntries(first: 100, after: $after) {
        nodes {
          type
          posted
          lines {
            nodes {
              amount
              account {
                type
                path
              }
              currency {
                code
                customCurrencyId
                precision
                name
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
}
    `;

export function useGetLedgerEntryGroupEntriesQuery(
  options: Omit<Urql.UseQueryArgs<GetLedgerEntryGroupEntriesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetLedgerEntryGroupEntriesQuery, GetLedgerEntryGroupEntriesQueryVariables>({
    query: GetLedgerEntryGroupEntriesDocument,
    ...options,
  });
}
export const GetPaymentDocument = gql`
    query GetPayment($payment: PaymentMatchInput!) {
  payment(payment: $payment) {
    ik
    status
    amount
    type
    created
    parameters
    events {
      nodes {
        __typename
        occurredAt
        status
        ... on PaymentCardCapturedEvent {
          cardCapturedLedgerEntry: ledgerEntry {
            id
            ik
            type
            lines {
              nodes {
                account {
                  type
                }
              }
            }
          }
        }
        ... on PaymentSettledEvent {
          settledLedgerEntry: ledgerEntry {
            id
            ik
            type
            lines {
              nodes {
                account {
                  type
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useGetPaymentQuery(options: Omit<Urql.UseQueryArgs<GetPaymentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPaymentQuery, GetPaymentQueryVariables>({ query: GetPaymentDocument, ...options });
}
export const GetPaymentsDocument = gql`
    query GetPayments($ledger: LedgerMatchInput!, $first: Int, $after: String) {
  ledger(ledger: $ledger) {
    payments(first: $first, after: $after) {
      nodes {
        ik
        status
        amount
        type
        created
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    `;

export function useGetPaymentsQuery(options: Omit<Urql.UseQueryArgs<GetPaymentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPaymentsQuery, GetPaymentsQueryVariables>({ query: GetPaymentsDocument, ...options });
}
export const GetTxDocument = gql`
    query GetTx($txId: ID!) {
  tx(tx: {id: $txId}) {
    __typename
    id
    externalId
    description
    posted
    amount
    currency {
      code
      customCurrencyId
      name
      precision
    }
    link {
      __typename
      id
      name
    }
    ledgerEntries {
      nodes {
        id
      }
    }
    externalAccount {
      id
      name
    }
  }
}
    `;

export function useGetTxQuery(options: Omit<Urql.UseQueryArgs<GetTxQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTxQuery, GetTxQueryVariables>({ query: GetTxDocument, ...options });
}
export const GetUnreconciledTxsDocument = gql`
    query GetUnreconciledTxs($ledgerAccount: LedgerAccountMatchInput!, $first: Int, $after: String, $balancesFirst: Int = 50, $balancesAfter: String, $childBalancesFirst: Int = 50, $childBalancesAfter: String, $ownBalancesFirst: Int = 50, $ownBalancesAfter: String) {
  ledgerAccount(ledgerAccount: $ledgerAccount) {
    type
    id
    name
    ledgerId
    path
    currencyMode
    created
    currency {
      code
      customCode
      precision
      customCurrencyId
      name
    }
    linkedAccount {
      id
      externalId
      name
      link {
        __typename
        ... on IncreaseLink {
          increaseEnv
        }
        ... on UnitLink {
          unitEnv
        }
        id
      }
    }
    payment {
      enabled
    }
    balances(first: $balancesFirst, after: $balancesAfter) {
      nodes {
        amount
        currency {
          code
          customCode
          precision
          customCurrencyId
          name
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    childBalances(first: $childBalancesFirst, after: $childBalancesAfter) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    ownBalances(
      consistencyMode: use_account
      first: $ownBalancesFirst
      after: $ownBalancesAfter
    ) {
      nodes {
        amount
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
    unreconciledTxs(first: $first, after: $after) {
      nodes {
        id
        amount
        description
        externalId
        posted
        currency {
          code
          customCode
          precision
          customCurrencyId
          name
        }
        ledgerLines {
          nodes {
            id
            accountId
            ledgerId
            ledgerEntryId
            description
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    `;

export function useGetUnreconciledTxsQuery(
  options: Omit<Urql.UseQueryArgs<GetUnreconciledTxsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetUnreconciledTxsQuery, GetUnreconciledTxsQueryVariables>({
    query: GetUnreconciledTxsDocument,
    ...options,
  });
}
export const LedgerLineEntrySectionGetLedgerEntryDocument = gql`
    query LedgerLineEntrySectionGetLedgerEntry($entryId: ID!) {
  ledgerEntry(ledgerEntry: {id: $entryId}) {
    __typename
    id
    ik
    type
    lines {
      nodes {
        id
        account {
          type
        }
      }
    }
  }
}
    `;

export function useLedgerLineEntrySectionGetLedgerEntryQuery(
  options: Omit<Urql.UseQueryArgs<LedgerLineEntrySectionGetLedgerEntryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LedgerLineEntrySectionGetLedgerEntryQuery, LedgerLineEntrySectionGetLedgerEntryQueryVariables>({
    query: LedgerLineEntrySectionGetLedgerEntryDocument,
    ...options,
  });
}
export const ListLedgerEntriesDocument = gql`
    query ListLedgerEntries($ledgerId: ID, $after: String, $filter: LedgerEntriesFilterSet) {
  ledger(ledger: {id: $ledgerId}) {
    __typename
    name
    id
    ledgerEntries(after: $after, filter: $filter) {
      nodes {
        id
        ik
        posted
        description
        type
        isReversal
        isReversed
        reversalPosition
        hidden
        lines {
          nodes {
            key
            id
            account {
              type
            }
          }
        }
        reverses {
          id
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useListLedgerEntriesQuery(options?: Omit<Urql.UseQueryArgs<ListLedgerEntriesQueryVariables>, 'query'>) {
  return Urql.useQuery<ListLedgerEntriesQuery, ListLedgerEntriesQueryVariables>({
    query: ListLedgerEntriesDocument,
    ...options,
  });
}
export const ListLedgerEntryGroupsDocument = gql`
    query ListLedgerEntryGroups($ledgerId: ID!, $after: String, $filter: LedgerEntryGroupsFilterSet) {
  ledger(ledger: {id: $ledgerId}) {
    __typename
    name
    id
    ledgerEntryGroups(after: $after, filter: $filter) {
      nodes {
        dashboardUrl
        key
        value
        created
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useListLedgerEntryGroupsQuery(
  options: Omit<Urql.UseQueryArgs<ListLedgerEntryGroupsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListLedgerEntryGroupsQuery, ListLedgerEntryGroupsQueryVariables>({
    query: ListLedgerEntryGroupsDocument,
    ...options,
  });
}
export const ListLedgerGroupBalancesDocument = gql`
    query ListLedgerGroupBalances($ledgerEntryGroup: LedgerEntryGroupMatchInput!, $after: String) {
  ledgerEntryGroup(ledgerEntryGroup: $ledgerEntryGroup) {
    created
    balances(after: $after) {
      nodes {
        account {
          name
          id
          path
          type
          link {
            __typename
          }
        }
        ownBalance
        currency {
          code
          customCode
          name
          precision
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useListLedgerGroupBalancesQuery(
  options: Omit<Urql.UseQueryArgs<ListLedgerGroupBalancesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListLedgerGroupBalancesQuery, ListLedgerGroupBalancesQueryVariables>({
    query: ListLedgerGroupBalancesDocument,
    ...options,
  });
}
export const ListLedgerGroupEntriesDocument = gql`
    query ListLedgerGroupEntries($ledgerEntryGroup: LedgerEntryGroupMatchInput!, $after: String, $filter: LedgerEntriesFilterSet) {
  ledgerEntryGroup(ledgerEntryGroup: $ledgerEntryGroup) {
    created
    ledgerEntries(after: $after, filter: $filter) {
      nodes {
        ik
        description
        type
        id
        posted
        hidden
        lines {
          nodes {
            account {
              type
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useListLedgerGroupEntriesQuery(
  options: Omit<Urql.UseQueryArgs<ListLedgerGroupEntriesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListLedgerGroupEntriesQuery, ListLedgerGroupEntriesQueryVariables>({
    query: ListLedgerGroupEntriesDocument,
    ...options,
  });
}
export const ListLedgersDocument = gql`
    query ListLedgers($first: Int, $after: String, $filter: LedgersFilterSet) {
  ledgers(first: $first, after: $after, filter: $filter) {
    nodes {
      __typename
      id
      ik
      name
      created
      schema {
        key
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    `;

export function useListLedgersQuery(options?: Omit<Urql.UseQueryArgs<ListLedgersQueryVariables>, 'query'>) {
  return Urql.useQuery<ListLedgersQuery, ListLedgersQueryVariables>({ query: ListLedgersDocument, ...options });
}
export const ListLedgersBySchemaKeyDocument = gql`
    query ListLedgersBySchemaKey($schemaKey: SafeString!, $first: Int, $after: String) {
  schema(schema: {key: $schemaKey}) {
    ledgers(first: $first, after: $after) {
      nodes {
        __typename
        id
        ik
        name
        created
        schema {
          key
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useListLedgersBySchemaKeyQuery(
  options: Omit<Urql.UseQueryArgs<ListLedgersBySchemaKeyQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListLedgersBySchemaKeyQuery, ListLedgersBySchemaKeyQueryVariables>({
    query: ListLedgersBySchemaKeyDocument,
    ...options,
  });
}
export const ListTemplateInstancesDocument = gql`
    query ListTemplateInstances($ledger: LedgerMatchInput!, $pathMatch: StringMatchFilter!, $first: Int, $after: String, $balancesFirst: Int = 50, $balancesAfter: String) {
  __typename
  ledger(ledger: $ledger) {
    ledgerAccounts(first: $first, after: $after, filter: {path: $pathMatch}) {
      __typename
      nodes {
        id
        path
        type
        parentLedgerAccount {
          id
          path
        }
        ik
        balances(first: $balancesFirst, after: $balancesAfter) {
          nodes {
            amount
            currency {
              code
              name
              precision
              customCode
              customCurrencyId
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
          }
        }
        currencyMode
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useListTemplateInstancesQuery(
  options: Omit<Urql.UseQueryArgs<ListTemplateInstancesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListTemplateInstancesQuery, ListTemplateInstancesQueryVariables>({
    query: ListTemplateInstancesDocument,
    ...options,
  });
}
export const QuerySimpleLedgerAccountBalancesDocument = gql`
    query QuerySimpleLedgerAccountBalances($ledger: LedgerMatchInput!, $pathMatch: StringMatchFilter!, $first: Int, $after: String, $balancesFirst: Int = 50, $balancesAfter: String) {
  __typename
  ledger(ledger: $ledger) {
    ledgerAccounts(first: $first, after: $after, filter: {path: $pathMatch}) {
      __typename
      nodes {
        id
        path
        type
        parentLedgerAccount {
          id
          path
        }
        ik
        balances(first: $balancesFirst, after: $balancesAfter) {
          nodes {
            amount
            currency {
              code
              name
              precision
              customCode
              customCurrencyId
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
          }
        }
        currencyMode
        currency {
          code
          name
          precision
          customCode
          customCurrencyId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useQuerySimpleLedgerAccountBalancesQuery(
  options: Omit<Urql.UseQueryArgs<QuerySimpleLedgerAccountBalancesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<QuerySimpleLedgerAccountBalancesQuery, QuerySimpleLedgerAccountBalancesQueryVariables>({
    query: QuerySimpleLedgerAccountBalancesDocument,
    ...options,
  });
}
export const ReconcileTxDocument = gql`
    mutation ReconcileTx($entry: LedgerEntryInput!) {
  reconcileTx(entry: $entry) {
    __typename
    ... on ReconcileTxResult {
      entry {
        id
        ik
        posted
        created
        date
        description
        conditions {
          account {
            id
            name
          }
          currency {
            code
            customCurrencyId
          }
          precondition {
            ownBalance {
              gte
              lte
              eq
            }
          }
          postcondition {
            ownBalance {
              gte
              lte
              eq
            }
          }
        }
        lines {
          nodes {
            id
            currency {
              code
              customCurrencyId
            }
            date
            posted
            created
            amount
            type
            ledgerId
            accountId
            ledgerEntryId
          }
        }
        groups {
          key
          value
        }
        tags {
          key
          value
        }
      }
      lines {
        key
        id
        currency {
          code
        }
        date
        posted
        created
        amount
        type
        ledgerId
        accountId
        ledgerEntryId
      }
      isIkReplay
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useReconcileTxMutation() {
  return Urql.useMutation<ReconcileTxMutation, ReconcileTxMutationVariables>(ReconcileTxDocument);
}
export const ReverseLedgerEntryDocument = gql`
    mutation ReverseLedgerEntry($id: ID!) {
  reverseLedgerEntry(id: $id) {
    __typename
    ... on ReverseLedgerEntryResult {
      reversingLedgerEntry {
        id
        ik
        posted
        isReversal
        isReversed
        reversalPosition
        reverses {
          id
        }
        reversedBy {
          id
        }
        lines {
          nodes {
            id
            amount
            accountId
            ledgerEntry {
              ik
              id
              reversalPosition
            }
            reverses {
              id
            }
          }
        }
        reversalHistory {
          nodes {
            id
            reversalPosition
          }
        }
      }
      reversedLedgerEntry {
        id
        ik
        posted
        isReversal
        isReversed
        reversalPosition
        reverses {
          id
        }
        reversedBy {
          id
        }
        lines {
          nodes {
            id
            amount
            accountId
            ledgerEntry {
              ik
              id
              reversalPosition
            }
            reverses {
              id
            }
          }
        }
        reversalHistory {
          nodes {
            id
            reversalPosition
          }
        }
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useReverseLedgerEntryMutation() {
  return Urql.useMutation<ReverseLedgerEntryMutation, ReverseLedgerEntryMutationVariables>(ReverseLedgerEntryDocument);
}
export const AddLedgerEntryDocument = gql`
    mutation AddLedgerEntry($entry: LedgerEntryInput!, $ik: SafeString!) {
  addLedgerEntry(ik: $ik, entry: $entry) {
    __typename
    ... on AddLedgerEntryResult {
      entry {
        id
        ik
        posted
        created
        date
        description
        conditions {
          account {
            id
            name
          }
          currency {
            code
            customCurrencyId
          }
          precondition {
            ownBalance {
              gte
              lte
              eq
            }
          }
          postcondition {
            ownBalance {
              gte
              lte
              eq
            }
          }
        }
        lines {
          nodes {
            id
            currency {
              code
              customCurrencyId
            }
            date
            posted
            created
            amount
            type
            ledgerId
            accountId
            ledgerEntryId
          }
        }
        groups {
          key
          value
        }
        tags {
          key
          value
        }
      }
      lines {
        key
        id
        currency {
          code
        }
        date
        posted
        created
        amount
        type
        ledgerId
        accountId
        ledgerEntryId
      }
      isIkReplay
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useAddLedgerEntryMutation() {
  return Urql.useMutation<AddLedgerEntryMutation, AddLedgerEntryMutationVariables>(AddLedgerEntryDocument);
}
export const MigrateLedgerEntryDocument = gql`
    mutation MigrateLedgerEntry($input: MigrateLedgerEntryInput!) {
  migrateLedgerEntry(input: $input) {
    __typename
    ... on MigrateLedgerEntryResult {
      newLedgerEntry {
        id
        ik
        posted
        created
        date
        description
        conditions {
          account {
            id
            name
          }
          currency {
            code
            customCurrencyId
          }
          precondition {
            ownBalance {
              gte
              lte
              eq
            }
          }
          postcondition {
            ownBalance {
              gte
              lte
              eq
            }
          }
        }
        lines {
          nodes {
            id
            currency {
              code
              customCurrencyId
            }
            date
            posted
            created
            amount
            type
            ledgerId
            accountId
            ledgerEntryId
          }
        }
        groups {
          key
          value
        }
        tags {
          key
          value
        }
      }
      isIkReplay
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useMigrateLedgerEntryMutation() {
  return Urql.useMutation<MigrateLedgerEntryMutation, MigrateLedgerEntryMutationVariables>(MigrateLedgerEntryDocument);
}
export const CreatePaymentDocument = gql`
    mutation CreatePayment($ik: SafeString!, $ledger: LedgerMatchInput!, $payment: CreatePaymentInput!) {
  createPayment(ik: $ik, ledger: $ledger, payment: $payment) {
    __typename
    ... on CreatePaymentResult {
      payment {
        id
        clientSecret
        status
        currency {
          code
          precision
        }
        amount
        mode
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useCreatePaymentMutation() {
  return Urql.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument);
}
export const GetSchemaDocument = gql`
    query GetSchema($key: SafeString!, $version: Int) {
  schema(schema: {key: $key}) {
    key
    name
    version(version: $version) {
      version
      json
      created
    }
    versions(first: 1) {
      nodes {
        version
        json
        created
      }
    }
    ledgers {
      nodes {
        __typename
        ik
        id
        name
      }
    }
  }
}
    `;

export function useGetSchemaQuery(options: Omit<Urql.UseQueryArgs<GetSchemaQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSchemaQuery, GetSchemaQueryVariables>({ query: GetSchemaDocument, ...options });
}
export const GetSchemaVersionsDocument = gql`
    query GetSchemaVersions($key: SafeString!, $first: Int, $after: String) {
  schema(schema: {key: $key}) {
    versions(first: $first, after: $after) {
      nodes {
        version
        created
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    `;

export function useGetSchemaVersionsQuery(options: Omit<Urql.UseQueryArgs<GetSchemaVersionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSchemaVersionsQuery, GetSchemaVersionsQueryVariables>({
    query: GetSchemaVersionsDocument,
    ...options,
  });
}
export const ListSchemasDocument = gql`
    query ListSchemas($first: Int, $after: String) {
  schemas(first: $first, after: $after) {
    nodes {
      __typename
      key
      name
      version {
        version
        created
        json
      }
      ledgers(first: 3) {
        nodes {
          id
          ik
          name
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    `;

export function useListSchemasQuery(options?: Omit<Urql.UseQueryArgs<ListSchemasQueryVariables>, 'query'>) {
  return Urql.useQuery<ListSchemasQuery, ListSchemasQueryVariables>({ query: ListSchemasDocument, ...options });
}
export const ListSchemasWithLedgersDocument = gql`
    query ListSchemasWithLedgers($first: Int) {
  schemas(first: $first) {
    nodes {
      __typename
      key
      versions {
        nodes {
          version
          created
          json
        }
      }
      ledgers {
        nodes {
          ik
          id
          ledgerEntries {
            nodes {
              id
            }
          }
        }
      }
    }
  }
}
    `;

export function useListSchemasWithLedgersQuery(
  options?: Omit<Urql.UseQueryArgs<ListSchemasWithLedgersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListSchemasWithLedgersQuery, ListSchemasWithLedgersQueryVariables>({
    query: ListSchemasWithLedgersDocument,
    ...options,
  });
}
export const StoreSchemaDocument = gql`
    mutation StoreSchema($schema: SchemaInput!) {
  storeSchema(schema: $schema) {
    __typename
    ... on StoreSchemaResult {
      schema {
        key
        version {
          created
          version
          json
        }
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `;

export function useStoreSchemaMutation() {
  return Urql.useMutation<StoreSchemaMutation, StoreSchemaMutationVariables>(StoreSchemaDocument);
}
